/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(18);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.ReactSimpleChatbot=t():e.ReactSimpleChatbot=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="dist/",t(t.s=8)}([function(e,t,n){"use strict";function r(e){return e.replace(C,"-$1").toLowerCase()}function o(e){return k(e).replace(O,"-ms-")}function i(e){return"string"==typeof e}function u(e){return"function"==typeof e&&"string"==typeof e.styledComponentId}function a(e){return e.displayName||e.name||"Component"}function c(e,t){for(var n=1540483477,r=t^e.length,o=e.length,i=0;o>=4;){var u=s(e,i);u=f(u,n),u^=u>>>24,u=f(u,n),r=f(r,n),r^=u,i+=4,o-=4}switch(o){case 3:r^=l(e,i),r^=e.charCodeAt(i+2)<<16,r=f(r,n);break;case 2:r^=l(e,i),r=f(r,n);break;case 1:r^=e.charCodeAt(i),r=f(r,n)}return r^=r>>>13,r=f(r,n),(r^=r>>>15)>>>0}function s(e,t){return e.charCodeAt(t++)+(e.charCodeAt(t++)<<8)+(e.charCodeAt(t++)<<16)+(e.charCodeAt(t)<<24)}function l(e,t){return e.charCodeAt(t++)+(e.charCodeAt(t++)<<8)}function f(e,t){return e|=0,t|=0,(65535&e)*t+(((e>>>16)*t&65535)<<16)|0}Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"css",function(){return R}),n.d(t,"keyframes",function(){return Ee}),n.d(t,"injectGlobal",function(){return Ne}),n.d(t,"ThemeProvider",function(){return me}),n.d(t,"withTheme",function(){return Se}),n.d(t,"ServerStyleSheet",function(){return ue}),n.d(t,"StyleSheetManager",function(){return ne});var p,d=n(25),h=n.n(d),g=n(27),v=n.n(g),y=n(1),b=n.n(y),m=n(2),_=n.n(m),x=n(28),w=n.n(x),j=n(29),M=n.n(j),C=/([A-Z])/g,S=r,k=S,O=/^ms-/,I=o,E=function e(t,n){var r=Object.keys(t).filter(function(e){var n=t[e];return void 0!==n&&null!==n&&!1!==n&&""!==n}).map(function(n){return h()(t[n])?e(t[n],n):I(n)+": "+t[n]+";"}).join(" ");return n?n+" {\n  "+r+"\n}":r},N=function e(t,n){return t.reduce(function(t,r){return void 0===r||null===r||!1===r||""===r?t:Array.isArray(r)?[].concat(t,e(r,n)):r.hasOwnProperty("styledComponentId")?[].concat(t,["."+r.styledComponentId]):"function"==typeof r?n?t.concat.apply(t,e([r(n)],n)):t.concat(r):t.concat(h()(r)?E(r):r.toString())},[])},P=new v.a({global:!1,cascade:!0,keyframe:!1,prefix:!0,compress:!1,semicolon:!0}),T=function(e,t,n){var r=e.join("").replace(/^\s*\/\/.*$/gm,""),o=t&&n?n+" "+t+" { "+r+" }":r;return P(n||!t?"":t,o)},A="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""),z=A.length,L=function(e){var t="",n=void 0;for(n=e;n>z;n=Math.floor(n/z))t=A[n%z]+t;return A[n%z]+t},D=function(e,t){return t.reduce(function(t,n,r){return t.concat(n,e[r+1])},[e[0]])},R=function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return N(D(e,n))},B=/^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//gm,F=function(e){var t=""+(e||""),n=[];return t.replace(B,function(e,t,r){return n.push({componentId:t,matchIndex:r}),e}),n.map(function(e,r){var o=e.componentId,i=e.matchIndex,u=n[r+1];return{componentId:o,cssFromDOM:u?t.slice(i,u.matchIndex):t.slice(i)}})},U=function(){return n.nc},W=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},Z=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),G=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},V=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},q=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n},H=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},Y=function(){function e(t,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";W(this,e),this.el=t,this.isLocal=n,this.ready=!1;var o=F(r);this.size=o.length,this.components=o.reduce(function(e,t){return e[t.componentId]=t,e},{})}return e.prototype.isFull=function(){return this.size>=40},e.prototype.addComponent=function(e){if(this.ready||this.replaceElement(),this.components[e])throw new Error("Trying to add Component '"+e+"' twice!");var t={componentId:e,textNode:document.createTextNode("")};this.el.appendChild(t.textNode),this.size+=1,this.components[e]=t},e.prototype.inject=function(e,t,n){this.ready||this.replaceElement();var r=this.components[e];if(!r)throw new Error("Must add a new component before you can inject css into it");if(""===r.textNode.data&&r.textNode.appendData("\n/* sc-component-id: "+e+" */\n"),r.textNode.appendData(t),n){var o=this.el.getAttribute($);this.el.setAttribute($,o?o+" "+n:n)}var i=U();i&&this.el.setAttribute("nonce",i)},e.prototype.toHTML=function(){return this.el.outerHTML},e.prototype.toReactElement=function(){throw new Error("BrowserTag doesn't implement toReactElement!")},e.prototype.clone=function(){throw new Error("BrowserTag cannot be cloned!")},e.prototype.replaceElement=function(){var e=this;if(this.ready=!0,0!==this.size){var t=this.el.cloneNode();if(t.appendChild(document.createTextNode("\n")),Object.keys(this.components).forEach(function(n){var r=e.components[n];r.textNode=document.createTextNode(r.cssFromDOM),t.appendChild(r.textNode)}),!this.el.parentNode)throw new Error("Trying to replace an element that wasn't mounted!");this.el.parentNode.replaceChild(t,this.el),this.el=t}},e}(),Q={create:function(){for(var e=[],t={},n=document.querySelectorAll("["+$+"]"),r=n.length,o=0;o<r;o+=1){var i=n[o];e.push(new Y(i,"true"===i.getAttribute(J),i.innerHTML));var u=i.getAttribute($);u&&u.trim().split(/\s+/).forEach(function(e){t[e]=!0})}return new te(function(e){var t=document.createElement("style");if(t.type="text/css",t.setAttribute($,""),t.setAttribute(J,e?"true":"false"),!document.head)throw new Error("Missing document <head>");return document.head.appendChild(t),new Y(t,e)},e,t)}},$="data-styled-components",J="data-styled-components-is-local",X="__styled-components-stylesheet__",K=null,ee=[],te=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};W(this,e),this.hashes={},this.deferredInjections={},this.stylesCacheable="undefined"!=typeof document,this.tagConstructor=t,this.tags=n,this.names=r,this.constructComponentTagMap()}return e.prototype.constructComponentTagMap=function(){var e=this;this.componentTags={},this.tags.forEach(function(t){Object.keys(t.components).forEach(function(n){e.componentTags[n]=t})})},e.prototype.getName=function(e){return this.hashes[e.toString()]},e.prototype.alreadyInjected=function(e,t){return!!this.names[t]&&(this.hashes[e.toString()]=t,!0)},e.prototype.hasInjectedComponent=function(e){return!!this.componentTags[e]},e.prototype.deferredInject=function(e,t,n){this===K&&ee.forEach(function(r){r.deferredInject(e,t,n)}),this.getOrCreateTag(e,t),this.deferredInjections[e]=n},e.prototype.inject=function(e,t,n,r,o){this===K&&ee.forEach(function(r){r.inject(e,t,n)});var i=this.getOrCreateTag(e,t),u=this.deferredInjections[e];u&&(i.inject(e,u),delete this.deferredInjections[e]),i.inject(e,n,o),r&&o&&(this.hashes[r.toString()]=o)},e.prototype.toHTML=function(){return this.tags.map(function(e){return e.toHTML()}).join("")},e.prototype.toReactElements=function(){return this.tags.map(function(e,t){return e.toReactElement("sc-"+t)})},e.prototype.getOrCreateTag=function(e,t){var n=this.componentTags[e];if(n)return n;var r=this.tags[this.tags.length-1],o=!r||r.isFull()||r.isLocal!==t?this.createNewTag(t):r;return this.componentTags[e]=o,o.addComponent(e),o},e.prototype.createNewTag=function(e){var t=this.tagConstructor(e);return this.tags.push(t),t},e.reset=function(t){K=e.create(t)},e.create=function(){return((arguments.length>0&&void 0!==arguments[0]?arguments[0]:"undefined"==typeof document)?ue:Q).create()},e.clone=function(t){var n=new e(t.tagConstructor,t.tags.map(function(e){return e.clone()}),G({},t.names));return n.hashes=G({},t.hashes),n.deferredInjections=G({},t.deferredInjections),ee.push(n),n},Z(e,null,[{key:"instance",get:function(){return K||(K=e.create())}}]),e}(),ne=function(e){function t(){return W(this,t),H(this,e.apply(this,arguments))}return V(t,e),t.prototype.getChildContext=function(){var e;return e={},e[X]=this.props.sheet,e},t.prototype.render=function(){return b.a.Children.only(this.props.children)},t}(y.Component);ne.childContextTypes=(p={},p[X]=_.a.oneOfType([_.a.instanceOf(te),_.a.instanceOf(ue)]).isRequired,p),ne.propTypes={sheet:_.a.oneOfType([_.a.instanceOf(te),_.a.instanceOf(ue)]).isRequired};var re,oe,ie=function(){function e(t){W(this,e),this.isLocal=t,this.components={},this.size=0,this.names=[]}return e.prototype.isFull=function(){return!1},e.prototype.addComponent=function(e){if(this.components[e])throw new Error("Trying to add Component '"+e+"' twice!");this.components[e]={componentId:e,css:""},this.size+=1},e.prototype.concatenateCSS=function(){var e=this;return Object.keys(this.components).reduce(function(t,n){return t+e.components[n].css},"")},e.prototype.inject=function(e,t,n){var r=this.components[e];if(!r)throw new Error("Must add a new component before you can inject css into it");""===r.css&&(r.css="/* sc-component-id: "+e+" */\n"),r.css+=t.replace(/\n*$/,"\n"),n&&this.names.push(n)},e.prototype.toHTML=function(){var e=['type="text/css"',$+'="'+this.names.join(" ")+'"',J+'="'+(this.isLocal?"true":"false")+'"'],t=U();return t&&e.push('nonce="'+t+'"'),"<style "+e.join(" ")+">"+this.concatenateCSS()+"</style>"},e.prototype.toReactElement=function(e){var t,n=(t={},t[$]=this.names.join(" "),t[J]=this.isLocal.toString(),t),r=U();return r&&(n.nonce=r),b.a.createElement("style",G({key:e,type:"text/css"},n,{dangerouslySetInnerHTML:{__html:this.concatenateCSS()}}))},e.prototype.clone=function(){var t=this,n=new e(this.isLocal);return n.names=[].concat(this.names),n.size=this.size,n.components=Object.keys(this.components).reduce(function(e,n){return e[n]=G({},t.components[n]),e},{}),n},e}(),ue=function(){function e(){W(this,e),this.instance=te.clone(te.instance)}return e.prototype.collectStyles=function(e){if(this.closed)throw new Error("Can't collect styles once you've called getStyleTags!");return b.a.createElement(ne,{sheet:this.instance},e)},e.prototype.getStyleTags=function(){return this.closed||(ee.splice(ee.indexOf(this.instance),1),this.closed=!0),this.instance.toHTML()},e.prototype.getStyleElement=function(){return this.closed||(ee.splice(ee.indexOf(this.instance),1),this.closed=!0),this.instance.toReactElements()},e.create=function(){return new te(function(e){return new ie(e)})},e}(),ae={children:!0,dangerouslySetInnerHTML:!0,key:!0,ref:!0,autoFocus:!0,defaultValue:!0,valueLink:!0,defaultChecked:!0,checkedLink:!0,innerHTML:!0,suppressContentEditableWarning:!0,onFocusIn:!0,onFocusOut:!0,className:!0,onCopy:!0,onCut:!0,onPaste:!0,onCompositionEnd:!0,onCompositionStart:!0,onCompositionUpdate:!0,onKeyDown:!0,onKeyPress:!0,onKeyUp:!0,onFocus:!0,onBlur:!0,onChange:!0,onInput:!0,onSubmit:!0,onReset:!0,onClick:!0,onContextMenu:!0,onDoubleClick:!0,onDrag:!0,onDragEnd:!0,onDragEnter:!0,onDragExit:!0,onDragLeave:!0,onDragOver:!0,onDragStart:!0,onDrop:!0,onMouseDown:!0,onMouseEnter:!0,onMouseLeave:!0,onMouseMove:!0,onMouseOut:!0,onMouseOver:!0,onMouseUp:!0,onSelect:!0,onTouchCancel:!0,onTouchEnd:!0,onTouchMove:!0,onTouchStart:!0,onScroll:!0,onWheel:!0,onAbort:!0,onCanPlay:!0,onCanPlayThrough:!0,onDurationChange:!0,onEmptied:!0,onEncrypted:!0,onEnded:!0,onError:!0,onLoadedData:!0,onLoadedMetadata:!0,onLoadStart:!0,onPause:!0,onPlay:!0,onPlaying:!0,onProgress:!0,onRateChange:!0,onSeeked:!0,onSeeking:!0,onStalled:!0,onSuspend:!0,onTimeUpdate:!0,onVolumeChange:!0,onWaiting:!0,onLoad:!0,onAnimationStart:!0,onAnimationEnd:!0,onAnimationIteration:!0,onTransitionEnd:!0,onCopyCapture:!0,onCutCapture:!0,onPasteCapture:!0,onCompositionEndCapture:!0,onCompositionStartCapture:!0,onCompositionUpdateCapture:!0,onKeyDownCapture:!0,onKeyPressCapture:!0,onKeyUpCapture:!0,onFocusCapture:!0,onBlurCapture:!0,onChangeCapture:!0,onInputCapture:!0,onSubmitCapture:!0,onResetCapture:!0,onClickCapture:!0,onContextMenuCapture:!0,onDoubleClickCapture:!0,onDragCapture:!0,onDragEndCapture:!0,onDragEnterCapture:!0,onDragExitCapture:!0,onDragLeaveCapture:!0,onDragOverCapture:!0,onDragStartCapture:!0,onDropCapture:!0,onMouseDownCapture:!0,onMouseEnterCapture:!0,onMouseLeaveCapture:!0,onMouseMoveCapture:!0,onMouseOutCapture:!0,onMouseOverCapture:!0,onMouseUpCapture:!0,onSelectCapture:!0,onTouchCancelCapture:!0,onTouchEndCapture:!0,onTouchMoveCapture:!0,onTouchStartCapture:!0,onScrollCapture:!0,onWheelCapture:!0,onAbortCapture:!0,onCanPlayCapture:!0,onCanPlayThroughCapture:!0,onDurationChangeCapture:!0,onEmptiedCapture:!0,onEncryptedCapture:!0,onEndedCapture:!0,onErrorCapture:!0,onLoadedDataCapture:!0,onLoadedMetadataCapture:!0,onLoadStartCapture:!0,onPauseCapture:!0,onPlayCapture:!0,onPlayingCapture:!0,onProgressCapture:!0,onRateChangeCapture:!0,onSeekedCapture:!0,onSeekingCapture:!0,onStalledCapture:!0,onSuspendCapture:!0,onTimeUpdateCapture:!0,onVolumeChangeCapture:!0,onWaitingCapture:!0,onLoadCapture:!0,onAnimationStartCapture:!0,onAnimationEndCapture:!0,onAnimationIterationCapture:!0,onTransitionEndCapture:!0},ce={accept:!0,acceptCharset:!0,accessKey:!0,action:!0,allowFullScreen:!0,allowTransparency:!0,alt:!0,as:!0,async:!0,autoComplete:!0,autoPlay:!0,capture:!0,cellPadding:!0,cellSpacing:!0,charSet:!0,challenge:!0,checked:!0,cite:!0,classID:!0,className:!0,cols:!0,colSpan:!0,content:!0,contentEditable:!0,contextMenu:!0,controls:!0,coords:!0,crossOrigin:!0,data:!0,dateTime:!0,default:!0,defer:!0,dir:!0,disabled:!0,download:!0,draggable:!0,encType:!0,form:!0,formAction:!0,formEncType:!0,formMethod:!0,formNoValidate:!0,formTarget:!0,frameBorder:!0,headers:!0,height:!0,hidden:!0,high:!0,href:!0,hrefLang:!0,htmlFor:!0,httpEquiv:!0,icon:!0,id:!0,inputMode:!0,integrity:!0,is:!0,keyParams:!0,keyType:!0,kind:!0,label:!0,lang:!0,list:!0,loop:!0,low:!0,manifest:!0,marginHeight:!0,marginWidth:!0,max:!0,maxLength:!0,media:!0,mediaGroup:!0,method:!0,min:!0,minLength:!0,multiple:!0,muted:!0,name:!0,nonce:!0,noValidate:!0,open:!0,optimum:!0,pattern:!0,placeholder:!0,playsInline:!0,poster:!0,preload:!0,profile:!0,radioGroup:!0,readOnly:!0,referrerPolicy:!0,rel:!0,required:!0,reversed:!0,role:!0,rows:!0,rowSpan:!0,sandbox:!0,scope:!0,scoped:!0,scrolling:!0,seamless:!0,selected:!0,shape:!0,size:!0,sizes:!0,span:!0,spellCheck:!0,src:!0,srcDoc:!0,srcLang:!0,srcSet:!0,start:!0,step:!0,style:!0,summary:!0,tabIndex:!0,target:!0,title:!0,type:!0,useMap:!0,value:!0,width:!0,wmode:!0,wrap:!0,about:!0,datatype:!0,inlist:!0,prefix:!0,property:!0,resource:!0,typeof:!0,vocab:!0,autoCapitalize:!0,autoCorrect:!0,autoSave:!0,color:!0,itemProp:!0,itemScope:!0,itemType:!0,itemID:!0,itemRef:!0,results:!0,security:!0,unselectable:0},se={accentHeight:!0,accumulate:!0,additive:!0,alignmentBaseline:!0,allowReorder:!0,alphabetic:!0,amplitude:!0,arabicForm:!0,ascent:!0,attributeName:!0,attributeType:!0,autoReverse:!0,azimuth:!0,baseFrequency:!0,baseProfile:!0,baselineShift:!0,bbox:!0,begin:!0,bias:!0,by:!0,calcMode:!0,capHeight:!0,clip:!0,clipPath:!0,clipRule:!0,clipPathUnits:!0,colorInterpolation:!0,colorInterpolationFilters:!0,colorProfile:!0,colorRendering:!0,contentScriptType:!0,contentStyleType:!0,cursor:!0,cx:!0,cy:!0,d:!0,decelerate:!0,descent:!0,diffuseConstant:!0,direction:!0,display:!0,divisor:!0,dominantBaseline:!0,dur:!0,dx:!0,dy:!0,edgeMode:!0,elevation:!0,enableBackground:!0,end:!0,exponent:!0,externalResourcesRequired:!0,fill:!0,fillOpacity:!0,fillRule:!0,filter:!0,filterRes:!0,filterUnits:!0,floodColor:!0,floodOpacity:!0,focusable:!0,fontFamily:!0,fontSize:!0,fontSizeAdjust:!0,fontStretch:!0,fontStyle:!0,fontVariant:!0,fontWeight:!0,format:!0,from:!0,fx:!0,fy:!0,g1:!0,g2:!0,glyphName:!0,glyphOrientationHorizontal:!0,glyphOrientationVertical:!0,glyphRef:!0,gradientTransform:!0,gradientUnits:!0,hanging:!0,horizAdvX:!0,horizOriginX:!0,ideographic:!0,imageRendering:!0,in:!0,in2:!0,intercept:!0,k:!0,k1:!0,k2:!0,k3:!0,k4:!0,kernelMatrix:!0,kernelUnitLength:!0,kerning:!0,keyPoints:!0,keySplines:!0,keyTimes:!0,lengthAdjust:!0,letterSpacing:!0,lightingColor:!0,limitingConeAngle:!0,local:!0,markerEnd:!0,markerMid:!0,markerStart:!0,markerHeight:!0,markerUnits:!0,markerWidth:!0,mask:!0,maskContentUnits:!0,maskUnits:!0,mathematical:!0,mode:!0,numOctaves:!0,offset:!0,opacity:!0,operator:!0,order:!0,orient:!0,orientation:!0,origin:!0,overflow:!0,overlinePosition:!0,overlineThickness:!0,paintOrder:!0,panose1:!0,pathLength:!0,patternContentUnits:!0,patternTransform:!0,patternUnits:!0,pointerEvents:!0,points:!0,pointsAtX:!0,pointsAtY:!0,pointsAtZ:!0,preserveAlpha:!0,preserveAspectRatio:!0,primitiveUnits:!0,r:!0,radius:!0,refX:!0,refY:!0,renderingIntent:!0,repeatCount:!0,repeatDur:!0,requiredExtensions:!0,requiredFeatures:!0,restart:!0,result:!0,rotate:!0,rx:!0,ry:!0,scale:!0,seed:!0,shapeRendering:!0,slope:!0,spacing:!0,specularConstant:!0,specularExponent:!0,speed:!0,spreadMethod:!0,startOffset:!0,stdDeviation:!0,stemh:!0,stemv:!0,stitchTiles:!0,stopColor:!0,stopOpacity:!0,strikethroughPosition:!0,strikethroughThickness:!0,string:!0,stroke:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeLinecap:!0,strokeLinejoin:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0,surfaceScale:!0,systemLanguage:!0,tableValues:!0,targetX:!0,targetY:!0,textAnchor:!0,textDecoration:!0,textRendering:!0,textLength:!0,to:!0,transform:!0,u1:!0,u2:!0,underlinePosition:!0,underlineThickness:!0,unicode:!0,unicodeBidi:!0,unicodeRange:!0,unitsPerEm:!0,vAlphabetic:!0,vHanging:!0,vIdeographic:!0,vMathematical:!0,values:!0,vectorEffect:!0,version:!0,vertAdvY:!0,vertOriginX:!0,vertOriginY:!0,viewBox:!0,viewTarget:!0,visibility:!0,widths:!0,wordSpacing:!0,writingMode:!0,x:!0,xHeight:!0,x1:!0,x2:!0,xChannelSelector:!0,xlinkActuate:!0,xlinkArcrole:!0,xlinkHref:!0,xlinkRole:!0,xlinkShow:!0,xlinkTitle:!0,xlinkType:!0,xmlBase:!0,xmlns:!0,xmlnsXlink:!0,xmlLang:!0,xmlSpace:!0,y:!0,y1:!0,y2:!0,yChannelSelector:!0,z:!0,zoomAndPan:!0},le=RegExp.prototype.test.bind(new RegExp("^(data|aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$")),fe={}.hasOwnProperty,pe=function(e){return fe.call(ce,e)||fe.call(se,e)||le(e.toLowerCase())||fe.call(ae,e)},de=function(e,t,n){var r=n&&e.theme===n.theme;return e.theme&&!r?e.theme:t},he=function(e){function t(e){u=e;for(var t in o){var n=o[t];void 0!==n&&n(u)}}function n(e){var t=i;return o[t]=e,i+=1,e(u),t}function r(e){o[e]=void 0}var o={},i=0,u=e;return{publish:t,subscribe:n,unsubscribe:r}},ge="__styled-components__",ve=ge+"next__",ye=_.a.shape({getTheme:_.a.func,subscribe:_.a.func,unsubscribe:_.a.func}),be=function(e){var t=!1;return function(){t||(t=!0,e())}}(function(){console.error("Warning: Usage of `context."+ge+"` as a function is deprecated. It will be replaced with the object on `.context."+ve+"` in a future version.")}),me=function(e){function t(){W(this,t);var n=H(this,e.call(this));return n.unsubscribeToOuterId=-1,n.getTheme=n.getTheme.bind(n),n}return V(t,e),t.prototype.componentWillMount=function(){var e=this,t=this.context[ve];void 0!==t&&(this.unsubscribeToOuterId=t.subscribe(function(t){e.outerTheme=t})),this.broadcast=he(this.getTheme())},t.prototype.getChildContext=function(){var e,t=this;return G({},this.context,(e={},e[ve]={getTheme:this.getTheme,subscribe:this.broadcast.subscribe,unsubscribe:this.broadcast.unsubscribe},e[ge]=function(e){be();var n=t.broadcast.subscribe(e);return function(){return t.broadcast.unsubscribe(n)}},e))},t.prototype.componentWillReceiveProps=function(e){this.props.theme!==e.theme&&this.broadcast.publish(this.getTheme(e.theme))},t.prototype.componentWillUnmount=function(){-1!==this.unsubscribeToOuterId&&this.context[ve].unsubscribe(this.unsubscribeToOuterId)},t.prototype.getTheme=function(e){var t=e||this.props.theme;if(w()(t)){var n=t(this.outerTheme);if(!h()(n))throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");return n}if(!h()(t))throw new Error("[ThemeProvider] Please make your theme prop a plain object");return G({},this.outerTheme,t)},t.prototype.render=function(){return this.props.children?b.a.Children.only(this.props.children):null},t}(y.Component);me.childContextTypes=(re={},re[ge]=_.a.func,re[ve]=ye,re),me.contextTypes=(oe={},oe[ve]=ye,oe);var _e=/[[\].#*$><+~=|^:(),"'`]/g,xe=/--+/g,we={},je=function e(t,n){for(var r=0;r<t.length;r+=1){var o=t[r];if(Array.isArray(o)&&!e(o))return!1;if("function"==typeof o&&!u(o))return!1}if(void 0!==n)for(var i in n){var a=n[i];if("function"==typeof a)return!1}return!0},Me=["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","g","image","line","linearGradient","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"],Ce=function(e){return e.replace(/\s|\\n/g,"")},Se=function(e){var t,n=e.displayName||e.name||"Component",r=u(e),o=function(t){function n(){var e,r,o;W(this,n);for(var i=arguments.length,u=Array(i),a=0;a<i;a++)u[a]=arguments[a];return e=r=H(this,t.call.apply(t,[this].concat(u))),r.state={},r.unsubscribeId=-1,o=e,H(r,o)}return V(n,t),n.prototype.componentWillMount=function(){var e=this,t=this.constructor.defaultProps,n=this.context[ve],r=de(this.props,void 0,t);if(void 0===n&&void 0!==r)this.setState({theme:r});else{var o=n.subscribe;this.unsubscribeId=o(function(n){var r=de(e.props,n,t);e.setState({theme:r})})}},n.prototype.componentWillReceiveProps=function(e){var t=this.constructor.defaultProps;this.setState(function(n){return{theme:de(e,n.theme,t)}})},n.prototype.componentWillUnmount=function(){-1!==this.unsubscribeId&&this.context[ve].unsubscribe(this.unsubscribeId)},n.prototype.render=function(){var t=this.props.innerRef,n=this.state.theme;return b.a.createElement(e,G({theme:n},this.props,{innerRef:r?t:void 0,ref:r?void 0:t}))},n}(b.a.Component);return o.displayName="WithTheme("+n+")",o.styledComponentId="withTheme",o.contextTypes=(t={},t[ge]=_.a.func,t[ve]=ye,t),M()(o,e)},ke=function(e,t,n){return function(){function r(e,t,n){W(this,r),this.rules=e,this.isStatic=je(e,t),this.componentId=n,te.instance.hasInjectedComponent(this.componentId)||te.instance.deferredInject(n,!0,"")}return r.prototype.generateAndInjectStyles=function(r,o){var i=this.isStatic,u=this.lastClassName;if(i&&void 0!==u)return u;var a=t(this.rules,r),s=c(this.componentId+a.join("")),l=o.getName(s);if(void 0!==l)return o.stylesCacheable&&(this.lastClassName=l),l;var f=e(s);if(o.stylesCacheable&&(this.lastClassName=l),o.alreadyInjected(s,f))return f;var p="\n"+n(a,"."+f);return o.inject(this.componentId,!0,p,s,f),f},r.generateName=function(t){return e(c(t))},r}()}(L,N,T),Oe=function(e){return function t(n,r){var o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if("string"!=typeof r&&"function"!=typeof r)throw new Error("Cannot create styled-component for component: "+r);var i=function(t){for(var i=arguments.length,u=Array(i>1?i-1:0),a=1;a<i;a++)u[a-1]=arguments[a];return n(r,o,e.apply(void 0,[t].concat(u)))};return i.withConfig=function(e){return t(n,r,G({},o,e))},i.attrs=function(e){return t(n,r,G({},o,{attrs:G({},o.attrs||{},e)}))},i}}(R),Ie=function(e,t){var n={},r=function(t,r){var o="string"!=typeof t?"sc":t.replace(_e,"-").replace(xe,"-"),i=(n[o]||0)+1;n[o]=i;var u=e.generateName(o+i),a=o+"-"+u;return void 0!==r?r+"-"+a:a},o=function(e){function t(){var n,r,o;W(this,t);for(var i=arguments.length,u=Array(i),a=0;a<i;a++)u[a]=arguments[a];return n=r=H(this,e.call.apply(e,[this].concat(u))),r.attrs={},r.state={theme:null,generatedClassName:""},r.unsubscribeId=-1,o=n,H(r,o)}return V(t,e),t.prototype.unsubscribeFromContext=function(){-1!==this.unsubscribeId&&this.context[ve].unsubscribe(this.unsubscribeId)},t.prototype.buildExecutionContext=function(e,t){var n=this.constructor.attrs,r=G({},t,{theme:e});return void 0===n?r:(this.attrs=Object.keys(n).reduce(function(e,t){var o=n[t];return e[t]="function"==typeof o?o(r):o,e},{}),G({},r,this.attrs))},t.prototype.generateAndInjectStyles=function(e,t){var n=this.constructor,r=n.attrs,o=n.componentStyle,i=n.warnTooManyClasses,u=this.context[X]||te.instance;if(o.isStatic&&void 0===r)return o.generateAndInjectStyles(we,u);var a=this.buildExecutionContext(e,t),c=o.generateAndInjectStyles(a,u);return void 0!==i&&i(c),c},t.prototype.componentWillMount=function(){var e=this,t=this.constructor.componentStyle,n=this.context[ve];if(t.isStatic){var r=this.generateAndInjectStyles(we,this.props);this.setState({generatedClassName:r})}else if(void 0!==n){var o=n.subscribe;this.unsubscribeId=o(function(t){var n=de(e.props,t,e.constructor.defaultProps),r=e.generateAndInjectStyles(n,e.props);e.setState({theme:n,generatedClassName:r})})}else{var i=this.props.theme||{},u=this.generateAndInjectStyles(i,this.props);this.setState({theme:i,generatedClassName:u})}},t.prototype.componentWillReceiveProps=function(e){var t=this;this.constructor.componentStyle.isStatic||this.setState(function(n){var r=de(e,n.theme,t.constructor.defaultProps);return{theme:r,generatedClassName:t.generateAndInjectStyles(r,e)}})},t.prototype.componentWillUnmount=function(){this.unsubscribeFromContext()},t.prototype.render=function(){var e=this,t=this.props.innerRef,n=this.state.generatedClassName,r=this.constructor,o=r.styledComponentId,a=r.target,c=i(a),s=[this.props.className,o,this.attrs.className,n].filter(Boolean).join(" "),l=G({},this.attrs,{className:s});u(a)?l.innerRef=t:l.ref=t;var f=Object.keys(this.props).reduce(function(t,n){return"innerRef"===n||"className"===n||c&&!pe(n)||(t[n]=e.props[n]),t},l);return Object(y.createElement)(a,f)},t}(y.Component);return function n(u,c,s){var l,f=c.displayName,p=void 0===f?i(u)?"styled."+u:"Styled("+a(u)+")":f,d=c.componentId,h=void 0===d?r(c.displayName,c.parentComponentId):d,g=c.ParentComponent,v=void 0===g?o:g,y=c.rules,b=c.attrs,m=c.displayName&&c.componentId?c.displayName+"-"+c.componentId:h,x=new e(void 0===y?s:y.concat(s),b,m),w=function(e){function r(){return W(this,r),H(this,e.apply(this,arguments))}return V(r,e),r.withComponent=function(e){var t=c.componentId,o=q(c,["componentId"]),u=t&&t+"-"+(i(e)?e:a(e)),l=G({},o,{componentId:u,ParentComponent:r});return n(e,l,s)},Z(r,null,[{key:"extend",get:function(){var e=c.rules,o=c.componentId,i=q(c,["rules","componentId"]),a=void 0===e?s:e.concat(s),l=G({},i,{rules:a,parentComponentId:o,ParentComponent:r});return t(n,u,l)}}]),r}(v);return w.contextTypes=(l={},l[ge]=_.a.func,l[ve]=ye,l[X]=_.a.oneOfType([_.a.instanceOf(te),_.a.instanceOf(ue)]),l),w.displayName=p,w.styledComponentId=m,w.attrs=b,w.componentStyle=x,w.warnTooManyClasses=void 0,w.target=u,w}}(ke,Oe),Ee=function(e,t,n){return function(r){for(var o=arguments.length,i=Array(o>1?o-1:0),u=1;u<o;u++)i[u-1]=arguments[u];var a=n.apply(void 0,[r].concat(i)),s=c(Ce(JSON.stringify(a))),l=te.instance.getName(s);if(l)return l;var f=e(s);if(te.instance.alreadyInjected(s,f))return f;var p=t(a,f,"@keyframes");return te.instance.inject("sc-keyframes-"+f,!0,p,s,f),f}}(L,T,R),Ne=function(e,t){return function(n){for(var r=arguments.length,o=Array(r>1?r-1:0),i=1;i<r;i++)o[i-1]=arguments[i];var u=t.apply(void 0,[n].concat(o)),a=c(JSON.stringify(u)),s="sc-global-"+a;te.instance.hasInjectedComponent(s)||te.instance.inject(s,!1,e(u))}}(T,R),Pe=function(e,t){var n=function(n){return t(e,n)};return Me.forEach(function(e){n[e]=n(e)}),n}(Ie,Oe);t.default=Pe},function(e,t,n){"use strict";e.exports=n(12)},function(e,t,n){e.exports=n(17)()},function(e,t,n){"use strict";function r(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}Object.defineProperty(t,"__esModule",{value:!0}),t.pulse=t.invalidInput=t.scale=t.loading=void 0;var o=r(["\n  0% { opacity: .2; }\n  20% { opacity: 1; }\n  100% { opacity: .2; }\n"],["\n  0% { opacity: .2; }\n  20% { opacity: 1; }\n  100% { opacity: .2; }\n"]),i=r(["\n  100% { transform: scale(1); }\n"],["\n  100% { transform: scale(1); }\n"]),u=r(["\n  25% { transform: rotate(-1deg); }\n  100% { transform: rotate(1deg); }\n"],["\n  25% { transform: rotate(-1deg); }\n  100% { transform: rotate(1deg); }\n"]),a=r(["\n  0% { box-shadow: 0 0 0 0 ","; }\n  70% { box-shadow: 0 0 0 10px ","; }\n  100% { box-shadow: 0 0 0 0 ","; }\n"],["\n  0% { box-shadow: 0 0 0 0 ","; }\n  70% { box-shadow: 0 0 0 10px ","; }\n  100% { box-shadow: 0 0 0 0 ","; }\n"]),c=n(0),s=n(30),l=function(e){return e&&e.__esModule?e:{default:e}}(s),f=(0,c.keyframes)(o),p=(0,c.keyframes)(i),d=(0,c.keyframes)(u),h=function(e){return(0,c.keyframes)(a,(0,l.default)(e,.4),(0,l.default)(e,0),(0,l.default)(e,0))};t.loading=f,t.scale=p,t.invalidInput=d,t.pulse=h},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={background:"#f5f8fb",fontFamily:"monospace",headerBgColor:"#6e48aa",headerFontColor:"#fff",headerFontSize:"16px",botBubbleColor:"#6E48AA",botFontColor:"#fff",userBubbleColor:"#fff",userFontColor:"#4a4a4a"}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),u=n(24),a=r(u),c=function(){return i.default.createElement("span",{className:"rsc-loading"},i.default.createElement(a.default,{delay:"0s"},"."),i.default.createElement(a.default,{delay:".2s"},"."),i.default.createElement(a.default,{delay:".4s"},"."))};t.default=c},function(e,t,n){(function(e,r){var o;(function(){function i(e,t){return e.set(t[0],t[1]),e}function u(e,t){return e.add(t),e}function a(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}function c(e,t,n,r){for(var o=-1,i=null==e?0:e.length;++o<i;){var u=e[o];t(r,u,n(u),e)}return r}function s(e,t){for(var n=-1,r=null==e?0:e.length;++n<r&&!1!==t(e[n],n,e););return e}function l(e,t){for(var n=null==e?0:e.length;n--&&!1!==t(e[n],n,e););return e}function f(e,t){for(var n=-1,r=null==e?0:e.length;++n<r;)if(!t(e[n],n,e))return!1;return!0}function p(e,t){for(var n=-1,r=null==e?0:e.length,o=0,i=[];++n<r;){var u=e[n];t(u,n,e)&&(i[o++]=u)}return i}function d(e,t){return!!(null==e?0:e.length)&&M(e,t,0)>-1}function h(e,t,n){for(var r=-1,o=null==e?0:e.length;++r<o;)if(n(t,e[r]))return!0;return!1}function g(e,t){for(var n=-1,r=null==e?0:e.length,o=Array(r);++n<r;)o[n]=t(e[n],n,e);return o}function v(e,t){for(var n=-1,r=t.length,o=e.length;++n<r;)e[o+n]=t[n];return e}function y(e,t,n,r){var o=-1,i=null==e?0:e.length;for(r&&i&&(n=e[++o]);++o<i;)n=t(n,e[o],o,e);return n}function b(e,t,n,r){var o=null==e?0:e.length;for(r&&o&&(n=e[--o]);o--;)n=t(n,e[o],o,e);return n}function m(e,t){for(var n=-1,r=null==e?0:e.length;++n<r;)if(t(e[n],n,e))return!0;return!1}function _(e){return e.split("")}function x(e){return e.match(Bt)||[]}function w(e,t,n){var r;return n(e,function(e,n,o){if(t(e,n,o))return r=n,!1}),r}function j(e,t,n,r){for(var o=e.length,i=n+(r?1:-1);r?i--:++i<o;)if(t(e[i],i,e))return i;return-1}function M(e,t,n){return t===t?J(e,t,n):j(e,S,n)}function C(e,t,n,r){for(var o=n-1,i=e.length;++o<i;)if(r(e[o],t))return o;return-1}function S(e){return e!==e}function k(e,t){var n=null==e?0:e.length;return n?P(e,t)/n:Ae}function O(e){return function(t){return null==t?oe:t[e]}}function I(e){return function(t){return null==e?oe:e[t]}}function E(e,t,n,r,o){return o(e,function(e,o,i){n=r?(r=!1,e):t(n,e,o,i)}),n}function N(e,t){var n=e.length;for(e.sort(t);n--;)e[n]=e[n].value;return e}function P(e,t){for(var n,r=-1,o=e.length;++r<o;){var i=t(e[r]);i!==oe&&(n=n===oe?i:n+i)}return n}function T(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}function A(e,t){return g(t,function(t){return[t,e[t]]})}function z(e){return function(t){return e(t)}}function L(e,t){return g(t,function(t){return e[t]})}function D(e,t){return e.has(t)}function R(e,t){for(var n=-1,r=e.length;++n<r&&M(t,e[n],0)>-1;);return n}function B(e,t){for(var n=e.length;n--&&M(t,e[n],0)>-1;);return n}function F(e,t){for(var n=e.length,r=0;n--;)e[n]===t&&++r;return r}function U(e){return"\\"+Sn[e]}function W(e,t){return null==e?oe:e[t]}function Z(e){return yn.test(e)}function G(e){return bn.test(e)}function V(e){for(var t,n=[];!(t=e.next()).done;)n.push(t.value);return n}function q(e){var t=-1,n=Array(e.size);return e.forEach(function(e,r){n[++t]=[r,e]}),n}function H(e,t){return function(n){return e(t(n))}}function Y(e,t){for(var n=-1,r=e.length,o=0,i=[];++n<r;){var u=e[n];u!==t&&u!==se||(e[n]=se,i[o++]=n)}return i}function Q(e){var t=-1,n=Array(e.size);return e.forEach(function(e){n[++t]=e}),n}function $(e){var t=-1,n=Array(e.size);return e.forEach(function(e){n[++t]=[e,e]}),n}function J(e,t,n){for(var r=n-1,o=e.length;++r<o;)if(e[r]===t)return r;return-1}function X(e,t,n){for(var r=n+1;r--;)if(e[r]===t)return r;return r}function K(e){return Z(e)?te(e):Zn(e)}function ee(e){return Z(e)?ne(e):_(e)}function te(e){for(var t=gn.lastIndex=0;gn.test(e);)++t;return t}function ne(e){return e.match(gn)||[]}function re(e){return e.match(vn)||[]}var oe,ie=200,ue="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",ae="Expected a function",ce="__lodash_hash_undefined__",se="__lodash_placeholder__",le=1,fe=2,pe=4,de=1,he=2,ge=1,ve=2,ye=4,be=8,me=16,_e=32,xe=64,we=128,je=256,Me=512,Ce=30,Se="...",ke=800,Oe=16,Ie=1,Ee=2,Ne=1/0,Pe=9007199254740991,Te=1.7976931348623157e308,Ae=NaN,ze=4294967295,Le=ze-1,De=ze>>>1,Re=[["ary",we],["bind",ge],["bindKey",ve],["curry",be],["curryRight",me],["flip",Me],["partial",_e],["partialRight",xe],["rearg",je]],Be="[object Arguments]",Fe="[object Array]",Ue="[object AsyncFunction]",We="[object Boolean]",Ze="[object Date]",Ge="[object DOMException]",Ve="[object Error]",qe="[object Function]",He="[object GeneratorFunction]",Ye="[object Map]",Qe="[object Number]",$e="[object Null]",Je="[object Object]",Xe="[object Proxy]",Ke="[object RegExp]",et="[object Set]",tt="[object String]",nt="[object Symbol]",rt="[object Undefined]",ot="[object WeakMap]",it="[object WeakSet]",ut="[object ArrayBuffer]",at="[object DataView]",ct="[object Float32Array]",st="[object Float64Array]",lt="[object Int8Array]",ft="[object Int16Array]",pt="[object Int32Array]",dt="[object Uint8Array]",ht="[object Uint8ClampedArray]",gt="[object Uint16Array]",vt="[object Uint32Array]",yt=/\b__p \+= '';/g,bt=/\b(__p \+=) '' \+/g,mt=/(__e\(.*?\)|\b__t\)) \+\n'';/g,_t=/&(?:amp|lt|gt|quot|#39);/g,xt=/[&<>"']/g,wt=RegExp(_t.source),jt=RegExp(xt.source),Mt=/<%-([\s\S]+?)%>/g,Ct=/<%([\s\S]+?)%>/g,St=/<%=([\s\S]+?)%>/g,kt=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,Ot=/^\w*$/,It=/^\./,Et=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Nt=/[\\^$.*+?()[\]{}|]/g,Pt=RegExp(Nt.source),Tt=/^\s+|\s+$/g,At=/^\s+/,zt=/\s+$/,Lt=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Dt=/\{\n\/\* \[wrapped with (.+)\] \*/,Rt=/,? & /,Bt=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,Ft=/\\(\\)?/g,Ut=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Wt=/\w*$/,Zt=/^[-+]0x[0-9a-f]+$/i,Gt=/^0b[01]+$/i,Vt=/^\[object .+?Constructor\]$/,qt=/^0o[0-7]+$/i,Ht=/^(?:0|[1-9]\d*)$/,Yt=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,Qt=/($^)/,$t=/['\n\r\u2028\u2029\\]/g,Jt="\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",Xt="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",Kt="["+Xt+"]",en="["+Jt+"]",tn="[a-z\\xdf-\\xf6\\xf8-\\xff]",nn="\\ud83c[\\udffb-\\udfff]",rn="(?:\\ud83c[\\udde6-\\uddff]){2}",on="[\\ud800-\\udbff][\\udc00-\\udfff]",un="[A-Z\\xc0-\\xd6\\xd8-\\xde]",an="(?:"+tn+"|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])",cn="(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",sn="(?:\\u200d(?:"+["[^\\ud800-\\udfff]",rn,on].join("|")+")[\\ufe0e\\ufe0f]?"+cn+")*",ln="[\\ufe0e\\ufe0f]?"+cn+sn,fn="(?:"+["[\\u2700-\\u27bf]",rn,on].join("|")+")"+ln,pn="(?:"+["[^\\ud800-\\udfff]"+en+"?",en,rn,on,"[\\ud800-\\udfff]"].join("|")+")",dn=RegExp("['’]","g"),hn=RegExp(en,"g"),gn=RegExp(nn+"(?="+nn+")|"+pn+ln,"g"),vn=RegExp([un+"?"+tn+"+(?:['’](?:d|ll|m|re|s|t|ve))?(?="+[Kt,un,"$"].join("|")+")","(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?="+[Kt,un+an,"$"].join("|")+")",un+"?"+an+"+(?:['’](?:d|ll|m|re|s|t|ve))?",un+"+(?:['’](?:D|LL|M|RE|S|T|VE))?","\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)","\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)","\\d+",fn].join("|"),"g"),yn=RegExp("[\\u200d\\ud800-\\udfff"+Jt+"\\ufe0e\\ufe0f]"),bn=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,mn=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],_n=-1,xn={};xn[ct]=xn[st]=xn[lt]=xn[ft]=xn[pt]=xn[dt]=xn[ht]=xn[gt]=xn[vt]=!0,xn[Be]=xn[Fe]=xn[ut]=xn[We]=xn[at]=xn[Ze]=xn[Ve]=xn[qe]=xn[Ye]=xn[Qe]=xn[Je]=xn[Ke]=xn[et]=xn[tt]=xn[ot]=!1;var wn={};wn[Be]=wn[Fe]=wn[ut]=wn[at]=wn[We]=wn[Ze]=wn[ct]=wn[st]=wn[lt]=wn[ft]=wn[pt]=wn[Ye]=wn[Qe]=wn[Je]=wn[Ke]=wn[et]=wn[tt]=wn[nt]=wn[dt]=wn[ht]=wn[gt]=wn[vt]=!0,wn[Ve]=wn[qe]=wn[ot]=!1;var jn={"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","Ç":"C","ç":"c","Ð":"D","ð":"d","È":"E","É":"E","Ê":"E","Ë":"E","è":"e","é":"e","ê":"e","ë":"e","Ì":"I","Í":"I","Î":"I","Ï":"I","ì":"i","í":"i","î":"i","ï":"i","Ñ":"N","ñ":"n","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","Ù":"U","Ú":"U","Û":"U","Ü":"U","ù":"u","ú":"u","û":"u","ü":"u","Ý":"Y","ý":"y","ÿ":"y","Æ":"Ae","æ":"ae","Þ":"Th","þ":"th","ß":"ss","Ā":"A","Ă":"A","Ą":"A","ā":"a","ă":"a","ą":"a","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","ć":"c","ĉ":"c","ċ":"c","č":"c","Ď":"D","Đ":"D","ď":"d","đ":"d","Ē":"E","Ĕ":"E","Ė":"E","Ę":"E","Ě":"E","ē":"e","ĕ":"e","ė":"e","ę":"e","ě":"e","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","ĝ":"g","ğ":"g","ġ":"g","ģ":"g","Ĥ":"H","Ħ":"H","ĥ":"h","ħ":"h","Ĩ":"I","Ī":"I","Ĭ":"I","Į":"I","İ":"I","ĩ":"i","ī":"i","ĭ":"i","į":"i","ı":"i","Ĵ":"J","ĵ":"j","Ķ":"K","ķ":"k","ĸ":"k","Ĺ":"L","Ļ":"L","Ľ":"L","Ŀ":"L","Ł":"L","ĺ":"l","ļ":"l","ľ":"l","ŀ":"l","ł":"l","Ń":"N","Ņ":"N","Ň":"N","Ŋ":"N","ń":"n","ņ":"n","ň":"n","ŋ":"n","Ō":"O","Ŏ":"O","Ő":"O","ō":"o","ŏ":"o","ő":"o","Ŕ":"R","Ŗ":"R","Ř":"R","ŕ":"r","ŗ":"r","ř":"r","Ś":"S","Ŝ":"S","Ş":"S","Š":"S","ś":"s","ŝ":"s","ş":"s","š":"s","Ţ":"T","Ť":"T","Ŧ":"T","ţ":"t","ť":"t","ŧ":"t","Ũ":"U","Ū":"U","Ŭ":"U","Ů":"U","Ű":"U","Ų":"U","ũ":"u","ū":"u","ŭ":"u","ů":"u","ű":"u","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","Ż":"Z","Ž":"Z","ź":"z","ż":"z","ž":"z","Ĳ":"IJ","ĳ":"ij","Œ":"Oe","œ":"oe","ŉ":"'n","ſ":"s"},Mn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Cn={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Sn={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},kn=parseFloat,On=parseInt,In="object"==typeof e&&e&&e.Object===Object&&e,En="object"==typeof self&&self&&self.Object===Object&&self,Nn=In||En||Function("return this")(),Pn="object"==typeof t&&t&&!t.nodeType&&t,Tn=Pn&&"object"==typeof r&&r&&!r.nodeType&&r,An=Tn&&Tn.exports===Pn,zn=An&&In.process,Ln=function(){try{return zn&&zn.binding&&zn.binding("util")}catch(e){}}(),Dn=Ln&&Ln.isArrayBuffer,Rn=Ln&&Ln.isDate,Bn=Ln&&Ln.isMap,Fn=Ln&&Ln.isRegExp,Un=Ln&&Ln.isSet,Wn=Ln&&Ln.isTypedArray,Zn=O("length"),Gn=I(jn),Vn=I(Mn),qn=I(Cn),Hn=function e(t){function n(e){if(oc(e)&&!vp(e)&&!(e instanceof _)){if(e instanceof o)return e;if(gl.call(e,"__wrapped__"))return tu(e)}return new o(e)}function r(){}function o(e,t){this.__wrapped__=e,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=oe}function _(e){this.__wrapped__=e,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=ze,this.__views__=[]}function I(){var e=new _(this.__wrapped__);return e.__actions__=Do(this.__actions__),e.__dir__=this.__dir__,e.__filtered__=this.__filtered__,e.__iteratees__=Do(this.__iteratees__),e.__takeCount__=this.__takeCount__,e.__views__=Do(this.__views__),e}function J(){if(this.__filtered__){var e=new _(this);e.__dir__=-1,e.__filtered__=!0}else e=this.clone(),e.__dir__*=-1;return e}function te(){var e=this.__wrapped__.value(),t=this.__dir__,n=vp(e),r=t<0,o=n?e.length:0,i=Si(0,o,this.__views__),u=i.start,a=i.end,c=a-u,s=r?a:u-1,l=this.__iteratees__,f=l.length,p=0,d=Vl(c,this.__takeCount__);if(!n||!r&&o==c&&d==c)return bo(e,this.__actions__);var h=[];e:for(;c--&&p<d;){s+=t;for(var g=-1,v=e[s];++g<f;){var y=l[g],b=y.iteratee,m=y.type,_=b(v);if(m==Ee)v=_;else if(!_){if(m==Ie)continue e;break e}}h[p++]=v}return h}function ne(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function Bt(){this.__data__=tf?tf(null):{},this.size=0}function Jt(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t}function Xt(e){var t=this.__data__;if(tf){var n=t[e];return n===ce?oe:n}return gl.call(t,e)?t[e]:oe}function Kt(e){var t=this.__data__;return tf?t[e]!==oe:gl.call(t,e)}function en(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=tf&&t===oe?ce:t,this}function tn(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function nn(){this.__data__=[],this.size=0}function rn(e){var t=this.__data__,n=Qn(t,e);return!(n<0||(n==t.length-1?t.pop():Il.call(t,n,1),--this.size,0))}function on(e){var t=this.__data__,n=Qn(t,e);return n<0?oe:t[n][1]}function un(e){return Qn(this.__data__,e)>-1}function an(e,t){var n=this.__data__,r=Qn(n,e);return r<0?(++this.size,n.push([e,t])):n[r][1]=t,this}function cn(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function sn(){this.size=0,this.__data__={hash:new ne,map:new(Jl||tn),string:new ne}}function ln(e){var t=wi(this,e).delete(e);return this.size-=t?1:0,t}function fn(e){return wi(this,e).get(e)}function pn(e){return wi(this,e).has(e)}function gn(e,t){var n=wi(this,e),r=n.size;return n.set(e,t),this.size+=n.size==r?0:1,this}function vn(e){var t=-1,n=null==e?0:e.length;for(this.__data__=new cn;++t<n;)this.add(e[t])}function yn(e){return this.__data__.set(e,ce),this}function bn(e){return this.__data__.has(e)}function jn(e){var t=this.__data__=new tn(e);this.size=t.size}function Mn(){this.__data__=new tn,this.size=0}function Cn(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n}function Sn(e){return this.__data__.get(e)}function In(e){return this.__data__.has(e)}function En(e,t){var n=this.__data__;if(n instanceof tn){var r=n.__data__;if(!Jl||r.length<ie-1)return r.push([e,t]),this.size=++n.size,this;n=this.__data__=new cn(r)}return n.set(e,t),this.size=n.size,this}function Pn(e,t){var n=vp(e),r=!n&&gp(e),o=!n&&!r&&bp(e),i=!n&&!r&&!o&&jp(e),u=n||r||o||i,a=u?T(e.length,cl):[],c=a.length;for(var s in e)!t&&!gl.call(e,s)||u&&("length"==s||o&&("offset"==s||"parent"==s)||i&&("buffer"==s||"byteLength"==s||"byteOffset"==s)||Ai(s,c))||a.push(s);return a}function Tn(e){var t=e.length;return t?e[Xr(0,t-1)]:oe}function zn(e,t){return Ji(Do(e),tr(t,0,e.length))}function Ln(e){return Ji(Do(e))}function Zn(e,t,n){(n===oe||Ga(e[t],n))&&(n!==oe||t in e)||Kn(e,t,n)}function Yn(e,t,n){var r=e[t];gl.call(e,t)&&Ga(r,n)&&(n!==oe||t in e)||Kn(e,t,n)}function Qn(e,t){for(var n=e.length;n--;)if(Ga(e[n][0],t))return n;return-1}function $n(e,t,n,r){return hf(e,function(e,o,i){t(r,e,n(e),i)}),r}function Jn(e,t){return e&&Ro(t,Bc(t),e)}function Xn(e,t){return e&&Ro(t,Fc(t),e)}function Kn(e,t,n){"__proto__"==t&&Tl?Tl(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n}function er(e,t){for(var n=-1,r=t.length,o=tl(r),i=null==e;++n<r;)o[n]=i?oe:Lc(e,t[n]);return o}function tr(e,t,n){return e===e&&(n!==oe&&(e=e<=n?e:n),t!==oe&&(e=e>=t?e:t)),e}function nr(e,t,n,r,o,i){var u,a=t&le,c=t&fe,l=t&pe;if(n&&(u=o?n(e,r,o,i):n(e)),u!==oe)return u;if(!rc(e))return e;var f=vp(e);if(f){if(u=Ii(e),!a)return Do(e,u)}else{var p=Sf(e),d=p==qe||p==He;if(bp(e))return Co(e,a);if(p==Je||p==Be||d&&!o){if(u=c||d?{}:Ei(e),!a)return c?Fo(e,Xn(u,e)):Bo(e,Jn(u,e))}else{if(!wn[p])return o?e:{};u=Ni(e,p,nr,a)}}i||(i=new jn);var h=i.get(e);if(h)return h;i.set(e,u);var g=l?c?bi:yi:c?Fc:Bc,v=f?oe:g(e);return s(v||e,function(r,o){v&&(o=r,r=e[o]),Yn(u,o,nr(r,t,n,o,e,i))}),u}function rr(e){var t=Bc(e);return function(n){return or(n,e,t)}}function or(e,t,n){var r=n.length;if(null==e)return!r;for(e=ul(e);r--;){var o=n[r],i=t[o],u=e[o];if(u===oe&&!(o in e)||!i(u))return!1}return!0}function ir(e,t,n){if("function"!=typeof e)throw new sl(ae);return If(function(){e.apply(oe,n)},t)}function ur(e,t,n,r){var o=-1,i=d,u=!0,a=e.length,c=[],s=t.length;if(!a)return c;n&&(t=g(t,z(n))),r?(i=h,u=!1):t.length>=ie&&(i=D,u=!1,t=new vn(t));e:for(;++o<a;){var l=e[o],f=null==n?l:n(l);if(l=r||0!==l?l:0,u&&f===f){for(var p=s;p--;)if(t[p]===f)continue e;c.push(l)}else i(t,f,r)||c.push(l)}return c}function ar(e,t){var n=!0;return hf(e,function(e,r,o){return n=!!t(e,r,o)}),n}function cr(e,t,n){for(var r=-1,o=e.length;++r<o;){var i=e[r],u=t(i);if(null!=u&&(a===oe?u===u&&!gc(u):n(u,a)))var a=u,c=i}return c}function sr(e,t,n,r){var o=e.length;for(n=xc(n),n<0&&(n=-n>o?0:o+n),r=r===oe||r>o?o:xc(r),r<0&&(r+=o),r=n>r?0:wc(r);n<r;)e[n++]=t;return e}function lr(e,t){var n=[];return hf(e,function(e,r,o){t(e,r,o)&&n.push(e)}),n}function fr(e,t,n,r,o){var i=-1,u=e.length;for(n||(n=Ti),o||(o=[]);++i<u;){var a=e[i];t>0&&n(a)?t>1?fr(a,t-1,n,r,o):v(o,a):r||(o[o.length]=a)}return o}function pr(e,t){return e&&vf(e,t,Bc)}function dr(e,t){return e&&yf(e,t,Bc)}function hr(e,t){return p(t,function(t){return ec(e[t])})}function gr(e,t){t=jo(t,e);for(var n=0,r=t.length;null!=e&&n<r;)e=e[Xi(t[n++])];return n&&n==r?e:oe}function vr(e,t,n){var r=t(e);return vp(e)?r:v(r,n(e))}function yr(e){return null==e?e===oe?rt:$e:Pl&&Pl in ul(e)?Ci(e):Vi(e)}function br(e,t){return e>t}function mr(e,t){return null!=e&&gl.call(e,t)}function _r(e,t){return null!=e&&t in ul(e)}function xr(e,t,n){return e>=Vl(t,n)&&e<Gl(t,n)}function wr(e,t,n){for(var r=n?h:d,o=e[0].length,i=e.length,u=i,a=tl(i),c=1/0,s=[];u--;){var l=e[u];u&&t&&(l=g(l,z(t))),c=Vl(l.length,c),a[u]=!n&&(t||o>=120&&l.length>=120)?new vn(u&&l):oe}l=e[0];var f=-1,p=a[0];e:for(;++f<o&&s.length<c;){var v=l[f],y=t?t(v):v;if(v=n||0!==v?v:0,!(p?D(p,y):r(s,y,n))){for(u=i;--u;){var b=a[u];if(!(b?D(b,y):r(e[u],y,n)))continue e}p&&p.push(y),s.push(v)}}return s}function jr(e,t,n,r){return pr(e,function(e,o,i){t(r,n(e),o,i)}),r}function Mr(e,t,n){t=jo(t,e),e=Hi(e,t);var r=null==e?e:e[Xi(_u(t))];return null==r?oe:a(r,e,n)}function Cr(e){return oc(e)&&yr(e)==Be}function Sr(e){return oc(e)&&yr(e)==ut}function kr(e){return oc(e)&&yr(e)==Ze}function Or(e,t,n,r,o){return e===t||(null==e||null==t||!oc(e)&&!oc(t)?e!==e&&t!==t:Ir(e,t,n,r,Or,o))}function Ir(e,t,n,r,o,i){var u=vp(e),a=vp(t),c=u?Fe:Sf(e),s=a?Fe:Sf(t);c=c==Be?Je:c,s=s==Be?Je:s;var l=c==Je,f=s==Je,p=c==s;if(p&&bp(e)){if(!bp(t))return!1;u=!0,l=!1}if(p&&!l)return i||(i=new jn),u||jp(e)?di(e,t,n,r,o,i):hi(e,t,c,n,r,o,i);if(!(n&de)){var d=l&&gl.call(e,"__wrapped__"),h=f&&gl.call(t,"__wrapped__");if(d||h){var g=d?e.value():e,v=h?t.value():t;return i||(i=new jn),o(g,v,n,r,i)}}return!!p&&(i||(i=new jn),gi(e,t,n,r,o,i))}function Er(e){return oc(e)&&Sf(e)==Ye}function Nr(e,t,n,r){var o=n.length,i=o,u=!r;if(null==e)return!i;for(e=ul(e);o--;){var a=n[o];if(u&&a[2]?a[1]!==e[a[0]]:!(a[0]in e))return!1}for(;++o<i;){a=n[o];var c=a[0],s=e[c],l=a[1];if(u&&a[2]){if(s===oe&&!(c in e))return!1}else{var f=new jn;if(r)var p=r(s,l,c,e,t,f);if(!(p===oe?Or(l,s,de|he,r,f):p))return!1}}return!0}function Pr(e){return!(!rc(e)||Bi(e))&&(ec(e)?xl:Vt).test(Ki(e))}function Tr(e){return oc(e)&&yr(e)==Ke}function Ar(e){return oc(e)&&Sf(e)==et}function zr(e){return oc(e)&&nc(e.length)&&!!xn[yr(e)]}function Lr(e){return"function"==typeof e?e:null==e?Is:"object"==typeof e?vp(e)?Wr(e[0],e[1]):Ur(e):Ds(e)}function Dr(e){if(!Fi(e))return Zl(e);var t=[];for(var n in ul(e))gl.call(e,n)&&"constructor"!=n&&t.push(n);return t}function Rr(e){if(!rc(e))return Gi(e);var t=Fi(e),n=[];for(var r in e)("constructor"!=r||!t&&gl.call(e,r))&&n.push(r);return n}function Br(e,t){return e<t}function Fr(e,t){var n=-1,r=Va(e)?tl(e.length):[];return hf(e,function(e,o,i){r[++n]=t(e,o,i)}),r}function Ur(e){var t=ji(e);return 1==t.length&&t[0][2]?Wi(t[0][0],t[0][1]):function(n){return n===e||Nr(n,e,t)}}function Wr(e,t){return Li(e)&&Ui(t)?Wi(Xi(e),t):function(n){var r=Lc(n,e);return r===oe&&r===t?Rc(n,e):Or(t,r,de|he)}}function Zr(e,t,n,r,o){e!==t&&vf(t,function(i,u){if(rc(i))o||(o=new jn),Gr(e,t,u,n,Zr,r,o);else{var a=r?r(e[u],i,u+"",e,t,o):oe;a===oe&&(a=i),Zn(e,u,a)}},Fc)}function Gr(e,t,n,r,o,i,u){var a=e[n],c=t[n],s=u.get(c);if(s)return void Zn(e,n,s);var l=i?i(a,c,n+"",e,t,u):oe,f=l===oe;if(f){var p=vp(c),d=!p&&bp(c),h=!p&&!d&&jp(c);l=c,p||d||h?vp(a)?l=a:qa(a)?l=Do(a):d?(f=!1,l=Co(c,!0)):h?(f=!1,l=Po(c,!0)):l=[]:pc(c)||gp(c)?(l=a,gp(a)?l=Mc(a):(!rc(a)||r&&ec(a))&&(l=Ei(c))):f=!1}f&&(u.set(c,l),o(l,c,r,i,u),u.delete(c)),Zn(e,n,l)}function Vr(e,t){var n=e.length;if(n)return t+=t<0?n:0,Ai(t,n)?e[t]:oe}function qr(e,t,n){var r=-1;return t=g(t.length?t:[Is],z(xi())),N(Fr(e,function(e,n,o){return{criteria:g(t,function(t){return t(e)}),index:++r,value:e}}),function(e,t){return Ao(e,t,n)})}function Hr(e,t){return Yr(e,t,function(t,n){return Rc(e,n)})}function Yr(e,t,n){for(var r=-1,o=t.length,i={};++r<o;){var u=t[r],a=gr(e,u);n(a,u)&&oo(i,jo(u,e),a)}return i}function Qr(e){return function(t){return gr(t,e)}}function $r(e,t,n,r){var o=r?C:M,i=-1,u=t.length,a=e;for(e===t&&(t=Do(t)),n&&(a=g(e,z(n)));++i<u;)for(var c=0,s=t[i],l=n?n(s):s;(c=o(a,l,c,r))>-1;)a!==e&&Il.call(a,c,1),Il.call(e,c,1);return e}function Jr(e,t){for(var n=e?t.length:0,r=n-1;n--;){var o=t[n];if(n==r||o!==i){var i=o;Ai(o)?Il.call(e,o,1):go(e,o)}}return e}function Xr(e,t){return e+Rl(Yl()*(t-e+1))}function Kr(e,t,n,r){for(var o=-1,i=Gl(Dl((t-e)/(n||1)),0),u=tl(i);i--;)u[r?i:++o]=e,e+=n;return u}function eo(e,t){var n="";if(!e||t<1||t>Pe)return n;do{t%2&&(n+=e),(t=Rl(t/2))&&(e+=e)}while(t);return n}function to(e,t){return Ef(qi(e,t,Is),e+"")}function no(e){return Tn(Xc(e))}function ro(e,t){var n=Xc(e);return Ji(n,tr(t,0,n.length))}function oo(e,t,n,r){if(!rc(e))return e;t=jo(t,e);for(var o=-1,i=t.length,u=i-1,a=e;null!=a&&++o<i;){var c=Xi(t[o]),s=n;if(o!=u){var l=a[c];(s=r?r(l,c,a):oe)===oe&&(s=rc(l)?l:Ai(t[o+1])?[]:{})}Yn(a,c,s),a=a[c]}return e}function io(e){return Ji(Xc(e))}function uo(e,t,n){var r=-1,o=e.length;t<0&&(t=-t>o?0:o+t),n=n>o?o:n,n<0&&(n+=o),o=t>n?0:n-t>>>0,t>>>=0;for(var i=tl(o);++r<o;)i[r]=e[r+t];return i}function ao(e,t){var n;return hf(e,function(e,r,o){return!(n=t(e,r,o))}),!!n}function co(e,t,n){var r=0,o=null==e?r:e.length;if("number"==typeof t&&t===t&&o<=De){for(;r<o;){var i=r+o>>>1,u=e[i];null!==u&&!gc(u)&&(n?u<=t:u<t)?r=i+1:o=i}return o}return so(e,t,Is,n)}function so(e,t,n,r){t=n(t);for(var o=0,i=null==e?0:e.length,u=t!==t,a=null===t,c=gc(t),s=t===oe;o<i;){var l=Rl((o+i)/2),f=n(e[l]),p=f!==oe,d=null===f,h=f===f,g=gc(f);if(u)var v=r||h;else v=s?h&&(r||p):a?h&&p&&(r||!d):c?h&&p&&!d&&(r||!g):!d&&!g&&(r?f<=t:f<t);v?o=l+1:i=l}return Vl(i,Le)}function lo(e,t){for(var n=-1,r=e.length,o=0,i=[];++n<r;){var u=e[n],a=t?t(u):u;if(!n||!Ga(a,c)){var c=a;i[o++]=0===u?0:u}}return i}function fo(e){return"number"==typeof e?e:gc(e)?Ae:+e}function po(e){if("string"==typeof e)return e;if(vp(e))return g(e,po)+"";if(gc(e))return pf?pf.call(e):"";var t=e+"";return"0"==t&&1/e==-Ne?"-0":t}function ho(e,t,n){var r=-1,o=d,i=e.length,u=!0,a=[],c=a;if(n)u=!1,o=h;else if(i>=ie){var s=t?null:wf(e);if(s)return Q(s);u=!1,o=D,c=new vn}else c=t?[]:a;e:for(;++r<i;){var l=e[r],f=t?t(l):l;if(l=n||0!==l?l:0,u&&f===f){for(var p=c.length;p--;)if(c[p]===f)continue e;t&&c.push(f),a.push(l)}else o(c,f,n)||(c!==a&&c.push(f),a.push(l))}return a}function go(e,t){return t=jo(t,e),null==(e=Hi(e,t))||delete e[Xi(_u(t))]}function vo(e,t,n,r){return oo(e,t,n(gr(e,t)),r)}function yo(e,t,n,r){for(var o=e.length,i=r?o:-1;(r?i--:++i<o)&&t(e[i],i,e););return n?uo(e,r?0:i,r?i+1:o):uo(e,r?i+1:0,r?o:i)}function bo(e,t){var n=e;return n instanceof _&&(n=n.value()),y(t,function(e,t){return t.func.apply(t.thisArg,v([e],t.args))},n)}function mo(e,t,n){var r=e.length;if(r<2)return r?ho(e[0]):[];for(var o=-1,i=tl(r);++o<r;)for(var u=e[o],a=-1;++a<r;)a!=o&&(i[o]=ur(i[o]||u,e[a],t,n));return ho(fr(i,1),t,n)}function _o(e,t,n){for(var r=-1,o=e.length,i=t.length,u={};++r<o;){var a=r<i?t[r]:oe;n(u,e[r],a)}return u}function xo(e){return qa(e)?e:[]}function wo(e){return"function"==typeof e?e:Is}function jo(e,t){return vp(e)?e:Li(e,t)?[e]:Nf(Sc(e))}function Mo(e,t,n){var r=e.length;return n=n===oe?r:n,!t&&n>=r?e:uo(e,t,n)}function Co(e,t){if(t)return e.slice();var n=e.length,r=Cl?Cl(n):new e.constructor(n);return e.copy(r),r}function So(e){var t=new e.constructor(e.byteLength);return new Ml(t).set(new Ml(e)),t}function ko(e,t){var n=t?So(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.byteLength)}function Oo(e,t,n){return y(t?n(q(e),le):q(e),i,new e.constructor)}function Io(e){var t=new e.constructor(e.source,Wt.exec(e));return t.lastIndex=e.lastIndex,t}function Eo(e,t,n){return y(t?n(Q(e),le):Q(e),u,new e.constructor)}function No(e){return ff?ul(ff.call(e)):{}}function Po(e,t){var n=t?So(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.length)}function To(e,t){if(e!==t){var n=e!==oe,r=null===e,o=e===e,i=gc(e),u=t!==oe,a=null===t,c=t===t,s=gc(t);if(!a&&!s&&!i&&e>t||i&&u&&c&&!a&&!s||r&&u&&c||!n&&c||!o)return 1;if(!r&&!i&&!s&&e<t||s&&n&&o&&!r&&!i||a&&n&&o||!u&&o||!c)return-1}return 0}function Ao(e,t,n){for(var r=-1,o=e.criteria,i=t.criteria,u=o.length,a=n.length;++r<u;){var c=To(o[r],i[r]);if(c)return r>=a?c:c*("desc"==n[r]?-1:1)}return e.index-t.index}function zo(e,t,n,r){for(var o=-1,i=e.length,u=n.length,a=-1,c=t.length,s=Gl(i-u,0),l=tl(c+s),f=!r;++a<c;)l[a]=t[a];for(;++o<u;)(f||o<i)&&(l[n[o]]=e[o]);for(;s--;)l[a++]=e[o++];return l}function Lo(e,t,n,r){for(var o=-1,i=e.length,u=-1,a=n.length,c=-1,s=t.length,l=Gl(i-a,0),f=tl(l+s),p=!r;++o<l;)f[o]=e[o];for(var d=o;++c<s;)f[d+c]=t[c];for(;++u<a;)(p||o<i)&&(f[d+n[u]]=e[o++]);return f}function Do(e,t){var n=-1,r=e.length;for(t||(t=tl(r));++n<r;)t[n]=e[n];return t}function Ro(e,t,n,r){var o=!n;n||(n={});for(var i=-1,u=t.length;++i<u;){var a=t[i],c=r?r(n[a],e[a],a,n,e):oe;c===oe&&(c=e[a]),o?Kn(n,a,c):Yn(n,a,c)}return n}function Bo(e,t){return Ro(e,Mf(e),t)}function Fo(e,t){return Ro(e,Cf(e),t)}function Uo(e,t){return function(n,r){var o=vp(n)?c:$n,i=t?t():{};return o(n,e,xi(r,2),i)}}function Wo(e){return to(function(t,n){var r=-1,o=n.length,i=o>1?n[o-1]:oe,u=o>2?n[2]:oe;for(i=e.length>3&&"function"==typeof i?(o--,i):oe,u&&zi(n[0],n[1],u)&&(i=o<3?oe:i,o=1),t=ul(t);++r<o;){var a=n[r];a&&e(t,a,r,i)}return t})}function Zo(e,t){return function(n,r){if(null==n)return n;if(!Va(n))return e(n,r);for(var o=n.length,i=t?o:-1,u=ul(n);(t?i--:++i<o)&&!1!==r(u[i],i,u););return n}}function Go(e){return function(t,n,r){for(var o=-1,i=ul(t),u=r(t),a=u.length;a--;){var c=u[e?a:++o];if(!1===n(i[c],c,i))break}return t}}function Vo(e,t,n){function r(){return(this&&this!==Nn&&this instanceof r?i:e).apply(o?n:this,arguments)}var o=t&ge,i=Yo(e);return r}function qo(e){return function(t){t=Sc(t);var n=Z(t)?ee(t):oe,r=n?n[0]:t.charAt(0),o=n?Mo(n,1).join(""):t.slice(1);return r[e]()+o}}function Ho(e){return function(t){return y(Ms(os(t).replace(dn,"")),e,"")}}function Yo(e){return function(){var t=arguments;switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);case 5:return new e(t[0],t[1],t[2],t[3],t[4]);case 6:return new e(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new e(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var n=df(e.prototype),r=e.apply(n,t);return rc(r)?r:n}}function Qo(e,t,n){function r(){for(var i=arguments.length,u=tl(i),c=i,s=_i(r);c--;)u[c]=arguments[c];var l=i<3&&u[0]!==s&&u[i-1]!==s?[]:Y(u,s);return(i-=l.length)<n?ui(e,t,Xo,r.placeholder,oe,u,l,oe,oe,n-i):a(this&&this!==Nn&&this instanceof r?o:e,this,u)}var o=Yo(e);return r}function $o(e){return function(t,n,r){var o=ul(t);if(!Va(t)){var i=xi(n,3);t=Bc(t),n=function(e){return i(o[e],e,o)}}var u=e(t,n,r);return u>-1?o[i?t[u]:u]:oe}}function Jo(e){return vi(function(t){var n=t.length,r=n,i=o.prototype.thru;for(e&&t.reverse();r--;){var u=t[r];if("function"!=typeof u)throw new sl(ae);if(i&&!a&&"wrapper"==mi(u))var a=new o([],!0)}for(r=a?r:n;++r<n;){u=t[r];var c=mi(u),s="wrapper"==c?jf(u):oe;a=s&&Ri(s[0])&&s[1]==(we|be|_e|je)&&!s[4].length&&1==s[9]?a[mi(s[0])].apply(a,s[3]):1==u.length&&Ri(u)?a[c]():a.thru(u)}return function(){var e=arguments,r=e[0];if(a&&1==e.length&&vp(r))return a.plant(r).value();for(var o=0,i=n?t[o].apply(this,e):r;++o<n;)i=t[o].call(this,i);return i}})}function Xo(e,t,n,r,o,i,u,a,c,s){function l(){for(var y=arguments.length,b=tl(y),m=y;m--;)b[m]=arguments[m];if(h)var _=_i(l),x=F(b,_);if(r&&(b=zo(b,r,o,h)),i&&(b=Lo(b,i,u,h)),y-=x,h&&y<s){var w=Y(b,_);return ui(e,t,Xo,l.placeholder,n,b,w,a,c,s-y)}var j=p?n:this,M=d?j[e]:e;return y=b.length,a?b=Yi(b,a):g&&y>1&&b.reverse(),f&&c<y&&(b.length=c),this&&this!==Nn&&this instanceof l&&(M=v||Yo(M)),M.apply(j,b)}var f=t&we,p=t&ge,d=t&ve,h=t&(be|me),g=t&Me,v=d?oe:Yo(e);return l}function Ko(e,t){return function(n,r){return jr(n,e,t(r),{})}}function ei(e,t){return function(n,r){var o;if(n===oe&&r===oe)return t;if(n!==oe&&(o=n),r!==oe){if(o===oe)return r;"string"==typeof n||"string"==typeof r?(n=po(n),r=po(r)):(n=fo(n),r=fo(r)),o=e(n,r)}return o}}function ti(e){return vi(function(t){return t=g(t,z(xi())),to(function(n){var r=this;return e(t,function(e){return a(e,r,n)})})})}function ni(e,t){t=t===oe?" ":po(t);var n=t.length;if(n<2)return n?eo(t,e):t;var r=eo(t,Dl(e/K(t)));return Z(t)?Mo(ee(r),0,e).join(""):r.slice(0,e)}function ri(e,t,n,r){function o(){for(var t=-1,c=arguments.length,s=-1,l=r.length,f=tl(l+c),p=this&&this!==Nn&&this instanceof o?u:e;++s<l;)f[s]=r[s];for(;c--;)f[s++]=arguments[++t];return a(p,i?n:this,f)}var i=t&ge,u=Yo(e);return o}function oi(e){return function(t,n,r){return r&&"number"!=typeof r&&zi(t,n,r)&&(n=r=oe),t=_c(t),n===oe?(n=t,t=0):n=_c(n),r=r===oe?t<n?1:-1:_c(r),Kr(t,n,r,e)}}function ii(e){return function(t,n){return"string"==typeof t&&"string"==typeof n||(t=jc(t),n=jc(n)),e(t,n)}}function ui(e,t,n,r,o,i,u,a,c,s){var l=t&be,f=l?u:oe,p=l?oe:u,d=l?i:oe,h=l?oe:i;t|=l?_e:xe,(t&=~(l?xe:_e))&ye||(t&=~(ge|ve));var g=[e,t,o,d,f,h,p,a,c,s],v=n.apply(oe,g);return Ri(e)&&Of(v,g),v.placeholder=r,Qi(v,e,t)}function ai(e){var t=il[e];return function(e,n){if(e=jc(e),n=null==n?0:Vl(xc(n),292)){var r=(Sc(e)+"e").split("e");return r=(Sc(t(r[0]+"e"+(+r[1]+n)))+"e").split("e"),+(r[0]+"e"+(+r[1]-n))}return t(e)}}function ci(e){return function(t){var n=Sf(t);return n==Ye?q(t):n==et?$(t):A(t,e(t))}}function si(e,t,n,r,o,i,u,a){var c=t&ve;if(!c&&"function"!=typeof e)throw new sl(ae);var s=r?r.length:0;if(s||(t&=~(_e|xe),r=o=oe),u=u===oe?u:Gl(xc(u),0),a=a===oe?a:xc(a),s-=o?o.length:0,t&xe){var l=r,f=o;r=o=oe}var p=c?oe:jf(e),d=[e,t,n,r,o,l,f,i,u,a];if(p&&Zi(d,p),e=d[0],t=d[1],n=d[2],r=d[3],o=d[4],a=d[9]=d[9]===oe?c?0:e.length:Gl(d[9]-s,0),!a&&t&(be|me)&&(t&=~(be|me)),t&&t!=ge)h=t==be||t==me?Qo(e,t,a):t!=_e&&t!=(ge|_e)||o.length?Xo.apply(oe,d):ri(e,t,n,r);else var h=Vo(e,t,n);return Qi((p?bf:Of)(h,d),e,t)}function li(e,t,n,r){return e===oe||Ga(e,pl[n])&&!gl.call(r,n)?t:e}function fi(e,t,n,r,o,i){return rc(e)&&rc(t)&&(i.set(t,e),Zr(e,t,oe,fi,i),i.delete(t)),e}function pi(e){return pc(e)?oe:e}function di(e,t,n,r,o,i){var u=n&de,a=e.length,c=t.length;if(a!=c&&!(u&&c>a))return!1;var s=i.get(e);if(s&&i.get(t))return s==t;var l=-1,f=!0,p=n&he?new vn:oe;for(i.set(e,t),i.set(t,e);++l<a;){var d=e[l],h=t[l];if(r)var g=u?r(h,d,l,t,e,i):r(d,h,l,e,t,i);if(g!==oe){if(g)continue;f=!1;break}if(p){if(!m(t,function(e,t){if(!D(p,t)&&(d===e||o(d,e,n,r,i)))return p.push(t)})){f=!1;break}}else if(d!==h&&!o(d,h,n,r,i)){f=!1;break}}return i.delete(e),i.delete(t),f}function hi(e,t,n,r,o,i,u){switch(n){case at:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case ut:return!(e.byteLength!=t.byteLength||!i(new Ml(e),new Ml(t)));case We:case Ze:case Qe:return Ga(+e,+t);case Ve:return e.name==t.name&&e.message==t.message;case Ke:case tt:return e==t+"";case Ye:var a=q;case et:var c=r&de;if(a||(a=Q),e.size!=t.size&&!c)return!1;var s=u.get(e);if(s)return s==t;r|=he,u.set(e,t);var l=di(a(e),a(t),r,o,i,u);return u.delete(e),l;case nt:if(ff)return ff.call(e)==ff.call(t)}return!1}function gi(e,t,n,r,o,i){var u=n&de,a=yi(e),c=a.length;if(c!=yi(t).length&&!u)return!1;for(var s=c;s--;){var l=a[s];if(!(u?l in t:gl.call(t,l)))return!1}var f=i.get(e);if(f&&i.get(t))return f==t;var p=!0;i.set(e,t),i.set(t,e);for(var d=u;++s<c;){l=a[s];var h=e[l],g=t[l];if(r)var v=u?r(g,h,l,t,e,i):r(h,g,l,e,t,i);if(!(v===oe?h===g||o(h,g,n,r,i):v)){p=!1;break}d||(d="constructor"==l)}if(p&&!d){var y=e.constructor,b=t.constructor;y!=b&&"constructor"in e&&"constructor"in t&&!("function"==typeof y&&y instanceof y&&"function"==typeof b&&b instanceof b)&&(p=!1)}return i.delete(e),i.delete(t),p}function vi(e){return Ef(qi(e,oe,pu),e+"")}function yi(e){return vr(e,Bc,Mf)}function bi(e){return vr(e,Fc,Cf)}function mi(e){for(var t=e.name+"",n=rf[t],r=gl.call(rf,t)?n.length:0;r--;){var o=n[r],i=o.func;if(null==i||i==e)return o.name}return t}function _i(e){return(gl.call(n,"placeholder")?n:e).placeholder}function xi(){var e=n.iteratee||Es;return e=e===Es?Lr:e,arguments.length?e(arguments[0],arguments[1]):e}function wi(e,t){var n=e.__data__;return Di(t)?n["string"==typeof t?"string":"hash"]:n.map}function ji(e){for(var t=Bc(e),n=t.length;n--;){var r=t[n],o=e[r];t[n]=[r,o,Ui(o)]}return t}function Mi(e,t){var n=W(e,t);return Pr(n)?n:oe}function Ci(e){var t=gl.call(e,Pl),n=e[Pl];try{e[Pl]=oe;var r=!0}catch(e){}var o=bl.call(e);return r&&(t?e[Pl]=n:delete e[Pl]),o}function Si(e,t,n){for(var r=-1,o=n.length;++r<o;){var i=n[r],u=i.size;switch(i.type){case"drop":e+=u;break;case"dropRight":t-=u;break;case"take":t=Vl(t,e+u);break;case"takeRight":e=Gl(e,t-u)}}return{start:e,end:t}}function ki(e){var t=e.match(Dt);return t?t[1].split(Rt):[]}function Oi(e,t,n){t=jo(t,e);for(var r=-1,o=t.length,i=!1;++r<o;){var u=Xi(t[r]);if(!(i=null!=e&&n(e,u)))break;e=e[u]}return i||++r!=o?i:!!(o=null==e?0:e.length)&&nc(o)&&Ai(u,o)&&(vp(e)||gp(e))}function Ii(e){var t=e.length,n=e.constructor(t);return t&&"string"==typeof e[0]&&gl.call(e,"index")&&(n.index=e.index,n.input=e.input),n}function Ei(e){return"function"!=typeof e.constructor||Fi(e)?{}:df(Sl(e))}function Ni(e,t,n,r){var o=e.constructor;switch(t){case ut:return So(e);case We:case Ze:return new o(+e);case at:return ko(e,r);case ct:case st:case lt:case ft:case pt:case dt:case ht:case gt:case vt:return Po(e,r);case Ye:return Oo(e,r,n);case Qe:case tt:return new o(e);case Ke:return Io(e);case et:return Eo(e,r,n);case nt:return No(e)}}function Pi(e,t){var n=t.length;if(!n)return e;var r=n-1;return t[r]=(n>1?"& ":"")+t[r],t=t.join(n>2?", ":" "),e.replace(Lt,"{\n/* [wrapped with "+t+"] */\n")}function Ti(e){return vp(e)||gp(e)||!!(El&&e&&e[El])}function Ai(e,t){return!!(t=null==t?Pe:t)&&("number"==typeof e||Ht.test(e))&&e>-1&&e%1==0&&e<t}function zi(e,t,n){if(!rc(n))return!1;var r=typeof t;return!!("number"==r?Va(n)&&Ai(t,n.length):"string"==r&&t in n)&&Ga(n[t],e)}function Li(e,t){if(vp(e))return!1;var n=typeof e;return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=e&&!gc(e))||Ot.test(e)||!kt.test(e)||null!=t&&e in ul(t)}function Di(e){var t=typeof e;return"string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==e:null===e}function Ri(e){var t=mi(e),r=n[t];if("function"!=typeof r||!(t in _.prototype))return!1;if(e===r)return!0;var o=jf(r);return!!o&&e===o[0]}function Bi(e){return!!yl&&yl in e}function Fi(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||pl)}function Ui(e){return e===e&&!rc(e)}function Wi(e,t){return function(n){return null!=n&&n[e]===t&&(t!==oe||e in ul(n))}}function Zi(e,t){var n=e[1],r=t[1],o=n|r,i=o<(ge|ve|we),u=r==we&&n==be||r==we&&n==je&&e[7].length<=t[8]||r==(we|je)&&t[7].length<=t[8]&&n==be;if(!i&&!u)return e;r&ge&&(e[2]=t[2],o|=n&ge?0:ye);var a=t[3];if(a){var c=e[3];e[3]=c?zo(c,a,t[4]):a,e[4]=c?Y(e[3],se):t[4]}return a=t[5],a&&(c=e[5],e[5]=c?Lo(c,a,t[6]):a,e[6]=c?Y(e[5],se):t[6]),a=t[7],a&&(e[7]=a),r&we&&(e[8]=null==e[8]?t[8]:Vl(e[8],t[8])),null==e[9]&&(e[9]=t[9]),e[0]=t[0],e[1]=o,e}function Gi(e){var t=[];if(null!=e)for(var n in ul(e))t.push(n);return t}function Vi(e){return bl.call(e)}function qi(e,t,n){return t=Gl(t===oe?e.length-1:t,0),function(){for(var r=arguments,o=-1,i=Gl(r.length-t,0),u=tl(i);++o<i;)u[o]=r[t+o];o=-1;for(var c=tl(t+1);++o<t;)c[o]=r[o];return c[t]=n(u),a(e,this,c)}}function Hi(e,t){return t.length<2?e:gr(e,uo(t,0,-1))}function Yi(e,t){for(var n=e.length,r=Vl(t.length,n),o=Do(e);r--;){var i=t[r];e[r]=Ai(i,n)?o[i]:oe}return e}function Qi(e,t,n){var r=t+"";return Ef(e,Pi(r,eu(ki(r),n)))}function $i(e){var t=0,n=0;return function(){var r=ql(),o=Oe-(r-n);if(n=r,o>0){if(++t>=ke)return arguments[0]}else t=0;return e.apply(oe,arguments)}}function Ji(e,t){var n=-1,r=e.length,o=r-1;for(t=t===oe?r:t;++n<t;){var i=Xr(n,o),u=e[i];e[i]=e[n],e[n]=u}return e.length=t,e}function Xi(e){if("string"==typeof e||gc(e))return e;var t=e+"";return"0"==t&&1/e==-Ne?"-0":t}function Ki(e){if(null!=e){try{return hl.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function eu(e,t){return s(Re,function(n){var r="_."+n[0];t&n[1]&&!d(e,r)&&e.push(r)}),e.sort()}function tu(e){if(e instanceof _)return e.clone();var t=new o(e.__wrapped__,e.__chain__);return t.__actions__=Do(e.__actions__),t.__index__=e.__index__,t.__values__=e.__values__,t}function nu(e,t,n){t=(n?zi(e,t,n):t===oe)?1:Gl(xc(t),0);var r=null==e?0:e.length;if(!r||t<1)return[];for(var o=0,i=0,u=tl(Dl(r/t));o<r;)u[i++]=uo(e,o,o+=t);return u}function ru(e){for(var t=-1,n=null==e?0:e.length,r=0,o=[];++t<n;){var i=e[t];i&&(o[r++]=i)}return o}function ou(){var e=arguments.length;if(!e)return[];for(var t=tl(e-1),n=arguments[0],r=e;r--;)t[r-1]=arguments[r];return v(vp(n)?Do(n):[n],fr(t,1))}function iu(e,t,n){var r=null==e?0:e.length;return r?(t=n||t===oe?1:xc(t),uo(e,t<0?0:t,r)):[]}function uu(e,t,n){var r=null==e?0:e.length;return r?(t=n||t===oe?1:xc(t),t=r-t,uo(e,0,t<0?0:t)):[]}function au(e,t){return e&&e.length?yo(e,xi(t,3),!0,!0):[]}function cu(e,t){return e&&e.length?yo(e,xi(t,3),!0):[]}function su(e,t,n,r){var o=null==e?0:e.length;return o?(n&&"number"!=typeof n&&zi(e,t,n)&&(n=0,r=o),sr(e,t,n,r)):[]}function lu(e,t,n){var r=null==e?0:e.length;if(!r)return-1;var o=null==n?0:xc(n);return o<0&&(o=Gl(r+o,0)),j(e,xi(t,3),o)}function fu(e,t,n){var r=null==e?0:e.length;if(!r)return-1;var o=r-1;return n!==oe&&(o=xc(n),o=n<0?Gl(r+o,0):Vl(o,r-1)),j(e,xi(t,3),o,!0)}function pu(e){return(null==e?0:e.length)?fr(e,1):[]}function du(e){return(null==e?0:e.length)?fr(e,Ne):[]}function hu(e,t){return(null==e?0:e.length)?(t=t===oe?1:xc(t),fr(e,t)):[]}function gu(e){for(var t=-1,n=null==e?0:e.length,r={};++t<n;){var o=e[t];r[o[0]]=o[1]}return r}function vu(e){return e&&e.length?e[0]:oe}function yu(e,t,n){var r=null==e?0:e.length;if(!r)return-1;var o=null==n?0:xc(n);return o<0&&(o=Gl(r+o,0)),M(e,t,o)}function bu(e){return(null==e?0:e.length)?uo(e,0,-1):[]}function mu(e,t){return null==e?"":Wl.call(e,t)}function _u(e){var t=null==e?0:e.length;return t?e[t-1]:oe}function xu(e,t,n){var r=null==e?0:e.length;if(!r)return-1;var o=r;return n!==oe&&(o=xc(n),o=o<0?Gl(r+o,0):Vl(o,r-1)),t===t?X(e,t,o):j(e,S,o,!0)}function wu(e,t){return e&&e.length?Vr(e,xc(t)):oe}function ju(e,t){return e&&e.length&&t&&t.length?$r(e,t):e}function Mu(e,t,n){return e&&e.length&&t&&t.length?$r(e,t,xi(n,2)):e}function Cu(e,t,n){return e&&e.length&&t&&t.length?$r(e,t,oe,n):e}function Su(e,t){var n=[];if(!e||!e.length)return n;var r=-1,o=[],i=e.length;for(t=xi(t,3);++r<i;){var u=e[r];t(u,r,e)&&(n.push(u),o.push(r))}return Jr(e,o),n}function ku(e){return null==e?e:Ql.call(e)}function Ou(e,t,n){var r=null==e?0:e.length;return r?(n&&"number"!=typeof n&&zi(e,t,n)?(t=0,n=r):(t=null==t?0:xc(t),n=n===oe?r:xc(n)),uo(e,t,n)):[]}function Iu(e,t){return co(e,t)}function Eu(e,t,n){return so(e,t,xi(n,2))}function Nu(e,t){var n=null==e?0:e.length;if(n){var r=co(e,t);if(r<n&&Ga(e[r],t))return r}return-1}function Pu(e,t){return co(e,t,!0)}function Tu(e,t,n){return so(e,t,xi(n,2),!0)}function Au(e,t){if(null==e?0:e.length){var n=co(e,t,!0)-1;if(Ga(e[n],t))return n}return-1}function zu(e){return e&&e.length?lo(e):[]}function Lu(e,t){return e&&e.length?lo(e,xi(t,2)):[]}function Du(e){var t=null==e?0:e.length;return t?uo(e,1,t):[]}function Ru(e,t,n){return e&&e.length?(t=n||t===oe?1:xc(t),uo(e,0,t<0?0:t)):[]}function Bu(e,t,n){var r=null==e?0:e.length;return r?(t=n||t===oe?1:xc(t),t=r-t,uo(e,t<0?0:t,r)):[]}function Fu(e,t){return e&&e.length?yo(e,xi(t,3),!1,!0):[]}function Uu(e,t){return e&&e.length?yo(e,xi(t,3)):[]}function Wu(e){return e&&e.length?ho(e):[]}function Zu(e,t){return e&&e.length?ho(e,xi(t,2)):[]}function Gu(e,t){return t="function"==typeof t?t:oe,e&&e.length?ho(e,oe,t):[]}function Vu(e){if(!e||!e.length)return[];var t=0;return e=p(e,function(e){if(qa(e))return t=Gl(e.length,t),!0}),T(t,function(t){return g(e,O(t))})}function qu(e,t){if(!e||!e.length)return[];var n=Vu(e);return null==t?n:g(n,function(e){return a(t,oe,e)})}function Hu(e,t){return _o(e||[],t||[],Yn)}function Yu(e,t){return _o(e||[],t||[],oo)}function Qu(e){var t=n(e);return t.__chain__=!0,t}function $u(e,t){return t(e),e}function Ju(e,t){return t(e)}function Xu(){return Qu(this)}function Ku(){return new o(this.value(),this.__chain__)}function ea(){this.__values__===oe&&(this.__values__=mc(this.value()));var e=this.__index__>=this.__values__.length;return{done:e,value:e?oe:this.__values__[this.__index__++]}}function ta(){return this}function na(e){for(var t,n=this;n instanceof r;){var o=tu(n);o.__index__=0,o.__values__=oe,t?i.__wrapped__=o:t=o;var i=o;n=n.__wrapped__}return i.__wrapped__=e,t}function ra(){var e=this.__wrapped__;if(e instanceof _){var t=e;return this.__actions__.length&&(t=new _(this)),t=t.reverse(),t.__actions__.push({func:Ju,args:[ku],thisArg:oe}),new o(t,this.__chain__)}return this.thru(ku)}function oa(){return bo(this.__wrapped__,this.__actions__)}function ia(e,t,n){var r=vp(e)?f:ar;return n&&zi(e,t,n)&&(t=oe),r(e,xi(t,3))}function ua(e,t){return(vp(e)?p:lr)(e,xi(t,3))}function aa(e,t){return fr(da(e,t),1)}function ca(e,t){return fr(da(e,t),Ne)}function sa(e,t,n){return n=n===oe?1:xc(n),fr(da(e,t),n)}function la(e,t){return(vp(e)?s:hf)(e,xi(t,3))}function fa(e,t){return(vp(e)?l:gf)(e,xi(t,3))}function pa(e,t,n,r){e=Va(e)?e:Xc(e),n=n&&!r?xc(n):0;var o=e.length;return n<0&&(n=Gl(o+n,0)),hc(e)?n<=o&&e.indexOf(t,n)>-1:!!o&&M(e,t,n)>-1}function da(e,t){return(vp(e)?g:Fr)(e,xi(t,3))}function ha(e,t,n,r){return null==e?[]:(vp(t)||(t=null==t?[]:[t]),n=r?oe:n,vp(n)||(n=null==n?[]:[n]),qr(e,t,n))}function ga(e,t,n){var r=vp(e)?y:E,o=arguments.length<3;return r(e,xi(t,4),n,o,hf)}function va(e,t,n){var r=vp(e)?b:E,o=arguments.length<3;return r(e,xi(t,4),n,o,gf)}function ya(e,t){return(vp(e)?p:lr)(e,Na(xi(t,3)))}function ba(e){return(vp(e)?Tn:no)(e)}function ma(e,t,n){return t=(n?zi(e,t,n):t===oe)?1:xc(t),(vp(e)?zn:ro)(e,t)}function _a(e){return(vp(e)?Ln:io)(e)}function xa(e){if(null==e)return 0;if(Va(e))return hc(e)?K(e):e.length;var t=Sf(e);return t==Ye||t==et?e.size:Dr(e).length}function wa(e,t,n){var r=vp(e)?m:ao;return n&&zi(e,t,n)&&(t=oe),r(e,xi(t,3))}function ja(e,t){if("function"!=typeof t)throw new sl(ae);return e=xc(e),function(){if(--e<1)return t.apply(this,arguments)}}function Ma(e,t,n){return t=n?oe:t,t=e&&null==t?e.length:t,si(e,we,oe,oe,oe,oe,t)}function Ca(e,t){var n;if("function"!=typeof t)throw new sl(ae);return e=xc(e),function(){return--e>0&&(n=t.apply(this,arguments)),e<=1&&(t=oe),n}}function Sa(e,t,n){t=n?oe:t;var r=si(e,be,oe,oe,oe,oe,oe,t);return r.placeholder=Sa.placeholder,r}function ka(e,t,n){t=n?oe:t;var r=si(e,me,oe,oe,oe,oe,oe,t);return r.placeholder=ka.placeholder,r}function Oa(e,t,n){function r(t){var n=p,r=d;return p=d=oe,b=t,g=e.apply(r,n)}function o(e){return b=e,v=If(a,t),m?r(e):g}function i(e){var n=e-y,r=e-b,o=t-n;return _?Vl(o,h-r):o}function u(e){var n=e-y,r=e-b;return y===oe||n>=t||n<0||_&&r>=h}function a(){var e=op();if(u(e))return c(e);v=If(a,i(e))}function c(e){return v=oe,x&&p?r(e):(p=d=oe,g)}function s(){v!==oe&&xf(v),b=0,p=y=d=v=oe}function l(){return v===oe?g:c(op())}function f(){var e=op(),n=u(e);if(p=arguments,d=this,y=e,n){if(v===oe)return o(y);if(_)return v=If(a,t),r(y)}return v===oe&&(v=If(a,t)),g}var p,d,h,g,v,y,b=0,m=!1,_=!1,x=!0;if("function"!=typeof e)throw new sl(ae);return t=jc(t)||0,rc(n)&&(m=!!n.leading,_="maxWait"in n,h=_?Gl(jc(n.maxWait)||0,t):h,x="trailing"in n?!!n.trailing:x),f.cancel=s,f.flush=l,f}function Ia(e){return si(e,Me)}function Ea(e,t){if("function"!=typeof e||null!=t&&"function"!=typeof t)throw new sl(ae);var n=function(){var r=arguments,o=t?t.apply(this,r):r[0],i=n.cache;if(i.has(o))return i.get(o);var u=e.apply(this,r);return n.cache=i.set(o,u)||i,u};return n.cache=new(Ea.Cache||cn),n}function Na(e){if("function"!=typeof e)throw new sl(ae);return function(){var t=arguments;switch(t.length){case 0:return!e.call(this);case 1:return!e.call(this,t[0]);case 2:return!e.call(this,t[0],t[1]);case 3:return!e.call(this,t[0],t[1],t[2])}return!e.apply(this,t)}}function Pa(e){return Ca(2,e)}function Ta(e,t){if("function"!=typeof e)throw new sl(ae);return t=t===oe?t:xc(t),to(e,t)}function Aa(e,t){if("function"!=typeof e)throw new sl(ae);return t=null==t?0:Gl(xc(t),0),to(function(n){var r=n[t],o=Mo(n,0,t);return r&&v(o,r),a(e,this,o)})}function za(e,t,n){var r=!0,o=!0;if("function"!=typeof e)throw new sl(ae);return rc(n)&&(r="leading"in n?!!n.leading:r,o="trailing"in n?!!n.trailing:o),Oa(e,t,{leading:r,maxWait:t,trailing:o})}function La(e){return Ma(e,1)}function Da(e,t){return lp(wo(t),e)}function Ra(){if(!arguments.length)return[];var e=arguments[0];return vp(e)?e:[e]}function Ba(e){return nr(e,pe)}function Fa(e,t){return t="function"==typeof t?t:oe,nr(e,pe,t)}function Ua(e){return nr(e,le|pe)}function Wa(e,t){return t="function"==typeof t?t:oe,nr(e,le|pe,t)}function Za(e,t){return null==t||or(e,t,Bc(t))}function Ga(e,t){return e===t||e!==e&&t!==t}function Va(e){return null!=e&&nc(e.length)&&!ec(e)}function qa(e){return oc(e)&&Va(e)}function Ha(e){return!0===e||!1===e||oc(e)&&yr(e)==We}function Ya(e){return oc(e)&&1===e.nodeType&&!pc(e)}function Qa(e){if(null==e)return!0;if(Va(e)&&(vp(e)||"string"==typeof e||"function"==typeof e.splice||bp(e)||jp(e)||gp(e)))return!e.length;var t=Sf(e);if(t==Ye||t==et)return!e.size;if(Fi(e))return!Dr(e).length;for(var n in e)if(gl.call(e,n))return!1;return!0}function $a(e,t){return Or(e,t)}function Ja(e,t,n){n="function"==typeof n?n:oe;var r=n?n(e,t):oe;return r===oe?Or(e,t,oe,n):!!r}function Xa(e){if(!oc(e))return!1;var t=yr(e);return t==Ve||t==Ge||"string"==typeof e.message&&"string"==typeof e.name&&!pc(e)}function Ka(e){return"number"==typeof e&&Ul(e)}function ec(e){if(!rc(e))return!1;var t=yr(e);return t==qe||t==He||t==Ue||t==Xe}function tc(e){return"number"==typeof e&&e==xc(e)}function nc(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=Pe}function rc(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}function oc(e){return null!=e&&"object"==typeof e}function ic(e,t){return e===t||Nr(e,t,ji(t))}function uc(e,t,n){return n="function"==typeof n?n:oe,Nr(e,t,ji(t),n)}function ac(e){return fc(e)&&e!=+e}function cc(e){if(kf(e))throw new rl(ue);return Pr(e)}function sc(e){return null===e}function lc(e){return null==e}function fc(e){return"number"==typeof e||oc(e)&&yr(e)==Qe}function pc(e){if(!oc(e)||yr(e)!=Je)return!1;var t=Sl(e);if(null===t)return!0;var n=gl.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&hl.call(n)==ml}function dc(e){return tc(e)&&e>=-Pe&&e<=Pe}function hc(e){return"string"==typeof e||!vp(e)&&oc(e)&&yr(e)==tt}function gc(e){return"symbol"==typeof e||oc(e)&&yr(e)==nt}function vc(e){return e===oe}function yc(e){return oc(e)&&Sf(e)==ot}function bc(e){return oc(e)&&yr(e)==it}function mc(e){if(!e)return[];if(Va(e))return hc(e)?ee(e):Do(e);if(Nl&&e[Nl])return V(e[Nl]());var t=Sf(e);return(t==Ye?q:t==et?Q:Xc)(e)}function _c(e){return e?(e=jc(e))===Ne||e===-Ne?(e<0?-1:1)*Te:e===e?e:0:0===e?e:0}function xc(e){var t=_c(e),n=t%1;return t===t?n?t-n:t:0}function wc(e){return e?tr(xc(e),0,ze):0}function jc(e){if("number"==typeof e)return e;if(gc(e))return Ae;if(rc(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=rc(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(Tt,"");var n=Gt.test(e);return n||qt.test(e)?On(e.slice(2),n?2:8):Zt.test(e)?Ae:+e}function Mc(e){return Ro(e,Fc(e))}function Cc(e){return e?tr(xc(e),-Pe,Pe):0===e?e:0}function Sc(e){return null==e?"":po(e)}function kc(e,t){var n=df(e);return null==t?n:Jn(n,t)}function Oc(e,t){return w(e,xi(t,3),pr)}function Ic(e,t){return w(e,xi(t,3),dr)}function Ec(e,t){return null==e?e:vf(e,xi(t,3),Fc)}function Nc(e,t){return null==e?e:yf(e,xi(t,3),Fc)}function Pc(e,t){return e&&pr(e,xi(t,3))}function Tc(e,t){return e&&dr(e,xi(t,3))}function Ac(e){return null==e?[]:hr(e,Bc(e))}function zc(e){return null==e?[]:hr(e,Fc(e))}function Lc(e,t,n){var r=null==e?oe:gr(e,t);return r===oe?n:r}function Dc(e,t){return null!=e&&Oi(e,t,mr)}function Rc(e,t){return null!=e&&Oi(e,t,_r)}function Bc(e){return Va(e)?Pn(e):Dr(e)}function Fc(e){return Va(e)?Pn(e,!0):Rr(e)}function Uc(e,t){var n={};return t=xi(t,3),pr(e,function(e,r,o){Kn(n,t(e,r,o),e)}),n}function Wc(e,t){var n={};return t=xi(t,3),pr(e,function(e,r,o){Kn(n,r,t(e,r,o))}),n}function Zc(e,t){return Gc(e,Na(xi(t)))}function Gc(e,t){if(null==e)return{};var n=g(bi(e),function(e){return[e]});return t=xi(t),Yr(e,n,function(e,n){return t(e,n[0])})}function Vc(e,t,n){t=jo(t,e);var r=-1,o=t.length;for(o||(o=1,e=oe);++r<o;){var i=null==e?oe:e[Xi(t[r])];i===oe&&(r=o,i=n),e=ec(i)?i.call(e):i}return e}function qc(e,t,n){return null==e?e:oo(e,t,n)}function Hc(e,t,n,r){return r="function"==typeof r?r:oe,null==e?e:oo(e,t,n,r)}function Yc(e,t,n){var r=vp(e),o=r||bp(e)||jp(e);if(t=xi(t,4),null==n){var i=e&&e.constructor;n=o?r?new i:[]:rc(e)&&ec(i)?df(Sl(e)):{}}return(o?s:pr)(e,function(e,r,o){return t(n,e,r,o)}),n}function Qc(e,t){return null==e||go(e,t)}function $c(e,t,n){return null==e?e:vo(e,t,wo(n))}function Jc(e,t,n,r){return r="function"==typeof r?r:oe,null==e?e:vo(e,t,wo(n),r)}function Xc(e){return null==e?[]:L(e,Bc(e))}function Kc(e){return null==e?[]:L(e,Fc(e))}function es(e,t,n){return n===oe&&(n=t,t=oe),n!==oe&&(n=jc(n),n=n===n?n:0),t!==oe&&(t=jc(t),t=t===t?t:0),tr(jc(e),t,n)}function ts(e,t,n){return t=_c(t),n===oe?(n=t,t=0):n=_c(n),e=jc(e),xr(e,t,n)}function ns(e,t,n){if(n&&"boolean"!=typeof n&&zi(e,t,n)&&(t=n=oe),n===oe&&("boolean"==typeof t?(n=t,t=oe):"boolean"==typeof e&&(n=e,e=oe)),e===oe&&t===oe?(e=0,t=1):(e=_c(e),t===oe?(t=e,e=0):t=_c(t)),e>t){var r=e;e=t,t=r}if(n||e%1||t%1){var o=Yl();return Vl(e+o*(t-e+kn("1e-"+((o+"").length-1))),t)}return Xr(e,t)}function rs(e){return Qp(Sc(e).toLowerCase())}function os(e){return(e=Sc(e))&&e.replace(Yt,Gn).replace(hn,"")}function is(e,t,n){e=Sc(e),t=po(t);var r=e.length;n=n===oe?r:tr(xc(n),0,r);var o=n;return(n-=t.length)>=0&&e.slice(n,o)==t}function us(e){return e=Sc(e),e&&jt.test(e)?e.replace(xt,Vn):e}function as(e){return e=Sc(e),e&&Pt.test(e)?e.replace(Nt,"\\$&"):e}function cs(e,t,n){e=Sc(e),t=xc(t);var r=t?K(e):0;if(!t||r>=t)return e;var o=(t-r)/2;return ni(Rl(o),n)+e+ni(Dl(o),n)}function ss(e,t,n){e=Sc(e),t=xc(t);var r=t?K(e):0;return t&&r<t?e+ni(t-r,n):e}function ls(e,t,n){e=Sc(e),t=xc(t);var r=t?K(e):0;return t&&r<t?ni(t-r,n)+e:e}function fs(e,t,n){return n||null==t?t=0:t&&(t=+t),Hl(Sc(e).replace(At,""),t||0)}function ps(e,t,n){return t=(n?zi(e,t,n):t===oe)?1:xc(t),eo(Sc(e),t)}function ds(){var e=arguments,t=Sc(e[0]);return e.length<3?t:t.replace(e[1],e[2])}function hs(e,t,n){return n&&"number"!=typeof n&&zi(e,t,n)&&(t=n=oe),(n=n===oe?ze:n>>>0)?(e=Sc(e),e&&("string"==typeof t||null!=t&&!xp(t))&&!(t=po(t))&&Z(e)?Mo(ee(e),0,n):e.split(t,n)):[]}function gs(e,t,n){return e=Sc(e),n=null==n?0:tr(xc(n),0,e.length),t=po(t),e.slice(n,n+t.length)==t}function vs(e,t,r){var o=n.templateSettings;r&&zi(e,t,r)&&(t=oe),e=Sc(e),t=Op({},t,o,li);var i,u,a=Op({},t.imports,o.imports,li),c=Bc(a),s=L(a,c),l=0,f=t.interpolate||Qt,p="__p += '",d=al((t.escape||Qt).source+"|"+f.source+"|"+(f===St?Ut:Qt).source+"|"+(t.evaluate||Qt).source+"|$","g"),h="//# sourceURL="+("sourceURL"in t?t.sourceURL:"lodash.templateSources["+ ++_n+"]")+"\n";e.replace(d,function(t,n,r,o,a,c){return r||(r=o),p+=e.slice(l,c).replace($t,U),n&&(i=!0,p+="' +\n__e("+n+") +\n'"),a&&(u=!0,p+="';\n"+a+";\n__p += '"),r&&(p+="' +\n((__t = ("+r+")) == null ? '' : __t) +\n'"),l=c+t.length,t}),p+="';\n";var g=t.variable;g||(p="with (obj) {\n"+p+"\n}\n"),p=(u?p.replace(yt,""):p).replace(bt,"$1").replace(mt,"$1;"),p="function("+(g||"obj")+") {\n"+(g?"":"obj || (obj = {});\n")+"var __t, __p = ''"+(i?", __e = _.escape":"")+(u?", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n":";\n")+p+"return __p\n}";var v=$p(function(){return ol(c,h+"return "+p).apply(oe,s)});if(v.source=p,Xa(v))throw v;return v}function ys(e){return Sc(e).toLowerCase()}function bs(e){return Sc(e).toUpperCase()}function ms(e,t,n){if((e=Sc(e))&&(n||t===oe))return e.replace(Tt,"");if(!e||!(t=po(t)))return e;var r=ee(e),o=ee(t);return Mo(r,R(r,o),B(r,o)+1).join("")}function _s(e,t,n){if((e=Sc(e))&&(n||t===oe))return e.replace(zt,"");if(!e||!(t=po(t)))return e;var r=ee(e);return Mo(r,0,B(r,ee(t))+1).join("")}function xs(e,t,n){if((e=Sc(e))&&(n||t===oe))return e.replace(At,"");if(!e||!(t=po(t)))return e;var r=ee(e);return Mo(r,R(r,ee(t))).join("")}function ws(e,t){var n=Ce,r=Se;if(rc(t)){var o="separator"in t?t.separator:o;n="length"in t?xc(t.length):n,r="omission"in t?po(t.omission):r}e=Sc(e);var i=e.length;if(Z(e)){var u=ee(e);i=u.length}if(n>=i)return e;var a=n-K(r);if(a<1)return r;var c=u?Mo(u,0,a).join(""):e.slice(0,a);if(o===oe)return c+r;if(u&&(a+=c.length-a),xp(o)){if(e.slice(a).search(o)){var s,l=c;for(o.global||(o=al(o.source,Sc(Wt.exec(o))+"g")),o.lastIndex=0;s=o.exec(l);)var f=s.index;c=c.slice(0,f===oe?a:f)}}else if(e.indexOf(po(o),a)!=a){var p=c.lastIndexOf(o);p>-1&&(c=c.slice(0,p))}return c+r}function js(e){return e=Sc(e),e&&wt.test(e)?e.replace(_t,qn):e}function Ms(e,t,n){return e=Sc(e),t=n?oe:t,t===oe?G(e)?re(e):x(e):e.match(t)||[]}function Cs(e){var t=null==e?0:e.length,n=xi();return e=t?g(e,function(e){if("function"!=typeof e[1])throw new sl(ae);return[n(e[0]),e[1]]}):[],to(function(n){for(var r=-1;++r<t;){var o=e[r];if(a(o[0],this,n))return a(o[1],this,n)}})}function Ss(e){return rr(nr(e,le))}function ks(e){return function(){return e}}function Os(e,t){return null==e||e!==e?t:e}function Is(e){return e}function Es(e){return Lr("function"==typeof e?e:nr(e,le))}function Ns(e){return Ur(nr(e,le))}function Ps(e,t){return Wr(e,nr(t,le))}function Ts(e,t,n){var r=Bc(t),o=hr(t,r);null!=n||rc(t)&&(o.length||!r.length)||(n=t,t=e,e=this,o=hr(t,Bc(t)));var i=!(rc(n)&&"chain"in n&&!n.chain),u=ec(e);return s(o,function(n){var r=t[n];e[n]=r,u&&(e.prototype[n]=function(){var t=this.__chain__;if(i||t){var n=e(this.__wrapped__);return(n.__actions__=Do(this.__actions__)).push({func:r,args:arguments,thisArg:e}),n.__chain__=t,n}return r.apply(e,v([this.value()],arguments))})}),e}function As(){return Nn._===this&&(Nn._=_l),this}function zs(){}function Ls(e){return e=xc(e),to(function(t){return Vr(t,e)})}function Ds(e){return Li(e)?O(Xi(e)):Qr(e)}function Rs(e){return function(t){return null==e?oe:gr(e,t)}}function Bs(){return[]}function Fs(){return!1}function Us(){return{}}function Ws(){return""}function Zs(){return!0}function Gs(e,t){if((e=xc(e))<1||e>Pe)return[];var n=ze,r=Vl(e,ze);t=xi(t),e-=ze;for(var o=T(r,t);++n<e;)t(n);return o}function Vs(e){return vp(e)?g(e,Xi):gc(e)?[e]:Do(Nf(Sc(e)))}function qs(e){var t=++vl;return Sc(e)+t}function Hs(e){return e&&e.length?cr(e,Is,br):oe}function Ys(e,t){return e&&e.length?cr(e,xi(t,2),br):oe}function Qs(e){return k(e,Is)}function $s(e,t){return k(e,xi(t,2))}function Js(e){return e&&e.length?cr(e,Is,Br):oe}function Xs(e,t){return e&&e.length?cr(e,xi(t,2),Br):oe}function Ks(e){return e&&e.length?P(e,Is):0}function el(e,t){return e&&e.length?P(e,xi(t,2)):0}t=null==t?Nn:Hn.defaults(Nn.Object(),t,Hn.pick(Nn,mn));var tl=t.Array,nl=t.Date,rl=t.Error,ol=t.Function,il=t.Math,ul=t.Object,al=t.RegExp,cl=t.String,sl=t.TypeError,ll=tl.prototype,fl=ol.prototype,pl=ul.prototype,dl=t["__core-js_shared__"],hl=fl.toString,gl=pl.hasOwnProperty,vl=0,yl=function(){var e=/[^.]+$/.exec(dl&&dl.keys&&dl.keys.IE_PROTO||"");return e?"Symbol(src)_1."+e:""}(),bl=pl.toString,ml=hl.call(ul),_l=Nn._,xl=al("^"+hl.call(gl).replace(Nt,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),wl=An?t.Buffer:oe,jl=t.Symbol,Ml=t.Uint8Array,Cl=wl?wl.allocUnsafe:oe,Sl=H(ul.getPrototypeOf,ul),kl=ul.create,Ol=pl.propertyIsEnumerable,Il=ll.splice,El=jl?jl.isConcatSpreadable:oe,Nl=jl?jl.iterator:oe,Pl=jl?jl.toStringTag:oe,Tl=function(){try{var e=Mi(ul,"defineProperty");return e({},"",{}),e}catch(e){}}(),Al=t.clearTimeout!==Nn.clearTimeout&&t.clearTimeout,zl=nl&&nl.now!==Nn.Date.now&&nl.now,Ll=t.setTimeout!==Nn.setTimeout&&t.setTimeout,Dl=il.ceil,Rl=il.floor,Bl=ul.getOwnPropertySymbols,Fl=wl?wl.isBuffer:oe,Ul=t.isFinite,Wl=ll.join,Zl=H(ul.keys,ul),Gl=il.max,Vl=il.min,ql=nl.now,Hl=t.parseInt,Yl=il.random,Ql=ll.reverse,$l=Mi(t,"DataView"),Jl=Mi(t,"Map"),Xl=Mi(t,"Promise"),Kl=Mi(t,"Set"),ef=Mi(t,"WeakMap"),tf=Mi(ul,"create"),nf=ef&&new ef,rf={},of=Ki($l),uf=Ki(Jl),af=Ki(Xl),cf=Ki(Kl),sf=Ki(ef),lf=jl?jl.prototype:oe,ff=lf?lf.valueOf:oe,pf=lf?lf.toString:oe,df=function(){function e(){}return function(t){if(!rc(t))return{};if(kl)return kl(t);e.prototype=t;var n=new e;return e.prototype=oe,n}}();n.templateSettings={escape:Mt,evaluate:Ct,interpolate:St,variable:"",imports:{_:n}},n.prototype=r.prototype,n.prototype.constructor=n,o.prototype=df(r.prototype),o.prototype.constructor=o,_.prototype=df(r.prototype),_.prototype.constructor=_,ne.prototype.clear=Bt,ne.prototype.delete=Jt,ne.prototype.get=Xt,ne.prototype.has=Kt,ne.prototype.set=en,tn.prototype.clear=nn,tn.prototype.delete=rn,tn.prototype.get=on,tn.prototype.has=un,tn.prototype.set=an,cn.prototype.clear=sn,cn.prototype.delete=ln,cn.prototype.get=fn,cn.prototype.has=pn,cn.prototype.set=gn,vn.prototype.add=vn.prototype.push=yn,vn.prototype.has=bn,jn.prototype.clear=Mn,jn.prototype.delete=Cn,jn.prototype.get=Sn,jn.prototype.has=In,jn.prototype.set=En;var hf=Zo(pr),gf=Zo(dr,!0),vf=Go(),yf=Go(!0),bf=nf?function(e,t){return nf.set(e,t),e}:Is,mf=Tl?function(e,t){return Tl(e,"toString",{configurable:!0,enumerable:!1,value:ks(t),writable:!0})}:Is,_f=to,xf=Al||function(e){return Nn.clearTimeout(e)},wf=Kl&&1/Q(new Kl([,-0]))[1]==Ne?function(e){return new Kl(e)}:zs,jf=nf?function(e){return nf.get(e)}:zs,Mf=Bl?function(e){return null==e?[]:(e=ul(e),p(Bl(e),function(t){return Ol.call(e,t)}))}:Bs,Cf=Bl?function(e){for(var t=[];e;)v(t,Mf(e)),e=Sl(e);return t}:Bs,Sf=yr;($l&&Sf(new $l(new ArrayBuffer(1)))!=at||Jl&&Sf(new Jl)!=Ye||Xl&&"[object Promise]"!=Sf(Xl.resolve())||Kl&&Sf(new Kl)!=et||ef&&Sf(new ef)!=ot)&&(Sf=function(e){var t=yr(e),n=t==Je?e.constructor:oe,r=n?Ki(n):"";if(r)switch(r){case of:return at;case uf:return Ye;case af:return"[object Promise]";case cf:return et;case sf:return ot}return t});var kf=dl?ec:Fs,Of=$i(bf),If=Ll||function(e,t){return Nn.setTimeout(e,t)},Ef=$i(mf),Nf=function(e){var t=Ea(e,function(e){return 500===n.size&&n.clear(),e}),n=t.cache;return t}(function(e){var t=[];return It.test(e)&&t.push(""),e.replace(Et,function(e,n,r,o){t.push(r?o.replace(Ft,"$1"):n||e)}),t}),Pf=to(function(e,t){return qa(e)?ur(e,fr(t,1,qa,!0)):[]}),Tf=to(function(e,t){var n=_u(t);return qa(n)&&(n=oe),qa(e)?ur(e,fr(t,1,qa,!0),xi(n,2)):[]}),Af=to(function(e,t){var n=_u(t);return qa(n)&&(n=oe),qa(e)?ur(e,fr(t,1,qa,!0),oe,n):[]}),zf=to(function(e){var t=g(e,xo);return t.length&&t[0]===e[0]?wr(t):[]}),Lf=to(function(e){var t=_u(e),n=g(e,xo);return t===_u(n)?t=oe:n.pop(),n.length&&n[0]===e[0]?wr(n,xi(t,2)):[]}),Df=to(function(e){var t=_u(e),n=g(e,xo);return t="function"==typeof t?t:oe,t&&n.pop(),n.length&&n[0]===e[0]?wr(n,oe,t):[]}),Rf=to(ju),Bf=vi(function(e,t){var n=null==e?0:e.length,r=er(e,t);return Jr(e,g(t,function(e){return Ai(e,n)?+e:e}).sort(To)),r}),Ff=to(function(e){return ho(fr(e,1,qa,!0))}),Uf=to(function(e){var t=_u(e);return qa(t)&&(t=oe),ho(fr(e,1,qa,!0),xi(t,2))}),Wf=to(function(e){var t=_u(e);return t="function"==typeof t?t:oe,ho(fr(e,1,qa,!0),oe,t)}),Zf=to(function(e,t){return qa(e)?ur(e,t):[]}),Gf=to(function(e){return mo(p(e,qa))}),Vf=to(function(e){var t=_u(e);return qa(t)&&(t=oe),mo(p(e,qa),xi(t,2))}),qf=to(function(e){var t=_u(e);return t="function"==typeof t?t:oe,mo(p(e,qa),oe,t)}),Hf=to(Vu),Yf=to(function(e){var t=e.length,n=t>1?e[t-1]:oe;return n="function"==typeof n?(e.pop(),n):oe,qu(e,n)}),Qf=vi(function(e){var t=e.length,n=t?e[0]:0,r=this.__wrapped__,i=function(t){return er(t,e)};return!(t>1||this.__actions__.length)&&r instanceof _&&Ai(n)?(r=r.slice(n,+n+(t?1:0)),r.__actions__.push({func:Ju,args:[i],thisArg:oe}),new o(r,this.__chain__).thru(function(e){return t&&!e.length&&e.push(oe),e})):this.thru(i)}),$f=Uo(function(e,t,n){gl.call(e,n)?++e[n]:Kn(e,n,1)}),Jf=$o(lu),Xf=$o(fu),Kf=Uo(function(e,t,n){gl.call(e,n)?e[n].push(t):Kn(e,n,[t])}),ep=to(function(e,t,n){var r=-1,o="function"==typeof t,i=Va(e)?tl(e.length):[];return hf(e,function(e){i[++r]=o?a(t,e,n):Mr(e,t,n)}),i}),tp=Uo(function(e,t,n){Kn(e,n,t)}),np=Uo(function(e,t,n){e[n?0:1].push(t)},function(){return[[],[]]}),rp=to(function(e,t){if(null==e)return[];var n=t.length;return n>1&&zi(e,t[0],t[1])?t=[]:n>2&&zi(t[0],t[1],t[2])&&(t=[t[0]]),qr(e,fr(t,1),[])}),op=zl||function(){return Nn.Date.now()},ip=to(function(e,t,n){var r=ge;if(n.length){var o=Y(n,_i(ip));r|=_e}return si(e,r,t,n,o)}),up=to(function(e,t,n){var r=ge|ve;if(n.length){var o=Y(n,_i(up));r|=_e}return si(t,r,e,n,o)}),ap=to(function(e,t){return ir(e,1,t)}),cp=to(function(e,t,n){return ir(e,jc(t)||0,n)});Ea.Cache=cn;var sp=_f(function(e,t){t=1==t.length&&vp(t[0])?g(t[0],z(xi())):g(fr(t,1),z(xi()));var n=t.length;return to(function(r){for(var o=-1,i=Vl(r.length,n);++o<i;)r[o]=t[o].call(this,r[o]);return a(e,this,r)})}),lp=to(function(e,t){var n=Y(t,_i(lp));return si(e,_e,oe,t,n)}),fp=to(function(e,t){var n=Y(t,_i(fp));return si(e,xe,oe,t,n)}),pp=vi(function(e,t){return si(e,je,oe,oe,oe,t)}),dp=ii(br),hp=ii(function(e,t){return e>=t}),gp=Cr(function(){return arguments}())?Cr:function(e){return oc(e)&&gl.call(e,"callee")&&!Ol.call(e,"callee")},vp=tl.isArray,yp=Dn?z(Dn):Sr,bp=Fl||Fs,mp=Rn?z(Rn):kr,_p=Bn?z(Bn):Er,xp=Fn?z(Fn):Tr,wp=Un?z(Un):Ar,jp=Wn?z(Wn):zr,Mp=ii(Br),Cp=ii(function(e,t){return e<=t}),Sp=Wo(function(e,t){if(Fi(t)||Va(t))return void Ro(t,Bc(t),e);for(var n in t)gl.call(t,n)&&Yn(e,n,t[n])}),kp=Wo(function(e,t){Ro(t,Fc(t),e)}),Op=Wo(function(e,t,n,r){Ro(t,Fc(t),e,r)}),Ip=Wo(function(e,t,n,r){Ro(t,Bc(t),e,r)}),Ep=vi(er),Np=to(function(e){return e.push(oe,li),a(Op,oe,e)}),Pp=to(function(e){return e.push(oe,fi),a(Dp,oe,e)}),Tp=Ko(function(e,t,n){e[t]=n},ks(Is)),Ap=Ko(function(e,t,n){gl.call(e,t)?e[t].push(n):e[t]=[n]},xi),zp=to(Mr),Lp=Wo(function(e,t,n){Zr(e,t,n)}),Dp=Wo(function(e,t,n,r){Zr(e,t,n,r)}),Rp=vi(function(e,t){var n={};if(null==e)return n;var r=!1;t=g(t,function(t){return t=jo(t,e),r||(r=t.length>1),t}),Ro(e,bi(e),n),r&&(n=nr(n,le|fe|pe,pi));for(var o=t.length;o--;)go(n,t[o]);return n}),Bp=vi(function(e,t){return null==e?{}:Hr(e,t)}),Fp=ci(Bc),Up=ci(Fc),Wp=Ho(function(e,t,n){return t=t.toLowerCase(),e+(n?rs(t):t)}),Zp=Ho(function(e,t,n){return e+(n?"-":"")+t.toLowerCase()}),Gp=Ho(function(e,t,n){return e+(n?" ":"")+t.toLowerCase()}),Vp=qo("toLowerCase"),qp=Ho(function(e,t,n){return e+(n?"_":"")+t.toLowerCase()}),Hp=Ho(function(e,t,n){return e+(n?" ":"")+Qp(t)}),Yp=Ho(function(e,t,n){return e+(n?" ":"")+t.toUpperCase()}),Qp=qo("toUpperCase"),$p=to(function(e,t){try{return a(e,oe,t)}catch(e){return Xa(e)?e:new rl(e)}}),Jp=vi(function(e,t){return s(t,function(t){t=Xi(t),Kn(e,t,ip(e[t],e))}),e}),Xp=Jo(),Kp=Jo(!0),ed=to(function(e,t){return function(n){return Mr(n,e,t)}}),td=to(function(e,t){return function(n){return Mr(e,n,t)}}),nd=ti(g),rd=ti(f),od=ti(m),id=oi(),ud=oi(!0),ad=ei(function(e,t){return e+t},0),cd=ai("ceil"),sd=ei(function(e,t){return e/t},1),ld=ai("floor"),fd=ei(function(e,t){return e*t},1),pd=ai("round"),dd=ei(function(e,t){return e-t},0);return n.after=ja,n.ary=Ma,n.assign=Sp,n.assignIn=kp,n.assignInWith=Op,n.assignWith=Ip,n.at=Ep,n.before=Ca,n.bind=ip,n.bindAll=Jp,n.bindKey=up,n.castArray=Ra,n.chain=Qu,n.chunk=nu,n.compact=ru,n.concat=ou,n.cond=Cs,n.conforms=Ss,n.constant=ks,n.countBy=$f,n.create=kc,n.curry=Sa,n.curryRight=ka,n.debounce=Oa,n.defaults=Np,n.defaultsDeep=Pp,n.defer=ap,n.delay=cp,n.difference=Pf,n.differenceBy=Tf,n.differenceWith=Af,n.drop=iu,n.dropRight=uu,n.dropRightWhile=au,n.dropWhile=cu,n.fill=su,n.filter=ua,n.flatMap=aa,n.flatMapDeep=ca,n.flatMapDepth=sa,n.flatten=pu,n.flattenDeep=du,n.flattenDepth=hu,n.flip=Ia,n.flow=Xp,n.flowRight=Kp,n.fromPairs=gu,n.functions=Ac,n.functionsIn=zc,n.groupBy=Kf,n.initial=bu,n.intersection=zf,n.intersectionBy=Lf,n.intersectionWith=Df,n.invert=Tp,n.invertBy=Ap,n.invokeMap=ep,n.iteratee=Es,n.keyBy=tp,n.keys=Bc,n.keysIn=Fc,n.map=da,n.mapKeys=Uc,n.mapValues=Wc,n.matches=Ns,n.matchesProperty=Ps,n.memoize=Ea,n.merge=Lp,n.mergeWith=Dp,n.method=ed,n.methodOf=td,n.mixin=Ts,n.negate=Na,n.nthArg=Ls,n.omit=Rp,n.omitBy=Zc,n.once=Pa,n.orderBy=ha,n.over=nd,n.overArgs=sp,n.overEvery=rd,n.overSome=od,n.partial=lp,n.partialRight=fp,n.partition=np,n.pick=Bp,n.pickBy=Gc,n.property=Ds,n.propertyOf=Rs,n.pull=Rf,n.pullAll=ju,n.pullAllBy=Mu,n.pullAllWith=Cu,n.pullAt=Bf,n.range=id,n.rangeRight=ud,n.rearg=pp,n.reject=ya,n.remove=Su,n.rest=Ta,n.reverse=ku,n.sampleSize=ma,n.set=qc,n.setWith=Hc,n.shuffle=_a,n.slice=Ou,n.sortBy=rp,n.sortedUniq=zu,n.sortedUniqBy=Lu,n.split=hs,n.spread=Aa,n.tail=Du,n.take=Ru,n.takeRight=Bu,n.takeRightWhile=Fu,n.takeWhile=Uu,n.tap=$u,n.throttle=za,n.thru=Ju,n.toArray=mc,n.toPairs=Fp,n.toPairsIn=Up,n.toPath=Vs,n.toPlainObject=Mc,n.transform=Yc,n.unary=La,n.union=Ff,n.unionBy=Uf,n.unionWith=Wf,n.uniq=Wu,n.uniqBy=Zu,n.uniqWith=Gu,n.unset=Qc,n.unzip=Vu,n.unzipWith=qu,n.update=$c,n.updateWith=Jc,n.values=Xc,n.valuesIn=Kc,n.without=Zf,n.words=Ms,n.wrap=Da,n.xor=Gf,n.xorBy=Vf,n.xorWith=qf,n.zip=Hf,n.zipObject=Hu,n.zipObjectDeep=Yu,n.zipWith=Yf,n.entries=Fp,n.entriesIn=Up,n.extend=kp,n.extendWith=Op,Ts(n,n),n.add=ad,n.attempt=$p,n.camelCase=Wp,n.capitalize=rs,n.ceil=cd,n.clamp=es,n.clone=Ba,n.cloneDeep=Ua,n.cloneDeepWith=Wa,n.cloneWith=Fa,n.conformsTo=Za,n.deburr=os,n.defaultTo=Os,n.divide=sd,n.endsWith=is,n.eq=Ga,n.escape=us,n.escapeRegExp=as,n.every=ia,n.find=Jf,n.findIndex=lu,n.findKey=Oc,n.findLast=Xf,n.findLastIndex=fu,n.findLastKey=Ic,n.floor=ld,n.forEach=la,n.forEachRight=fa,n.forIn=Ec,n.forInRight=Nc,n.forOwn=Pc,n.forOwnRight=Tc,n.get=Lc,n.gt=dp,n.gte=hp,n.has=Dc,n.hasIn=Rc,n.head=vu,n.identity=Is,n.includes=pa,n.indexOf=yu,n.inRange=ts,n.invoke=zp,n.isArguments=gp,n.isArray=vp,n.isArrayBuffer=yp,n.isArrayLike=Va,n.isArrayLikeObject=qa,n.isBoolean=Ha,n.isBuffer=bp,n.isDate=mp,n.isElement=Ya,n.isEmpty=Qa,n.isEqual=$a,n.isEqualWith=Ja,n.isError=Xa,n.isFinite=Ka,n.isFunction=ec,n.isInteger=tc,n.isLength=nc,n.isMap=_p,n.isMatch=ic,n.isMatchWith=uc,n.isNaN=ac,n.isNative=cc,n.isNil=lc,n.isNull=sc,n.isNumber=fc,n.isObject=rc,n.isObjectLike=oc,n.isPlainObject=pc,n.isRegExp=xp,n.isSafeInteger=dc,n.isSet=wp,n.isString=hc,n.isSymbol=gc,n.isTypedArray=jp,n.isUndefined=vc,n.isWeakMap=yc,n.isWeakSet=bc,n.join=mu,n.kebabCase=Zp,n.last=_u,n.lastIndexOf=xu,n.lowerCase=Gp,n.lowerFirst=Vp,n.lt=Mp,n.lte=Cp,n.max=Hs,n.maxBy=Ys,n.mean=Qs,n.meanBy=$s,n.min=Js,n.minBy=Xs,n.stubArray=Bs,n.stubFalse=Fs,n.stubObject=Us,n.stubString=Ws,n.stubTrue=Zs,n.multiply=fd,n.nth=wu,n.noConflict=As,n.noop=zs,n.now=op,n.pad=cs,n.padEnd=ss,n.padStart=ls,n.parseInt=fs,n.random=ns,n.reduce=ga,n.reduceRight=va,n.repeat=ps,n.replace=ds,n.result=Vc,n.round=pd,n.runInContext=e,n.sample=ba,n.size=xa,n.snakeCase=qp,n.some=wa,n.sortedIndex=Iu,n.sortedIndexBy=Eu,n.sortedIndexOf=Nu,n.sortedLastIndex=Pu,n.sortedLastIndexBy=Tu,n.sortedLastIndexOf=Au,n.startCase=Hp,n.startsWith=gs,n.subtract=dd,n.sum=Ks,n.sumBy=el,n.template=vs,n.times=Gs,n.toFinite=_c,n.toInteger=xc,n.toLength=wc,n.toLower=ys,n.toNumber=jc,n.toSafeInteger=Cc,n.toString=Sc,n.toUpper=bs,n.trim=ms,n.trimEnd=_s,n.trimStart=xs,n.truncate=ws,n.unescape=js,n.uniqueId=qs,n.upperCase=Yp,n.upperFirst=Qp,n.each=la,n.eachRight=fa,n.first=vu,Ts(n,function(){var e={};return pr(n,function(t,r){gl.call(n.prototype,r)||(e[r]=t)}),e}(),{chain:!1}),n.VERSION="4.17.4",s(["bind","bindKey","curry","curryRight","partial","partialRight"],function(e){n[e].placeholder=n}),s(["drop","take"],function(e,t){_.prototype[e]=function(n){n=n===oe?1:Gl(xc(n),0);var r=this.__filtered__&&!t?new _(this):this.clone();return r.__filtered__?r.__takeCount__=Vl(n,r.__takeCount__):r.__views__.push({size:Vl(n,ze),type:e+(r.__dir__<0?"Right":"")}),r},_.prototype[e+"Right"]=function(t){return this.reverse()[e](t).reverse()}}),s(["filter","map","takeWhile"],function(e,t){var n=t+1,r=n==Ie||3==n;_.prototype[e]=function(e){var t=this.clone();return t.__iteratees__.push({iteratee:xi(e,3),type:n}),t.__filtered__=t.__filtered__||r,t}}),s(["head","last"],function(e,t){var n="take"+(t?"Right":"");_.prototype[e]=function(){return this[n](1).value()[0]}}),s(["initial","tail"],function(e,t){var n="drop"+(t?"":"Right");_.prototype[e]=function(){return this.__filtered__?new _(this):this[n](1)}}),_.prototype.compact=function(){return this.filter(Is)},_.prototype.find=function(e){return this.filter(e).head()},_.prototype.findLast=function(e){return this.reverse().find(e)},_.prototype.invokeMap=to(function(e,t){return"function"==typeof e?new _(this):this.map(function(n){return Mr(n,e,t)})}),_.prototype.reject=function(e){return this.filter(Na(xi(e)))},_.prototype.slice=function(e,t){e=xc(e);var n=this;return n.__filtered__&&(e>0||t<0)?new _(n):(e<0?n=n.takeRight(-e):e&&(n=n.drop(e)),t!==oe&&(t=xc(t),n=t<0?n.dropRight(-t):n.take(t-e)),n)},_.prototype.takeRightWhile=function(e){return this.reverse().takeWhile(e).reverse()},_.prototype.toArray=function(){return this.take(ze)},pr(_.prototype,function(e,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),i=/^(?:head|last)$/.test(t),u=n[i?"take"+("last"==t?"Right":""):t],a=i||/^find/.test(t);u&&(n.prototype[t]=function(){var t=this.__wrapped__,c=i?[1]:arguments,s=t instanceof _,l=c[0],f=s||vp(t),p=function(e){var t=u.apply(n,v([e],c));return i&&d?t[0]:t};f&&r&&"function"==typeof l&&1!=l.length&&(s=f=!1);var d=this.__chain__,h=!!this.__actions__.length,g=a&&!d,y=s&&!h;if(!a&&f){t=y?t:new _(this);var b=e.apply(t,c);return b.__actions__.push({func:Ju,args:[p],thisArg:oe}),new o(b,d)}return g&&y?e.apply(this,c):(b=this.thru(p),g?i?b.value()[0]:b.value():b)})}),s(["pop","push","shift","sort","splice","unshift"],function(e){var t=ll[e],r=/^(?:push|sort|unshift)$/.test(e)?"tap":"thru",o=/^(?:pop|shift)$/.test(e);n.prototype[e]=function(){var e=arguments;if(o&&!this.__chain__){var n=this.value();return t.apply(vp(n)?n:[],e)}return this[r](function(n){return t.apply(vp(n)?n:[],e)})}}),pr(_.prototype,function(e,t){var r=n[t];if(r){var o=r.name+"";(rf[o]||(rf[o]=[])).push({name:t,func:r})}}),rf[Xo(oe,ve).name]=[{name:"wrapper",func:oe}],_.prototype.clone=I,_.prototype.reverse=J,_.prototype.value=te,n.prototype.at=Qf,n.prototype.chain=Xu,n.prototype.commit=Ku,n.prototype.next=ea,n.prototype.plant=na,n.prototype.reverse=ra,n.prototype.toJSON=n.prototype.valueOf=n.prototype.value=oa,n.prototype.first=n.prototype.head,Nl&&(n.prototype[Nl]=ta),n}();Nn._=Hn,(o=function(){return Hn}.call(t,n,t,r))!==oe&&(r.exports=o)}).call(this)}).call(t,n(10),n(11)(e))},function(e,t){function n(e,t,n){var r,o=[],i=[e],u=[e],a=[n?l:"[Circular]"],c=e,s=1;return function(e,h){return t&&(h=t.call(this,e,h)),""!==e&&(c!==this&&(r=s-v.call(i,this)-1,s-=r,i.splice(s,i.length),o.splice(s-1,o.length),c=this),"object"==typeof h&&h?(v.call(i,h)<0&&i.push(c=h),s=i.length,r=v.call(u,h),r<0?(r=u.push(h)-1,n?(o.push((""+e).replace(d,f)),a[r]=l+o.join(l)):a[r]=a[0]):h=a[r]):"string"==typeof h&&n&&(h=h.replace(f,p).replace(l,f))),h}}function r(e,t){for(var n=0,r=t.length;n<r;e=e[t[n++].replace(h,l)]);return e}function o(e){return function(t,n){var r="string"==typeof n;return r&&n.charAt(0)===l?new y(n.slice(1)):(""===t&&(n=a(n,n,{})),r&&(n=n.replace(g,"$1"+l).replace(p,f)),e?e.call(this,t,n):n)}}function i(e,t,n){for(var r=0,o=t.length;r<o;r++)t[r]=a(e,t[r],n);return t}function u(e,t,n){for(var r in t)t.hasOwnProperty(r)&&(t[r]=a(e,t[r],n));return t}function a(e,t,n){return t instanceof Array?i(e,t,n):t instanceof y?t.length?n.hasOwnProperty(t)?n[t]:n[t]=r(e,t.split(l)):e:t instanceof Object?u(e,t,n):t}function c(e,t,r,o){return JSON.stringify(e,n(e,t,!o),r)}function s(e,t){return JSON.parse(e,o(t))}var l="~",f="\\x"+("0"+l.charCodeAt(0).toString(16)).slice(-2),p="\\"+f,d=new RegExp(f,"g"),h=new RegExp(p,"g"),g=new RegExp("(?:^|([^\\\\]))"+p),v=[].indexOf||function(e){for(var t=this.length;t--&&this[t]!==e;);return t},y=String;this.stringify=c,this.parse=s},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.Loading=void 0;var o=n(9),i=r(o),u=n(5),a=r(u);t.default=i.default,t.Loading=a.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(6),s=r(c),l=n(1),f=r(l),p=n(2),d=r(p),h=n(21),g=r(h),v=n(22),y=n(42),b=r(y),m=n(48),_=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(m),x=n(49),w=r(x),j=n(50),M=r(j),C=n(51),S=r(C),k=n(52),O=r(k),I=n(53),E=r(I),N=n(54),P=r(N),T=n(55),A=r(T),z=n(56),L=r(z),D=n(57),R=r(D),B=n(58),F=r(B),U=n(59),W=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={renderedSteps:[],previousSteps:[],currentStep:{},previousStep:{},steps:{},disabled:!0,opened:e.opened||!e.floating,inputValue:"",inputInvalid:!1,speaking:!1,recognitionEnable:e.recognitionEnable&&F.default.isSupported(),defaultUserSettings:{}},n.renderStep=n.renderStep.bind(n),n.getTriggeredStep=n.getTriggeredStep.bind(n),n.generateRenderedStepsById=n.generateRenderedStepsById.bind(n),n.triggerNextStep=n.triggerNextStep.bind(n),n.onValueChange=n.onValueChange.bind(n),n.onRecognitionChange=n.onRecognitionChange.bind(n),n.onRecognitionEnd=n.onRecognitionEnd.bind(n),n.onRecognitionStop=n.onRecognitionStop.bind(n),n.handleKeyPress=n.handleKeyPress.bind(n),n.handleSubmitButton=n.handleSubmitButton.bind(n),n}return u(t,e),a(t,[{key:"componentWillMount",value:function(){for(var e=this,t=this.props,n=t.botDelay,r=t.botAvatar,o=t.cache,i=t.cacheName,u=t.customDelay,a=t.userAvatar,c=t.userDelay,s={},l={delay:n,avatar:r},f={delay:c,avatar:a},p={delay:u},d=0,h=this.props.steps.length;d<h;d+=1){var g=this.props.steps[d],v={};g.user?v=f:g.message||g.asMessage?v=l:g.component&&(v=p),s[g.id]=Object.assign({},v,b.default.parse(g))}b.default.checkInvalidIds(s);var y=this.props.steps[0];if(y.message){var m=y.message;y.message="function"==typeof m?m():m,s[y.id].message=y.message}var x=_.getData({cacheName:i,cache:o,firstStep:y,steps:s},function(){e.setState({disabled:!1},function(){e.input.focus()})}),w=x.currentStep,j=x.previousStep,M=x.previousSteps,C=x.renderedSteps;this.setState({currentStep:w,defaultUserSettings:f,previousStep:j,previousSteps:M,renderedSteps:C,steps:s})}},{key:"componentDidMount",value:function(){var e=this.state.recognitionEnable,t=this.props.recognitionLang;e&&(this.recognition=new F.default(this.onRecognitionChange,this.onRecognitionEnd,this.onRecognitionStop,t)),this.content.addEventListener("DOMNodeInserted",this.onNodeInserted)}},{key:"componentWillUpdate",value:function(e,t){var n=e.opened;void 0!==n&&n!==t.opened&&this.setState({opened:n})}},{key:"componentWillUnmount",value:function(){this.content.removeEventListener("DOMNodeInserted",this.onNodeInserted)}},{key:"onNodeInserted",value:function(e){e.currentTarget.scrollTop=e.currentTarget.scrollHeight}},{key:"onRecognitionChange",value:function(e){this.setState({inputValue:e})}},{key:"onRecognitionEnd",value:function(){this.setState({speaking:!1}),this.handleSubmitButton()}},{key:"onRecognitionStop",value:function(){this.setState({speaking:!1})}},{key:"onValueChange",value:function(e){this.setState({inputValue:e.target.value})}},{key:"getTriggeredStep",value:function(e,t){var n=this.generateRenderedStepsById();return"function"==typeof e?e({value:t,steps:n}):e}},{key:"getStepMessage",value:function(e){var t=this.state.previousSteps,n=t.length>0?t.length-1:0,r=this.generateRenderedStepsById(),o=t[n].value;return"function"==typeof e?e({previousValue:o,steps:r}):e}},{key:"generateRenderedStepsById",value:function(){for(var e=this.state.previousSteps,t={},n=0,r=e.length;n<r;n+=1){var o=e[n],i=o.id,u=o.message,a=o.value;t[i]={id:i,message:u,value:a}}return t}},{key:"triggerNextStep",value:function(e){var t=this,n=this.state,r=n.defaultUserSettings,o=n.previousSteps,i=n.renderedSteps,u=n.steps,a=this.state,c=a.currentStep,s=a.previousStep,l=c.end;if(e&&e.value&&(c.value=e.value),e&&e.trigger&&(c.trigger=this.getTriggeredStep(e.trigger,e.value)),l)this.handleEnd();else if(c.options&&e){var f=c.options.filter(function(t){return t.value===e.value})[0],p=this.getTriggeredStep(f.trigger,c.value);delete c.options,c=Object.assign({},c,f,r,{user:!0,message:f.label,trigger:p}),i.pop(),o.pop(),i.push(c),o.push(c),this.setState({currentStep:c,renderedSteps:i,previousSteps:o})}else if(c.trigger){c.replace&&i.pop();var d=this.getTriggeredStep(c.trigger,c.value),h=Object.assign({},u[d]);if(h.message)h.message=this.getStepMessage(h.message);else if(h.update){var v=h;if(h=Object.assign({},u[v.update]),h.options)for(var y=0,b=h.options.length;y<b;y+=1)h.options[y].trigger=v.trigger;else h.trigger=v.trigger}h.key=(0,g.default)(24),s=c,c=h,this.setState({renderedSteps:i,currentStep:c,previousStep:s},function(){h.user?t.setState({disabled:!1},function(){t.input.focus()}):(i.push(h),o.push(h),t.setState({renderedSteps:i,previousSteps:o}))})}var m=this.props,x=m.cache,w=m.cacheName;x&&setTimeout(function(){_.setData(w,{currentStep:c,previousStep:s,previousSteps:o,renderedSteps:i})},300)}},{key:"handleEnd",value:function(){if(this.props.handleEnd){for(var e=this.state.previousSteps,t=e.map(function(e){return{id:e.id,message:e.message,value:e.value}}),n=[],r=0,o=e.length;r<o;r+=1){var i=e[r],u=i.id,a=i.message,c=i.value;n[u]={id:u,message:a,value:c}}var s=e.filter(function(e){return e.value}).map(function(e){return e.value});this.props.handleEnd({renderedSteps:t,steps:n,values:s})}}},{key:"isLastPosition",value:function(e){var t=this.state.renderedSteps,n=t.length,r=t.map(function(e){return e.key}).indexOf(e.key);if(n<=1||r+1===n)return!0;var o=t[r+1];return!o.message&&!o.asMessage||e.user!==o.user}},{key:"isFirstPosition",value:function(e){var t=this.state.renderedSteps,n=t.map(function(e){return e.key}).indexOf(e.key);if(0===n)return!0;var r=t[n-1];return!r.message&&!r.asMessage||e.user!==r.user}},{key:"handleKeyPress",value:function(e){"Enter"===e.key&&this.submitUserMessage()}},{key:"handleSubmitButton",value:function(){var e=this.state,t=e.inputValue,n=e.speaking,r=e.recognitionEnable;if((s.default.isEmpty(t)||n)&&r)return this.recognition.speak(),void(n||this.setState({speaking:!0}));this.submitUserMessage()}},{key:"submitUserMessage",value:function(){var e=this.state,t=e.defaultUserSettings,n=e.inputValue,r=e.previousSteps,o=e.renderedSteps,i=this.state.currentStep;if(!i.validator||!this.checkInvalidInput()){var u={message:n,value:n};i=Object.assign({},t,i,u),o.push(i),r.push(i),this.setState({currentStep:i,renderedSteps:o,previousSteps:r,disabled:!0,inputValue:""})}}},{key:"checkInvalidInput",value:function(){var e=this,t=this.state,n=t.currentStep,r=t.inputValue,o=n.validator(r),i=r;return!("boolean"==typeof o&&o||(this.setState({inputValue:o.toString(),inputInvalid:!0,disabled:!0},function(){setTimeout(function(){e.setState({inputValue:i,inputInvalid:!1,disabled:!1},function(){e.input.focus()})},2e3)}),0))}},{key:"toggleChatBot",value:function(e){this.props.toggleFloating?this.props.toggleFloating({opened:e}):this.setState({opened:e})}},{key:"renderStep",value:function(e,t){var n=this.state.renderedSteps,r=this.props,o=r.avatarStyle,i=r.bubbleStyle,u=r.customStyle,a=r.hideBotAvatar,c=r.hideUserAvatar,s=e.options,l=e.component,p=e.asMessage,d=this.generateRenderedStepsById(),h=t>0?n[t-1]:{};return l&&!p?f.default.createElement(v.CustomStep,{key:t,step:e,steps:d,style:u,previousStep:h,triggerNextStep:this.triggerNextStep}):s?f.default.createElement(v.OptionsStep,{key:t,step:e,triggerNextStep:this.triggerNextStep,bubbleStyle:i}):f.default.createElement(v.TextStep,{key:t,step:e,steps:d,previousValue:h.value,triggerNextStep:this.triggerNextStep,avatarStyle:o,bubbleStyle:i,hideBotAvatar:a,hideUserAvatar:c,isFirst:this.isFirstPosition(e),isLast:this.isLastPosition(e)})}},{key:"render",value:function(){var e=this,t=this.state,n=t.disabled,r=t.inputInvalid,o=t.inputValue,i=t.opened,u=t.renderedSteps,a=t.speaking,c=t.recognitionEnable,l=this.props,p=l.className,d=l.contentStyle,h=l.floating,g=l.footerStyle,v=l.headerComponent,y=l.headerTitle,b=l.hideHeader,m=l.hideSubmitButton,_=l.inputStyle,x=l.placeholder,j=l.recognitionPlaceholder,C=l.style,k=l.submitButtonStyle,I=l.width,N=v||f.default.createElement(S.default,{className:"rsc-header"},f.default.createElement(O.default,{className:"rsc-header-title"},y),h&&f.default.createElement(E.default,{className:"rsc-header-close-button",onClick:function(){return e.toggleChatBot(!1)}},f.default.createElement(U.CloseIcon,null))),T=(s.default.isEmpty(o)||a)&&c?f.default.createElement(U.MicIcon,null):f.default.createElement(U.SubmitIcon,null),z=a?j:x;return f.default.createElement("div",{className:"rsc "+p},h&&f.default.createElement(P.default,{className:"rsc-float-button",opened:i,onClick:function(){return e.toggleChatBot(!0)}},f.default.createElement(U.ChatIcon,null)),f.default.createElement(w.default,{className:"rsc-container",floating:h,opened:i,style:C,width:I},!b&&N,f.default.createElement(M.default,{className:"rsc-content",innerRef:function(t){return e.content=t},floating:h,style:d},s.default.map(u,this.renderStep)),f.default.createElement(A.default,{className:"rsc-footer",style:g},f.default.createElement(L.default,{type:"textarea",style:_,innerRef:function(t){return e.input=t},className:"rsc-input",placeholder:r?"":z,onKeyPress:this.handleKeyPress,onChange:this.onValueChange,value:o,floating:h,invalid:r,disabled:n,hasButton:!m}),!m&&f.default.createElement(R.default,{className:"rsc-submit-button",style:k,onClick:this.handleSubmitButton,invalid:r,disabled:n,speaking:a},T))))}}]),t}(l.Component);W.propTypes={avatarStyle:d.default.object,botAvatar:d.default.string,botDelay:d.default.number,bubbleStyle:d.default.object,cache:d.default.bool,cacheName:d.default.string,className:d.default.string,contentStyle:d.default.object,customDelay:d.default.number,customStyle:d.default.object,floating:d.default.bool,footerStyle:d.default.object,handleEnd:d.default.func,headerComponent:d.default.element,headerTitle:d.default.string,hideBotAvatar:d.default.bool,hideHeader:d.default.bool,hideSubmitButton:d.default.bool,hideUserAvatar:d.default.bool,inputStyle:d.default.object,opened:d.default.bool,toggleFloating:d.default.func,placeholder:d.default.string,recognitionEnable:d.default.bool,recognitionLang:d.default.string,recognitionPlaceholder:d.default.string,steps:d.default.array.isRequired,style:d.default.object,submitButtonStyle:d.default.object,userAvatar:d.default.string,userDelay:d.default.number,width:d.default.string},W.defaultProps={avatarStyle:{},botDelay:1e3,bubbleStyle:{},cache:!1,cacheName:"rsc_cache",className:"",contentStyle:{},customStyle:{},customDelay:1e3,floating:!1,footerStyle:{},handleEnd:void 0,headerComponent:void 0,headerTitle:"Chat",hideBotAvatar:!1,hideHeader:!1,hideSubmitButton:!1,hideUserAvatar:!1,inputStyle:{},opened:void 0,placeholder:"Type the message ...",recognitionEnable:!1,recognitionLang:"en",recognitionPlaceholder:"Listening ...",style:{},submitButtonStyle:{},toggleFloating:void 0,userDelay:1e3,width:"350px",botAvatar:"data:image/svg+xml;base64,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",userAvatar:"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgLTIwOC41IDIxIDEwMCAxMDAiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9Ii0yMDguNSAyMSAxMDAgMTAwIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGc+PGNpcmNsZSBjeD0iLTE1OC41IiBjeT0iNzEiIGZpbGw9IiNGNUVFRTUiIGlkPSJNYXNrIiByPSI1MCIvPjxnPjxkZWZzPjxjaXJjbGUgY3g9Ii0xNTguNSIgY3k9IjcxIiBpZD0iTWFza18yXyIgcj0iNTAiLz48L2RlZnM+PGNsaXBQYXRoIGlkPSJNYXNrXzRfIj48dXNlIG92ZXJmbG93PSJ2aXNpYmxlIiB4bGluazpocmVmPSIjTWFza18yXyIvPjwvY2xpcFBhdGg+PHBhdGggY2xpcC1wYXRoPSJ1cmwoI01hc2tfNF8pIiBkPSJNLTEwOC41LDEyMXYtMTRjMCwwLTIxLjItNC45LTI4LTYuN2MtMi41LTAuNy03LTMuMy03LTEyICAgICBjMC0xLjcsMC02LjMsMC02LjNoLTE1aC0xNWMwLDAsMCw0LjYsMCw2LjNjMCw4LjctNC41LDExLjMtNywxMmMtNi44LDEuOS0yOC4xLDcuMy0yOC4xLDYuN3YxNGg1MC4xSC0xMDguNXoiIGZpbGw9IiNFNkMxOUMiIGlkPSJNYXNrXzNfIi8+PGcgY2xpcC1wYXRoPSJ1cmwoI01hc2tfNF8pIj48ZGVmcz48cGF0aCBkPSJNLTEwOC41LDEyMXYtMTRjMCwwLTIxLjItNC45LTI4LTYuN2MtMi41LTAuNy03LTMuMy03LTEyYzAtMS43LDAtNi4zLDAtNi4zaC0xNWgtMTVjMCwwLDAsNC42LDAsNi4zICAgICAgIGMwLDguNy00LjUsMTEuMy03LDEyYy02LjgsMS45LTI4LjEsNy4zLTI4LjEsNi43djE0aDUwLjFILTEwOC41eiIgaWQ9Ik1hc2tfMV8iLz48L2RlZnM+PGNsaXBQYXRoIGlkPSJNYXNrXzVfIj48dXNlIG92ZXJmbG93PSJ2aXNpYmxlIiB4bGluazpocmVmPSIjTWFza18xXyIvPjwvY2xpcFBhdGg+PHBhdGggY2xpcC1wYXRoPSJ1cmwoI01hc2tfNV8pIiBkPSJNLTE1OC41LDEwMC4xYzEyLjcsMCwyMy0xOC42LDIzLTM0LjQgICAgICBjMC0xNi4yLTEwLjMtMjQuNy0yMy0yNC43cy0yMyw4LjUtMjMsMjQuN0MtMTgxLjUsODEuNS0xNzEuMiwxMDAuMS0xNTguNSwxMDAuMXoiIGZpbGw9IiNENEIwOEMiIGlkPSJoZWFkLXNoYWRvdyIvPjwvZz48L2c+PHBhdGggZD0iTS0xNTguNSw5NmMxMi43LDAsMjMtMTYuMywyMy0zMWMwLTE1LjEtMTAuMy0yMy0yMy0yM3MtMjMsNy45LTIzLDIzICAgIEMtMTgxLjUsNzkuNy0xNzEuMiw5Ni0xNTguNSw5NnoiIGZpbGw9IiNGMkNFQTUiIGlkPSJoZWFkIi8+PC9nPjwvc3ZnPg=="},t.default=W},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t,n){"use strict";function r(e){for(var t=arguments.length-1,n="Minified React error #"+e+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+e,r=0;r<t;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);throw t=Error(n+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."),t.name="Invariant Violation",t.framesToPop=1,t}function o(e,t,n){this.props=e,this.context=t,this.refs=b,this.updater=n||_}function i(e,t,n){this.props=e,this.context=t,this.refs=b,this.updater=n||_}function u(){}function a(e,t,n){this.props=e,this.context=t,this.refs=b,this.updater=n||_}function c(e,t,n,r,o,i,u){return{$$typeof:S,type:e,key:t,ref:n,props:u,_owner:i}}function s(e){var t={"=":"=0",":":"=2"};return"$"+(""+e).replace(/[=:]/g,function(e){return t[e]})}function l(e,t,n,r){if(N.length){var o=N.pop();return o.result=e,o.keyPrefix=t,o.func=n,o.context=r,o.count=0,o}return{result:e,keyPrefix:t,func:n,context:r,count:0}}function f(e){e.result=null,e.keyPrefix=null,e.func=null,e.context=null,e.count=0,10>N.length&&N.push(e)}function p(e,t,n,o){var i=typeof e;if("undefined"!==i&&"boolean"!==i||(e=null),null===e||"string"===i||"number"===i||"object"===i&&e.$$typeof===I)return n(o,e,""===t?"."+d(e,0):t),1;var u=0;if(t=""===t?".":t+":",Array.isArray(e))for(var a=0;a<e.length;a++){i=e[a];var c=t+d(i,a);u+=p(i,c,n,o)}else if("function"==typeof(c=O&&e[O]||e["@@iterator"]))for(e=c.call(e),a=0;!(i=e.next()).done;)i=i.value,c=t+d(i,a++),u+=p(i,c,n,o);else"object"===i&&(n=""+e,r("31","[object Object]"===n?"object with keys {"+Object.keys(e).join(", ")+"}":n,""));return u}function d(e,t){return"object"==typeof e&&null!==e&&null!=e.key?s(e.key):t.toString(36)}function h(e,t){e.func.call(e.context,t,e.count++)}function g(e,t,n){var r=e.result,o=e.keyPrefix;e=e.func.call(e.context,t,e.count++),Array.isArray(e)?v(e,r,n,m.thatReturnsArgument):null!=e&&(c.isValidElement(e)&&(e=c.cloneAndReplaceKey(e,o+(!e.key||t&&t.key===e.key?"":(""+e.key).replace(E,"$&/")+"/")+n)),r.push(e))}function v(e,t,n,r,o){var i="";null!=n&&(i=(""+n).replace(E,"$&/")+"/"),t=l(t,i,r,o),null==e||p(e,"",g,t),f(t)}var y=n(13),b=n(14);n(15);var m=n(16),_={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};o.prototype.isReactComponent={},o.prototype.setState=function(e,t){"object"!=typeof e&&"function"!=typeof e&&null!=e&&r("85"),this.updater.enqueueSetState(this,e,t,"setState")},o.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate")},u.prototype=o.prototype;var x=i.prototype=new u;x.constructor=i,y(x,o.prototype),x.isPureReactComponent=!0;var w=a.prototype=new u;w.constructor=a,y(w,o.prototype),w.unstable_isAsyncReactComponent=!0,w.render=function(){return this.props.children};var j={Component:o,PureComponent:i,AsyncComponent:a},M={current:null},C=Object.prototype.hasOwnProperty,S="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,k={key:!0,ref:!0,__self:!0,__source:!0};c.createElement=function(e,t,n){var r,o={},i=null,u=null,a=null,s=null;if(null!=t)for(r in void 0!==t.ref&&(u=t.ref),void 0!==t.key&&(i=""+t.key),a=void 0===t.__self?null:t.__self,s=void 0===t.__source?null:t.__source,t)C.call(t,r)&&!k.hasOwnProperty(r)&&(o[r]=t[r]);var l=arguments.length-2;if(1===l)o.children=n;else if(1<l){for(var f=Array(l),p=0;p<l;p++)f[p]=arguments[p+2];o.children=f}if(e&&e.defaultProps)for(r in l=e.defaultProps)void 0===o[r]&&(o[r]=l[r]);return c(e,i,u,a,s,M.current,o)},c.createFactory=function(e){var t=c.createElement.bind(null,e);return t.type=e,t},c.cloneAndReplaceKey=function(e,t){return c(e.type,t,e.ref,e._self,e._source,e._owner,e.props)},c.cloneElement=function(e,t,n){var r=y({},e.props),o=e.key,i=e.ref,u=e._self,a=e._source,s=e._owner;if(null!=t){if(void 0!==t.ref&&(i=t.ref,s=M.current),void 0!==t.key&&(o=""+t.key),e.type&&e.type.defaultProps)var l=e.type.defaultProps;for(f in t)C.call(t,f)&&!k.hasOwnProperty(f)&&(r[f]=void 0===t[f]&&void 0!==l?l[f]:t[f])}var f=arguments.length-2;if(1===f)r.children=n;else if(1<f){l=Array(f);for(var p=0;p<f;p++)l[p]=arguments[p+2];r.children=l}return c(e.type,o,i,u,a,s,r)},c.isValidElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===S};var O="function"==typeof Symbol&&Symbol.iterator,I="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,E=/\/+/g,N=[],P={forEach:function(e,t,n){if(null==e)return e;t=l(null,null,t,n),null==e||p(e,"",h,t),f(t)},map:function(e,t,n){if(null==e)return e;var r=[];return v(e,r,null,t,n),r},count:function(e){return null==e?0:p(e,"",m.thatReturnsNull,null)},toArray:function(e){var t=[];return v(e,t,null,m.thatReturnsArgument),t}};e.exports={Children:{map:P.map,forEach:P.forEach,count:P.count,toArray:P.toArray,only:function(e){return c.isValidElement(e)||r("143"),e}},Component:j.Component,PureComponent:j.PureComponent,unstable_AsyncComponent:j.AsyncComponent,createElement:c.createElement,cloneElement:c.cloneElement,isValidElement:c.isValidElement,createFactory:c.createFactory,version:"16.0.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:M,assign:y}}},function(e,t,n){"use strict";function r(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable;e.exports=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(t).map(function(e){return t[e]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(e){r[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(e){return!1}}()?Object.assign:function(e,t){for(var n,a,c=r(e),s=1;s<arguments.length;s++){n=Object(arguments[s]);for(var l in n)i.call(n,l)&&(c[l]=n[l]);if(o){a=o(n);for(var f=0;f<a.length;f++)u.call(n,a[f])&&(c[a[f]]=n[a[f]])}}return c}},function(e,t,n){"use strict";var r={};e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,i,u,a,c){if(o(t),!e){var s;if(void 0===t)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,r,i,u,a,c],f=0;s=new Error(t.replace(/%s/g,function(){return l[f++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var o=function(e){};e.exports=r},function(e,t,n){"use strict";function r(e){return function(){return e}}var o=function(){};o.thatReturns=r,o.thatReturnsFalse=r(!1),o.thatReturnsTrue=r(!0),o.thatReturnsNull=r(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,n){"use strict";var r=n(18),o=n(19),i=n(20);e.exports=function(){function e(e,t,n,r,u,a){a!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";function r(e){return function(){return e}}var o=function(){};o.thatReturns=r,o.thatReturnsFalse=r(!1),o.thatReturnsTrue=r(!0),o.thatReturnsNull=r(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,n){"use strict";function r(e,t,n,r,i,u,a,c){if(o(t),!e){var s;if(void 0===t)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,r,i,u,a,c],f=0;s=new Error(t.replace(/%s/g,function(){return l[f++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var o=function(e){};e.exports=r},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){!function(){var t=function(e,t){var n=["abcdefghijklmnopqrstuvwxyz","ABCDEFGHIJKLMNOPQRSTUVWXYZ","0123456789","~!@#$%^&()_+-={}[];',"],r="",t=t||"aA0";t.split("").forEach(function(e){isNaN(parseInt(e))?/[a-z]/.test(e)?r+=n[0]:/[A-Z]/.test(e)?r+=n[1]:r+=n[3]:r+=n[2]});for(var e=e||30,o="";e--;)o+=r.charAt(Math.floor(Math.random()*r.length));return o};e.exports=t}()},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.TextStep=t.OptionsStep=t.CustomStep=void 0;var o=n(23),i=r(o),u=n(32),a=r(u),c=n(37),s=r(c);t.CustomStep=i.default,t.OptionsStep=a.default,t.TextStep=s.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),s=r(c),l=n(2),f=r(l),p=n(5),d=r(p),h=n(31),g=r(h),v=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={loading:!0},n.renderComponent=n.renderComponent.bind(n),n}return u(t,e),a(t,[{key:"componentDidMount",value:function(){var e=this,t=this.props.step,n=t.delay,r=t.waitAction;setTimeout(function(){e.setState({loading:!1},function(){r||t.rendered||e.props.triggerNextStep()})},n)}},{key:"renderComponent",value:function(){var e=this.props,t=e.step,n=e.steps,r=e.previousStep,o=e.triggerNextStep,i=t.component;return s.default.cloneElement(i,{step:t,steps:n,previousStep:r,triggerNextStep:o})}},{key:"render",value:function(){var e=this.state.loading,t=this.props.style;return s.default.createElement(g.default,{className:"rsc-cs",style:t},e?s.default.createElement(d.default,null):this.renderComponent())}}]),t}(c.Component);v.propTypes={step:f.default.object.isRequired,steps:f.default.object.isRequired,style:f.default.object.isRequired,previousStep:f.default.object.isRequired,triggerNextStep:f.default.func.isRequired},t.default=v},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  animation: "," 1.4s infinite both;\n  animation-delay: ",";\n"],["\n  animation: "," 1.4s infinite both;\n  animation-delay: ",";\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=n(3),a=i.default.span(r,u.loading,function(e){return e.delay});t.default=a},function(e,t,n){"use strict";function r(e){return!0===o(e)&&"[object Object]"===Object.prototype.toString.call(e)}var o=n(26);e.exports=function(e){var t,n;return!1!==r(e)&&"function"==typeof(t=e.constructor)&&(n=t.prototype,!1!==r(n)&&!1!==n.hasOwnProperty("isPrototypeOf"))}},function(e,t,n){"use strict";e.exports=function(e){return null!=e&&"object"==typeof e&&!1===Array.isArray(e)}},function(e,t,n){!function(t){e.exports=function e(t){"use strict";function n(e,t,o,c,f){for(var p,d,h=0,y=0,b=0,m=0,_=0,x=0,w=0,j=0,M=0,C=0,S=0,E=0,N=0,P=0,T=0,A=0,z=0,D=0,R=0,B=o.length,re=B-1,Ie="",Ee="",Ae="",Le="",De="",Re="";T<B;){if(w=o.charCodeAt(T),T===re&&y+m+b+h!==0&&(y===se&&(w=$),B++,re++),y+m+b+h===0){if(T===re&&(A>0&&(Ee=Ee.replace(v,"")),Ee.trim().length>0)){switch(w){case ee:case X:case Z:case J:case $:break;default:Ee+=o.charAt(T)}w=Z}if(1===z)switch(w){case V:case ie:z=0;break;case X:case J:case $:case ee:break;default:T--,w=Z}switch(w){case V:for(Ee=Ee.trim(),_=Ee.charCodeAt(0),S=1,R=++T;T<B;){switch(w=o.charCodeAt(T)){case V:S++;break;case G:S--}if(0===S)break;T++}switch(Ae=o.substring(R,T),_===de&&(_=(Ee=Ee.replace(g,"").trim()).charCodeAt(0)),_){case K:switch(A>0&&(Ee=Ee.replace(v,"")),x=Ee.charCodeAt(1)){case je:case ye:case be:case ne:p=t;break;default:p=Te}if(Ae=n(t,p,Ae,x,f+1),R=Ae.length,Pe>0&&0===R&&(R=Ee.length),ze>0&&(p=r(Te,Ee,D),d=l(We,Ae,p,t,Ce,Me,R,x,f),Ee=p.join(""),void 0!==d&&0===(R=(Ae=d.trim()).length)&&(x=0,Ae="")),R>0)switch(x){case be:Ee=Ee.replace(L,a);case je:case ye:case ne:Ae=Ee+"{"+Ae+"}";break;case ve:Ee=Ee.replace(k,"$1 $2"+(Ge>0?Ve:"")),Ae=Ee+"{"+Ae+"}",Ae=1===Oe||2===Oe&&u("@"+Ae,3)?"@"+F+Ae+"@"+Ae:"@"+Ae;break;default:Ae=Ee+Ae}else Ae="";break;default:Ae=n(t,r(t,Ee,D),Ae,c,f+1)}De+=Ae,E=0,z=0,P=0,A=0,D=0,N=0,Ee="",Ae="",w=o.charCodeAt(++T);break;case G:case Z:if(Ee=(A>0?Ee.replace(v,""):Ee).trim(),(R=Ee.length)>1)switch(0===P&&((_=Ee.charCodeAt(0))===ne||_>96&&_<123)&&(R=(Ee=Ee.replace(" ",":")).length),ze>0&&void 0!==(d=l(Fe,Ee,t,e,Ce,Me,Le.length,c,f))&&0===(R=(Ee=d.trim()).length)&&(Ee="\0\0"),_=Ee.charCodeAt(0),x=Ee.charCodeAt(1),_+x){case de:break;case xe:case we:Re+=Ee+o.charAt(T);break;default:if(Ee.charCodeAt(R-1)===ue)break;Le+=i(Ee,_,x,Ee.charCodeAt(2))}E=0,z=0,P=0,A=0,D=0,Ee="",w=o.charCodeAt(++T)}}switch(w){case J:case $:if(y+m+b+h+Ne===0)switch(C){case H:case ae:case ce:case K:case pe:case le:case oe:case fe:case se:case ne:case ue:case ie:case Z:case V:case G:break;default:P>0&&(z=1)}y===se?y=0:ke+E===0&&(A=1,Ee+="\0"),ze*Ze>0&&l(Be,Ee,t,e,Ce,Me,Le.length,c,f),Me=1,Ce++;break;case Z:case G:if(y+m+b+h===0){Me++;break}default:switch(Me++,Ie=o.charAt(T),w){case X:case ee:if(m+h+y===0)switch(j){case ie:case ue:case X:case ee:Ie="";break;default:w!==ee&&(Ie=" ")}break;case de:Ie="\\0";break;case he:Ie="\\f";break;case ge:Ie="\\v";break;case te:m+y+h===0&&ke>0&&(D=1,A=1,Ie="\f"+Ie);break;case 108:if(m+y+h+Se===0&&P>0)switch(T-P){case 2:j===me&&o.charCodeAt(T-3)===ue&&(Se=j);case 8:M===_e&&(Se=M)}break;case ue:m+y+h===0&&(P=T);break;case ie:y+b+m+h===0&&(A=1,Ie+="\r");break;case ce:case ae:0===y&&(m=m===w?0:0===m?w:m);break;case Y:m+y+b===0&&h++;break;case Q:m+y+b===0&&h--;break;case H:m+y+h===0&&b--;break;case q:if(m+y+h===0){if(0===E)switch(2*j+3*M){case 533:break;default:S=0,E=1}b++}break;case K:y+b+m+h+P+N===0&&(N=1);break;case oe:case se:if(m+h+b>0)break;switch(y){case 0:switch(2*w+3*o.charCodeAt(T+1)){case 235:y=se;break;case 220:R=T,y=oe}break;case oe:w===se&&j===oe&&(33===o.charCodeAt(R+2)&&(Le+=o.substring(R,T+1)),Ie="",y=0)}}if(0===y){if(ke+m+h+N===0&&c!==ve&&w!==Z)switch(w){case ie:case pe:case le:case fe:case H:case q:if(0===E){switch(j){case X:case ee:case $:case J:Ie+="\0";break;default:Ie="\0"+Ie+(w===ie?"":"\0")}A=1}else switch(w){case q:E=++S;break;case H:0==(E=--S)&&(A=1,Ie+="\0")}break;case X:case ee:switch(j){case de:case V:case G:case Z:case ie:case he:case X:case ee:case $:case J:break;default:0===E&&(A=1,Ie+="\0")}}Ee+=Ie,w!==ee&&w!==X&&(C=w)}}M=j,j=w,T++}if(R=Le.length,Pe>0&&0===R&&0===De.length&&0===t[0].length==0&&(c!==ye||1===t.length&&(ke>0?qe:He)===t[0])&&(R=t.join(",").length+2),R>0){if(p=0===ke&&c!==ve?s(t):t,ze>0&&void 0!==(d=l(Ue,Le,p,e,Ce,Me,R,c,f))&&0===(Le=d).length)return Re+Le+De;if(Le=p.join(",")+"{"+Le+"}",Oe*Se!=0){switch(2!==Oe||u(Le,2)||(Se=0),Se){case _e:Le=Le.replace(I,":"+U+"$1")+Le;break;case me:Le=Le.replace(O,"::"+F+"input-$1")+Le.replace(O,"::"+U+"$1")+Le.replace(O,":"+W+"input-$1")+Le}Se=0}}return Re+Le+De}function r(e,t,n){var r=t.trim().split(j),i=r,u=r.length,a=e.length;switch(a){case 0:case 1:for(var c=0,s=0===a?"":e[0]+" ";c<u;++c)i[c]=o(s,i[c],n,a).trim();break;default:for(var c=0,l=0,i=[];c<u;++c)for(var f=0;f<a;++f)i[l++]=o(e[f]+" ",r[c],n,a).trim()}return i}function o(e,t,n,r){var o=t,i=o.charCodeAt(0);switch(i<33&&(i=(o=o.trim()).charCodeAt(0)),i){case te:switch(ke+r){case 0:case 1:if(0===e.trim().length)break;default:return o.replace(M,"$1"+e.trim())}break;case ue:switch(o.charCodeAt(1)){case 103:if(Ie>0&&ke>0)return o.replace(C,"$1").replace(M,"$1"+He);break;default:return e.trim()+o}default:if(n*ke>0&&o.indexOf("\f")>0)return o.replace(M,(e.charCodeAt(0)===ue?"":"$1")+e.trim())}return e+o}function i(e,t,n,r){var o,i=0,a=e+";",s=2*t+3*n+4*r;if(944===s)return c(a);if(0===Oe||2===Oe&&!u(a,1))return a;switch(s){case 1015:return a.charCodeAt(9)===ne?F+a+a:a;case 951:return 116===a.charCodeAt(3)?F+a+a:a;case 963:return 110===a.charCodeAt(5)?F+a+a:a;case 1009:if(100!==a.charCodeAt(4))break;case 969:case 942:return F+a+a;case 978:return F+a+U+a+a;case 1019:case 983:return F+a+U+a+W+a+a;case 883:return a.charCodeAt(8)===ne?F+a+a:a;case 932:if(a.charCodeAt(4)===ne)switch(a.charCodeAt(5)){case 103:return F+"box-"+a.replace("-grow","")+W+a.replace("grow","positive")+a;case 115:return W+a.replace("shrink","negative")+a;case 98:return W+a.replace("basis","preferred-size")+a}return F+a+W+a+a;case 964:return F+a+W+"flex-"+a+a;case 1023:if(99!==a.charCodeAt(8))break;return o=a.substring(a.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),F+"box-pack"+o+F+a+W+"flex-pack"+o+a;case 1005:return b.test(a)?a.replace(y,":"+F)+a.replace(y,":"+U)+a:a;case 1e3:switch(o=a.substring(13).trim(),i=o.indexOf("-")+1,o.charCodeAt(0)+o.charCodeAt(i)){case 226:o=a.replace(z,"tb");break;case 232:o=a.replace(z,"tb-rl");break;case 220:o=a.replace(z,"lr");break;default:return a}return F+a+W+o+a;case 1017:if(-1===a.indexOf("sticky",9))return a;case 975:switch(i=(a=e).length-10,o=(33===a.charCodeAt(i)?a.substring(0,i):a).substring(e.indexOf(":",7)+1).trim(),s=o.charCodeAt(0)+(0|o.charCodeAt(7))){case 203:if(o.charCodeAt(8)<111)break;case 115:a=a.replace(o,F+o)+";"+a;break;case 207:case 102:a=a.replace(o,F+(s>102?"inline-":"")+"box")+";"+a.replace(o,F+o)+";"+a.replace(o,W+o+"box")+";"+a}return a+";";case 938:if(a.charCodeAt(5)===ne)switch(a.charCodeAt(6)){case 105:return o=a.replace("-items",""),F+a+F+"box-"+o+W+"flex-"+o+a;case 115:return F+a+W+"flex-item-"+a.replace(R,"")+a;default:return F+a+W+"flex-line-pack"+a.replace("align-content","")+a}break;case 953:if((i=a.indexOf("-content",9))>0&&109===a.charCodeAt(i-3)&&45!==a.charCodeAt(i-4))return o=a.substring(i-3),"width:"+F+o+"width:"+U+o+"width:"+o;break;case 962:if(a=F+a+(102===a.charCodeAt(5)?W+a:"")+a,n+r===211&&105===a.charCodeAt(13)&&a.indexOf("transform",10)>0)return a.substring(0,a.indexOf(";",27)+1).replace(m,"$1"+F+"$2")+a}return a}function u(e,t){var n=e.indexOf(1===t?":":"{"),r=e.substring(0,3!==t?n:10),o=e.substring(n+1,e.length-1);return Le(2!==t?r:r.replace(B,"$1"),o,t)}function a(e,t){var n=i(t,t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2));return n!==t+";"?n.replace(D," or ($1)").substring(4):"("+t+")"}function c(e){var t=e.length,n=e.indexOf(":",9)+1,r=e.substring(0,n).trim(),o=e.substring(n,t-1).trim();switch(e.charCodeAt(9)*Ge){case 0:break;case ne:if(110!==e.charCodeAt(10))break;default:for(var i=o.split((o="",_)),a=0,n=0,t=i.length;a<t;n=0,++a){for(var c=i[a],s=c.split(x);c=s[n];){var l=c.charCodeAt(0);if(1===Ge&&(l>K&&l<90||l>96&&l<123||l===re||l===ne&&c.charCodeAt(1)!==ne))switch(isNaN(parseFloat(c))+(-1!==c.indexOf("("))){case 1:switch(c){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:c+=Ve}}s[n++]=c}o+=(0===a?"":",")+s.join(" ")}}return o=r+o+";",1===Oe||2===Oe&&u(o,1)?F+o+o:o}function s(e){for(var t,n,r=0,o=e.length,i=Array(o);r<o;++r){for(var u=e[r].split(w),a="",c=0,s=0,l=0,f=0,p=u.length;c<p;++c)if(!(0===(s=(n=u[c]).length)&&p>1)){if(l=a.charCodeAt(a.length-1),f=n.charCodeAt(0),t="",0!==c)switch(l){case oe:case pe:case le:case fe:case ee:case q:break;default:t=" "}switch(f){case te:n=t+qe;case pe:case le:case fe:case ee:case H:case q:break;case Y:n=t+n+qe;break;case ue:switch(2*n.charCodeAt(1)+3*n.charCodeAt(2)){case 530:if(Ie>0){n=t+n.substring(8,s-1);break}default:(c<1||u[c-1].length<1)&&(n=t+qe+n)}break;case ie:t="";default:n=s>1&&n.indexOf(":")>0?t+n.replace(A,"$1"+qe+"$2"):t+n+qe}a+=n}i[r]=a.replace(v,"").trim()}return i}function l(e,t,n,r,o,i,u,a,c){for(var s,l=0,f=t;l<ze;++l)switch(s=Ae[l].call(h,e,f,n,r,o,i,u,a,c)){case void 0:case!1:case!0:case null:break;default:f=s}switch(f){case void 0:case!1:case!0:case null:case t:break;default:return f}}function f(e){return e.replace(v,"").replace(E,"").replace(N,"$1").replace(P,"$1").replace(T," ")}function p(e){switch(e){case void 0:case null:ze=Ae.length=0;break;default:switch(e.constructor){case Array:for(var t=0,n=e.length;t<n;++t)p(e[t]);break;case Function:Ae[ze++]=e;break;case Boolean:Ze=0|!!e}}return p}function d(e){for(var t in e){var n=e[t];switch(t){case"keyframe":Ge=0|n;break;case"global":Ie=0|n;break;case"cascade":ke=0|n;break;case"compress":Ee=0|n;break;case"semicolon":Ne=0|n;break;case"preserve":Pe=0|n;break;case"prefix":Le=null,n?"function"!=typeof n?Oe=1:(Oe=2,Le=n):Oe=0}}return d}function h(t,r){if(void 0!==this&&this.constructor===h)return e(t);var o=t,i=o.charCodeAt(0);i<33&&(i=(o=o.trim()).charCodeAt(0)),Ge>0&&(Ve=o.replace(S,i===Y?"":"-")),i=1,1===ke?He=o:qe=o;var u,a=[He];ze>0&&void 0!==(u=l(Re,r,a,a,Ce,Me,0,0,0))&&"string"==typeof u&&(r=u);var c=n(Te,a,r,0,0);return ze>0&&void 0!==(u=l(De,c,a,a,Ce,Me,c.length,0,0))&&"string"!=typeof(c=u)&&(i=0),Ve="",He="",qe="",Se=0,Ce=1,Me=1,Ee*i==0?c:f(c)}var g=/^\0+/g,v=/[\0\r\f]/g,y=/: */g,b=/zoo|gra/,m=/([,: ])(transform)/g,_=/,+\s*(?![^(]*[)])/g,x=/ +\s*(?![^(]*[)])/g,w=/ *[\0] */g,j=/,\r+?/g,M=/([\t\r\n ])*\f?&/g,C=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,S=/\W+/g,k=/@(k\w+)\s*(\S*)\s*/,O=/::(place)/g,I=/:(read-only)/g,E=/\s+(?=[{\];=:>])/g,N=/([[}=:>])\s+/g,P=/(\{[^{]+?);(?=\})/g,T=/\s{2,}/g,A=/([^\(])(:+) */g,z=/[svh]\w+-[tblr]{2}/,L=/\(\s*([^]*?)\s*\)/g,D=/([^]*?);/g,R=/-self|flex-/g,B=/[^]*?(:[rp][el]a[\w-]+)[^]*/,F="-webkit-",U="-moz-",W="-ms-",Z=59,G=125,V=123,q=40,H=41,Y=91,Q=93,$=10,J=13,X=9,K=64,ee=32,te=38,ne=45,re=95,oe=42,ie=44,ue=58,ae=39,ce=34,se=47,le=62,fe=43,pe=126,de=0,he=12,ge=11,ve=107,ye=109,be=115,me=112,_e=111,xe=169,we=163,je=100,Me=1,Ce=1,Se=0,ke=1,Oe=1,Ie=1,Ee=0,Ne=0,Pe=0,Te=[],Ae=[],ze=0,Le=null,De=-2,Re=-1,Be=0,Fe=1,Ue=2,We=3,Ze=0,Ge=1,Ve="",qe="",He="";return h.use=p,h.set=d,void 0!==t&&d(t),h}(null)}()},function(e,t){function n(e){var t=r.call(e);return"[object Function]"===t||"function"==typeof e&&"[object RegExp]"!==t||"undefined"!=typeof window&&(e===window.setTimeout||e===window.alert||e===window.confirm||e===window.prompt)}e.exports=n;var r=Object.prototype.toString},function(e,t,n){"use strict";var r={childContextTypes:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,mixins:!0,propTypes:!0,type:!0},o={name:!0,length:!0,prototype:!0,caller:!0,arguments:!0,arity:!0},i="function"==typeof Object.getOwnPropertySymbols;e.exports=function(e,t,n){if("string"!=typeof t){var u=Object.getOwnPropertyNames(t);i&&(u=u.concat(Object.getOwnPropertySymbols(t)));for(var a=0;a<u.length;++a)if(!(r[u[a]]||o[u[a]]||n&&n[u[a]]))try{e[u[a]]=t[u[a]]}catch(e){}}return e}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e){var t=/^#?([a-f\d])([a-f\d])([a-f\d])$/i;e=e.replace(t,function(e,t,n,r){return t+t+n+n+r+r});var n=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);return n?{r:parseInt(n[1],16),g:parseInt(n[2],16),b:parseInt(n[3],16)}:null},o=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=r(e);return"rgba("+n.r+", "+n.g+", "+n.b+", "+t+")"};t.default=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  background: #fff;\n  border-radius: 5px;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;\n  display: flex;\n  justify-content: center;\n  margin: 0 6px 10px 6px;\n  padding: 16px;\n"],["\n  background: #fff;\n  border-radius: 5px;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;\n  display: flex;\n  justify-content: center;\n  margin: 0 6px 10px 6px;\n  padding: 16px;\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.div(r);t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),s=r(c),l=n(2),f=r(l),p=n(6),d=r(p),h=n(33),g=r(h),v=n(34),y=r(v),b=n(35),m=r(b),_=n(36),x=r(_),w=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.renderOption=n.renderOption.bind(n),n.onOptionClick=n.onOptionClick.bind(n),n}return u(t,e),a(t,[{key:"onOptionClick",value:function(e){var t=e.value;this.props.triggerNextStep({value:t})}},{key:"renderOption",value:function(e){var t=this,n=this.props.bubbleStyle,r=this.props.step.user,o=e.value,i=e.label;return s.default.createElement(g.default,{key:o,className:"rsc-os-option"},s.default.createElement(y.default,{className:"rsc-os-option-element",style:n,user:r,onClick:function(){return t.onOptionClick({value:o})}},i))}},{key:"render",value:function(){var e=this.props.step.options;return s.default.createElement(x.default,{className:"rsc-os"},s.default.createElement(m.default,{className:"rsc-os-options"},d.default.map(e,this.renderOption)))}}]),t}(c.Component);w.propTypes={step:f.default.object.isRequired,triggerNextStep:f.default.func.isRequired,bubbleStyle:f.default.object.isRequired},t.default=w},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  animation: "," .3s ease forwards;\n  cursor: pointer;\n  display: inline-block;\n  margin: 2px;\n  transform: scale(0);\n"],["\n  animation: "," .3s ease forwards;\n  cursor: pointer;\n  display: inline-block;\n  margin: 2px;\n  transform: scale(0);\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=n(3),a=i.default.li(r,u.scale);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  background: ",";\n  border-radius: 22px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n  color: ",";\n  display: inline-block;\n  font-size: 14px;\n  padding: 12px;\n\n  &:hover { opacity: .7; }\n"],["\n  background: ",";\n  border-radius: 22px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n  color: ",";\n  display: inline-block;\n  font-size: 14px;\n  padding: 12px;\n\n  &:hover { opacity: .7; }\n"]),i=n(0),u=r(i),a=n(4),c=r(a),s=u.default.a(o,function(e){return e.theme.botBubbleColor},function(e){return e.theme.botFontColor});s.defaultProps={theme:c.default},t.default=s},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  margin: 2px 0 12px 0;\n  padding: 0 6px;\n"],["\n  margin: 2px 0 12px 0;\n  padding: 0 6px;\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.ul(r);t.default=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n\n"],["\n\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.div(r);t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),s=r(c),l=n(2),f=r(l),p=n(38),d=r(p),h=n(39),g=r(h),v=n(40),y=r(v),b=n(5),m=r(b),_=n(41),x=r(_),w=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={loading:!0},n.renderMessage=n.renderMessage.bind(n),n}return u(t,e),a(t,[{key:"componentDidMount",value:function(){var e=this,t=this.props.step,n=t.component,r=t.delay,o=t.waitAction,i=n&&o;setTimeout(function(){e.setState({loading:!1},function(){i||t.rendered||e.props.triggerNextStep()})},r)}},{key:"renderMessage",value:function(){var e=this.props,t=e.previousValue,n=e.step,r=e.steps,o=e.previousStep,i=e.triggerNextStep,u=n.component,a=n.message;return u?s.default.cloneElement(u,{step:n,steps:r,previousStep:o,triggerNextStep:i}):a=a.replace(/{previousValue}/g,t)}},{key:"render",value:function(){var e=this.props,t=e.step,n=e.isFirst,r=e.isLast,o=e.avatarStyle,i=e.bubbleStyle,u=e.hideBotAvatar,a=e.hideUserAvatar,c=t.avatar,l=t.user,f=l?!a:!u;return s.default.createElement(x.default,{className:"rsc-ts",user:l},s.default.createElement(y.default,{className:"rsc-ts-image-container",user:l},n&&f&&s.default.createElement(g.default,{className:"rsc-ts-image",style:o,showAvatar:f,user:l,src:c,alt:"avatar"})),s.default.createElement(d.default,{className:"rsc-ts-bubble",style:i,user:l,showAvatar:f,isFirst:n,isLast:r},this.state.loading&&s.default.createElement(m.default,null),!this.state.loading&&this.renderMessage()))}}]),t}(c.Component);w.propTypes={isFirst:f.default.bool.isRequired,isLast:f.default.bool.isRequired,step:f.default.object.isRequired,triggerNextStep:f.default.func.isRequired,avatarStyle:f.default.object.isRequired,bubbleStyle:f.default.object.isRequired,hideBotAvatar:f.default.bool.isRequired,hideUserAvatar:f.default.bool.isRequired,previousStep:f.default.object,previousValue:f.default.any,steps:f.default.object},w.defaultProps={previousStep:{},steps:{},previousValue:""},t.default=w},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  animation: "," .3s ease forwards;\n  background: ",";\n  border-radius: ",";\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n  color: ",";\n  display: inline-block;\n  font-size: 14px;\n  max-width: 50%;\n  margin: ",";\n  overflow: hidden;\n  position: relative;\n  padding: 12px;\n  transform: scale(0);\n  transform-origin: ",";\n"],["\n  animation: "," .3s ease forwards;\n  background: ",";\n  border-radius: ",";\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n  color: ",";\n  display: inline-block;\n  font-size: 14px;\n  max-width: 50%;\n  margin: ",";\n  overflow: hidden;\n  position: relative;\n  padding: 12px;\n  transform: scale(0);\n  transform-origin: ",";\n"]),i=n(0),u=r(i),a=n(3),c=n(4),s=r(c),l=u.default.div(o,a.scale,function(e){return e.user?e.theme.userBubbleColor:e.theme.botBubbleColor},function(e){var t=e.isFirst,n=e.isLast,r=e.user;return t||n?!t&&n?r?"18px 0 18px 18px":"0 18px 18px 18px":e.user?"18px 18px 0 18px":"18px 18px 18px 0":r?"18px 0 0 18px":"0 18px 18px 0px"},function(e){return e.user?e.theme.userFontColor:e.theme.botFontColor},function(e){var t=e.isFirst,n=e.showAvatar,r=e.user;return!t&&n?r?"-8px 46px 10px 0":"-8px 0 10px 46px":t||n?"0 0 10px 0":r?"-8px 0px 10px 0":"-8px 0 10px 0px"},function(e){var t=e.isFirst,n=e.user;return t?n?"bottom right":"bottom left":n?"top right":"top left"});l.defaultProps={theme:s.default},t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  animation: "," .3s ease forwards;\n  border-radius: ",";\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;\n  height: 40px;\n  min-width: 40px;\n  padding: 3px;\n  transform: scale(0);\n  transform-origin: ",";\n  width: 40;\n"],["\n  animation: "," .3s ease forwards;\n  border-radius: ",";\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;\n  height: 40px;\n  min-width: 40px;\n  padding: 3px;\n  transform: scale(0);\n  transform-origin: ",";\n  width: 40;\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=n(3),a=i.default.img(r,u.scale,function(e){return e.user?"50% 50% 50% 0":"50% 50% 0 50%"},function(e){return e.user?"bottom left":"bottom right"});t.default=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  display: inline-block;\n  order: ",";\n  padding: 6px;\n"],["\n  display: inline-block;\n  order: ",";\n  padding: 6px;\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.div(r,function(e){return e.user?"1":"0"});t.default=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  align-items: flex-end;\n  display: flex;\n  justify-content: ",";\n"],["\n  align-items: flex-end;\n  display: flex;\n  justify-content: ",";\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.div(r,function(e){return e.user?"flex-end":"flex-start"});t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=n(43),u=r(i),a=n(44),c=r(a),s=n(45),l=r(s),f=n(46),p=r(f),d=n(47),h=r(d),g=n(7),v={parse:function(e){var t=[];if(e.user)t=u.default;else if(e.message)t=c.default;else if(e.options)t=l.default;else if(e.component)t=p.default;else{if(!e.update)throw new Error("The step "+g.stringify(e)+" is invalid");t=h.default}for(var n=0,r=t.length;n<r;n+=1){var i=t[n],a=i.key,s=i.types,f=i.required;if(!e[a]&&f)throw new Error("Key '"+a+"' is required in step "+g.stringify(e));if(e[a]&&"any"!==s[0]&&s.indexOf(o(e[a]))<0)throw new Error("The type of '"+a+"' value must be "+s.join(" or ")+" instead of "+o(e[a]))}var d=t.map(function(e){return e.key});for(var a in e)d.indexOf(a)<0&&(console.error("Invalid key '"+a+"' in step '"+e.id+"'"),delete e[a]);return e},checkInvalidIds:function(e){for(var t in e){var n=e[t],r=e[t].trigger;if("function"!=typeof r)if(n.options)for(var o=n.options.filter(function(e){return"function"!=typeof e.trigger}),i=o.map(function(e){return e.trigger}),u=0,a=i.length;u<a;u+=1){var c=i[u];if(c&&!e[c])throw new Error("The id '"+c+"' triggered by option "+(u+1)+" in step '"+e[t].id+"' does not exist")}else if(r&&!e[r])throw new Error("The id '"+r+"' triggered by step '"+e[t].id+"' does not exist")}}};t.default=v},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=[{key:"id",types:["string","number"],required:!0},{key:"user",types:["boolean"],required:!0},{key:"trigger",types:["string","number","function"],required:!1},{key:"validator",types:["function"],required:!1},{key:"end",types:["boolean"],required:!1}]},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=[{key:"id",types:["string","number"],required:!0},{key:"message",types:["string","function"],required:!0},{key:"avatar",types:["string"],required:!1},{key:"trigger",types:["string","number","function"],required:!1},{key:"delay",types:["number"],required:!1},{key:"end",types:["boolean"],required:!1}]},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=[{key:"id",types:["string","number"],required:!0},{key:"options",types:["object"],required:!0},{key:"end",types:["boolean"],required:!1}]},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=[{key:"id",types:["string","number"],required:!0},{key:"component",types:["any"],required:!0},{key:"avatar",types:["string"],required:!1},{key:"replace",types:["boolean"],required:!1},{key:"waitAction",types:["boolean"],required:!1},{key:"asMessage",types:["boolean"],required:!1},{key:"trigger",types:["string","number","function"],required:!1},{key:"delay",types:["number"],required:!1},{key:"end",types:["boolean"],required:!1}]},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=[{key:"id",types:["string","number"],required:!0},{key:"update",types:["string","number"],required:!0},{key:"trigger",types:["string","number","function"],required:!0}]},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(7),o=function(e,t){var n=e.cacheName,o=e.cache,i=e.firstStep,u=e.steps,a=i,c=[u[a.id]],s=[u[a.id]],l={};if(o&&localStorage.getItem(n)){var f=r.parse(localStorage.getItem(n)),p=f.renderedSteps[f.renderedSteps.length-1];if(!p||!p.end){for(var d=0;d<f.renderedSteps.length;d+=1){var h=f.renderedSteps[d];if(f.renderedSteps[d].delay=0,f.renderedSteps[d].rendered=!0,h.component){var g=h.id;f.renderedSteps[d].component=u[g].component}}var v=f.currentStep,y=v.trigger,b=v.end,m=v.options,_=f.currentStep.id;if(m&&delete f.currentStep.rendered,!y&&!b)if(m)for(var x=0;x<m.length;x+=1)f.currentStep.options[x].trigger=u[_].options[x].trigger;else f.currentStep.trigger=u[_].trigger;return f.currentStep.user&&t(),f}localStorage.removeItem(n)}return{currentStep:a,previousStep:l,previousSteps:s,renderedSteps:c}},i=function(e,t){localStorage.setItem(e,r.stringify(t))};t.getData=o,t.setData=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  background: ",";\n  border-radius: 10px;\n  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.15);\n  font-family: ",";\n  overflow: hidden;\n  position: ",";\n  bottom: ",";\n  right: ",";\n  width: ",";\n  z-index: 999;\n  transform: ",";\n  transform-origin: bottom right;\n  transition: transform .3s ease;\n\n  @media screen and (max-width: 568px) {\n    border-radius: ",";\n    bottom: 0;\n    height: 100%;\n    right: 0;\n    width: 100%;\n  }\n"],["\n  background: ",";\n  border-radius: 10px;\n  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.15);\n  font-family: ",";\n  overflow: hidden;\n  position: ",";\n  bottom: ",";\n  right: ",";\n  width: ",";\n  z-index: 999;\n  transform: ",";\n  transform-origin: bottom right;\n  transition: transform .3s ease;\n\n  @media screen and (max-width: 568px) {\n    border-radius: ",";\n    bottom: 0;\n    height: 100%;\n    right: 0;\n    width: 100%;\n  }\n"]),i=n(0),u=r(i),a=n(4),c=r(a),s=u.default.div(o,function(e){return e.theme.background},function(e){return e.theme.fontFamily},function(e){return e.floating?"fixed":"relative"},function(e){return e.floating?"32px":"initial"},function(e){return e.floating?"32px":"initial"},function(e){return e.width},function(e){return e.opened?"scale(1)":"scale(0)"},function(e){return e.floating?"0":""});s.defaultProps={theme:c.default},t.default=s},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  height: 400px;\n  overflow-y: scroll;\n  margin-top: 2px;\n  padding-top: 6px;\n\n  @media screen and (max-width: 568px) {\n    height: ",";\n  }\n"],["\n  height: 400px;\n  overflow-y: scroll;\n  margin-top: 2px;\n  padding-top: 6px;\n\n  @media screen and (max-width: 568px) {\n    height: ",";\n  }\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.div(r,function(e){return e.floating?"calc(100% - 112px)":""});t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  align-items: center;\n  background: ",";\n  color: ",";\n  display: flex;\n  fill: ",";\n  height: 56px;\n  justify-content: space-between;\n  padding: 0 10px;\n"],["\n  align-items: center;\n  background: ",";\n  color: ",";\n  display: flex;\n  fill: ",";\n  height: 56px;\n  justify-content: space-between;\n  padding: 0 10px;\n"]),i=n(0),u=r(i),a=n(4),c=r(a),s=u.default.div(o,function(e){return e.theme.headerBgColor},function(e){return e.theme.headerFontColor},function(e){return e.theme.headerFontColor});s.defaultProps={theme:c.default},t.default=s},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  margin: 0;\n  font-size:",";\n"],["\n  margin: 0;\n  font-size:",";\n"]),i=n(0),u=r(i),a=n(4),c=r(a),s=u.default.h2(o,function(e){return e.theme.headerFontSize});s.defaultProps={theme:c.default},t.default=s},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  cursor: pointer;\n"],["\n  cursor: pointer;\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.a(r);t.default=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  align-items: center;\n  cursor: pointer;\n  background: ",";\n  bottom: 32px;\n  border-radius: 100%;\n  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.15);\n  display: flex;\n  fill: ",";\n  height: 56px;\n  justify-content: center;\n  position: fixed;\n  right: 32px;\n  transform: ",";\n  transition: transform .3s ease;\n  width: 56px;\n  z-index: 999;\n"],["\n  align-items: center;\n  cursor: pointer;\n  background: ",";\n  bottom: 32px;\n  border-radius: 100%;\n  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.15);\n  display: flex;\n  fill: ",";\n  height: 56px;\n  justify-content: center;\n  position: fixed;\n  right: 32px;\n  transform: ",";\n  transition: transform .3s ease;\n  width: 56px;\n  z-index: 999;\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.a(r,function(e){return e.theme.headerBgColor},function(e){return e.theme.headerFontColor},function(e){return e.opened?"scale(0)":"scale(1)"});u.defaultProps={theme:{headerBgColor:"#6e48aa",headerFontColor:"#fff"}},t.default=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  position: relative;\n"],["\n  position: relative;\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=i.default.div(r);t.default=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  animation: ",";\n  border: 0;\n  border-radius: 0;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top: ",";\n  box-shadow: ",";\n  box-sizing: border-box;\n  color: ",";\n  font-size: 14px;\n  opacity: ",";\n  outline: none;\n  padding: ",";\n  width: 100%;\n  -webkit-appearance: none;\n\n  &:disabled { background: #fff; }\n\n  @media screen and (max-width: 568px) {\n    border-bottom-left-radius: ",";\n    border-bottom-right-radius: ",";\n  }\n"],["\n  animation: ",";\n  border: 0;\n  border-radius: 0;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top: ",";\n  box-shadow: ",";\n  box-sizing: border-box;\n  color: ",";\n  font-size: 14px;\n  opacity: ",";\n  outline: none;\n  padding: ",";\n  width: 100%;\n  -webkit-appearance: none;\n\n  &:disabled { background: #fff; }\n\n  @media screen and (max-width: 568px) {\n    border-bottom-left-radius: ",";\n    border-bottom-right-radius: ",";\n  }\n"]),o=n(0),i=function(e){return e&&e.__esModule?e:{default:e}}(o),u=n(3),a=i.default.input(r,function(e){return e.invalid?u.invalidInput+" .2s ease":""},function(e){return e.invalid?"0":"1px solid #eee"},function(e){return e.invalid?"inset 0 0 2px #E53935":"none"},function(e){return e.invalid?"#E53935":""},function(e){return e.disabled&&!e.invalid?".5":"1"},function(e){return e.hasButton?"16px 52px 16px 10px":"16px 10px"},function(e){return e.floating?"0":"10px"},function(e){return e.floating?"0":"10px"});t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=function(e,t){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  background-color: transparent;\n  border: 0;\n  border-bottom-right-radius: 10px;\n  box-shadow: none;\n  cursor: ",";\n  fill: ",";\n  opacity: ",";\n  outline: none;\n  padding: 14px 16px 12px 16px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  &:before {\n    content: '';\n    position: absolute;\n    width: 23px;\n    height: 23px;\n    border-radius: 50%;\n    animation: ",";\n  }\n  &:not(:disabled):hover {\n    opacity: 0.7;\n  }\n"],["\n  background-color: transparent;\n  border: 0;\n  border-bottom-right-radius: 10px;\n  box-shadow: none;\n  cursor: ",";\n  fill: ",";\n  opacity: ",";\n  outline: none;\n  padding: 14px 16px 12px 16px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  &:before {\n    content: '';\n    position: absolute;\n    width: 23px;\n    height: 23px;\n    border-radius: 50%;\n    animation: ",";\n  }\n  &:not(:disabled):hover {\n    opacity: 0.7;\n  }\n"]),i=n(0),u=r(i),a=n(4),c=r(a),s=n(3),l=function(e){var t=e.speaking,n=e.invalid,r=e.theme;return t?r.headerBgColor:n?"#E53935":"#4a4a4a"},f=u.default.button(o,function(e){return e.disabled?"default":"pointer"},l,function(e){return e.disabled&&!e.invalid?".5":"1"},function(e){var t=e.theme;return e.speaking?(0,s.pulse)(t.headerBgColor)+" 2s ease infinite":""});f.defaultProps={theme:c.default},t.default=f},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=null,u=function(){},a=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:u,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"en";return r(this,e),i||(i=this),this.state={inputValue:"",lang:a,onChange:t,onEnd:n,onStop:o},this.onResult=this.onResult.bind(this),this.onEnd=this.onEnd.bind(this),this.setup(),i}return o(e,null,[{key:"isSupported",value:function(){return"webkitSpeechRecognition"in window}}]),o(e,[{key:"onChange",value:function(e){var t=this.state.onChange;this.setState({inputValue:e}),t(e)}},{key:"onFinal",value:function(e){this.setState({inputValue:e}),this.recognition.stop()}},{key:"onEnd",value:function(){var e=this.state,t=e.onStop,n=e.onEnd,r=e.force;this.setState({speaking:!1}),r?t():n()}},{key:"onResult",value:function(e){for(var t="",n="",r=e.resultIndex;r<e.results.length;++r)e.results[r].isFinal?(n+=e.results[r][0].transcript,this.onFinal(n)):(t+=e.results[r][0].transcript,this.onChange(t))}},{key:"setState",value:function(e){this.state=Object.assign({},this.state,e)}},{key:"setup",value:function(){return e.isSupported()?(this.recognition=new window.webkitSpeechRecognition,this.recognition.continuous=!0,this.recognition.interimResults=!0,this.recognition.lang=this.state.lang,this.recognition.onresult=this.onResult,this.recognition.onend=this.onEnd,this):this}},{key:"setLang",value:function(e){return this.setState({lang:e}),this.setup(),this}},{key:"speak",value:function(){return e.isSupported()?(this.state.speaking?(this.setState({force:!0}),this.recognition.stop()):(this.recognition.start(),this.setState({speaking:!0,inputValue:""})),this):this}}]),e}();t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.MicIcon=t.SubmitIcon=t.CloseIcon=t.ChatIcon=void 0;var o=n(60),i=r(o),u=n(61),a=r(u),c=n(62),s=r(c),l=n(63),f=r(l);t.ChatIcon=i.default,t.CloseIcon=a.default,t.SubmitIcon=s.default,t.MicIcon=f.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(){return o.default.createElement("svg",{height:"24",viewBox:"0 0 24 24",width:"24",xmlns:"http://www.w3.org/2000/svg"},o.default.createElement("path",{d:"M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"}),o.default.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))};t.default=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(){return o.default.createElement("svg",{height:"24",viewBox:"0 0 24 24",width:"24",xmlns:"http://www.w3.org/2000/svg"},o.default.createElement("path",{d:"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}),o.default.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}))};t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),u=n(2),a=r(u),c=function(e){return i.default.createElement("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",width:e.size,height:e.size,viewBox:"0 0 500 500"},i.default.createElement("g",null,i.default.createElement("g",null,i.default.createElement("polygon",{points:"0,497.25 535.5,267.75 0,38.25 0,216.75 382.5,267.75 0,318.75"}))))};c.propTypes={size:a.default.number},c.defaultProps={size:20},t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1),i=r(o),u=n(2),a=r(u),c=function(e){return i.default.createElement("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",width:e.size,height:e.size,viewBox:"0 0 400 400"},i.default.createElement("g",null,i.default.createElement("path",{d:"M290.991,240.991c0,26.392-21.602,47.999-48.002,47.999h-11.529c-26.4,0-48.002-21.607-48.002-47.999V104.002   c0-26.4,21.602-48.004,48.002-48.004h11.529c26.4,0,48.002,21.604,48.002,48.004V240.991z"}),i.default.createElement("path",{d:"M342.381,209.85h-8.961c-4.932,0-8.961,4.034-8.961,8.961v8.008c0,50.26-37.109,91.001-87.361,91.001   c-50.26,0-87.109-40.741-87.109-91.001v-8.008c0-4.927-4.029-8.961-8.961-8.961h-8.961c-4.924,0-8.961,4.034-8.961,8.961v8.008   c0,58.862,40.229,107.625,96.07,116.362v36.966h-34.412c-4.932,0-8.961,4.039-8.961,8.971v17.922c0,4.923,4.029,8.961,8.961,8.961   h104.688c4.926,0,8.961-4.038,8.961-8.961v-17.922c0-4.932-4.035-8.971-8.961-8.971h-34.43v-36.966   c55.889-8.729,96.32-57.5,96.32-116.362v-8.008C351.342,213.884,347.303,209.85,342.381,209.85z"})))};c.propTypes={size:a.default.number},c.defaultProps={size:20},t.default=c}])});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLocalhost; });
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||window.location.hostname==='fakin-chat.firebaseapp.com'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(13);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(45)();
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectMessage */
/* harmony export (immutable) */ __webpack_exports__["d"] = GetRandomMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = GetMessageByName;
/* harmony export (immutable) */ __webpack_exports__["b"] = GetRandomAnswer;
/* harmony export (immutable) */ __webpack_exports__["c"] = GetRandomQuestion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Messages__ = __webpack_require__(51);
function SelectMessage(key,index){return __WEBPACK_IMPORTED_MODULE_0__Messages__["a" /* default */][key][index];}function GetRandomMessage(key){var MessageArray=__WEBPACK_IMPORTED_MODULE_0__Messages__["a" /* default */][key];return MessageArray[Math.floor(Math.random()*MessageArray.length)];}function GetMessageByName(key,name){return __WEBPACK_IMPORTED_MODULE_0__Messages__["a" /* default */][key][name];}function GetRandomAnswer(key,option){var MessageArray=__WEBPACK_IMPORTED_MODULE_0__Messages__["a" /* default */][key]['answers'][option];return MessageArray[Math.floor(Math.random()*MessageArray.length)];}function GetRandomQuestion(key){var MessageArray=__WEBPACK_IMPORTED_MODULE_0__Messages__["a" /* default */][key]['questions'];return MessageArray[Math.floor(Math.random()*MessageArray.length)];}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(11);
module.exports = __webpack_require__(17);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(12).enable();
  window.Promise = __webpack_require__(15);
}

// fetch() polyfill for making API calls.
__webpack_require__(16);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(1);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(7);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(7);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__ = __webpack_require__(6);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(1),n=__webpack_require__(2),p=__webpack_require__(3),q=__webpack_require__(4),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(20);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(2),ea=__webpack_require__(0),m=__webpack_require__(21),A=__webpack_require__(1),C=__webpack_require__(4),fa=__webpack_require__(22),ha=__webpack_require__(23),ja=__webpack_require__(24),ka=__webpack_require__(3);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(25);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(26);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_json_pretty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_json_pretty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_json_pretty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_logo_png__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_bot_alice_png__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_bot_alice_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_bot_alice_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_bot_barbie_png__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_bot_barbie_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_bot_barbie_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_bot_dalibor_png__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_bot_dalibor_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_bot_dalibor_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_bot_petr_png__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_bot_petr_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_bot_petr_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_og_image_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_og_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_og_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_simple_chatbot__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_simple_chatbot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_simple_chatbot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_components__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DynamicQuestion__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_BookDescription__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__registerServiceWorker__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var identities=[{name:'petr',color:'#9900FF',avatar:__WEBPACK_IMPORTED_MODULE_7__static_bot_petr_png___default.a},{name:'alice',color:'#f15668',avatar:__WEBPACK_IMPORTED_MODULE_4__static_bot_alice_png___default.a},{name:'barbie',color:'#009900',avatar:__WEBPACK_IMPORTED_MODULE_5__static_bot_barbie_png___default.a},{name:'dalibor',color:'#0099FF',avatar:__WEBPACK_IMPORTED_MODULE_6__static_bot_dalibor_png___default.a}];var identity=identities[Math.floor(Math.random()*identities.length)];var SayHi=Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["a" /* GetMessageByName */])('SayHi',identity.name);var SayHi2=Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["d" /* default */])('SayHi2');var SayHi3=Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["d" /* default */])('SayHi3');var SayHi4=Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["d" /* default */])('SayHi4');console.log(SayHi);var stepsWithState=function stepsWithState(state){var time=__WEBPACK_IMPORTED_MODULE_16__registerServiceWorker__["b" /* isLocalhost */]?0:70;return[{id:'SayHi',message:SayHi,delay:SayHi.length*time,trigger:'SayHi2'},{id:'SayHi2',message:SayHi2,delay:SayHi2.length*time,trigger:'ask1'},{id:'SayHi3',message:SayHi3,delay:SayHi3.length*time,trigger:'SayHi4'},{id:'SayHi4',message:SayHi4,delay:SayHi4.length*time,trigger:'loop'},{id:'ask1',options:[{value:1,label:Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["d" /* default */])('yes1'),trigger:'SayHi3'},{value:0,label:Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["d" /* default */])('no1'),trigger:'loop'}]},{id:'dummy',message:Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["d" /* default */])('dummy'),end:true},{id:'loop',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_DynamicQuestion__["a" /* default */],state),replace:true,delay:0,waitAction:true,asMessage:true,trigger:'loop'},{id:'showMessage',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Message__["a" /* default */],{messages:state.messages}),asMessage:true,waitAction:true,delay:0,trigger:'loop'},{id:'showMessageEnd',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Message__["a" /* default */],{messages:state.messages}),asMessage:true,trigger:'loop'//end: true,
},{id:'showBook',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Book__["a" /* default */],{books:state.books}),asMessage:false,trigger:'loop'},{id:'showBookDescription',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_BookDescription__["a" /* default */],{books:state.books}),asMessage:false,trigger:'loop'},{id:'Actionweights',options:[{value:0,label:'Téma',trigger:'loop'},{value:1,label:'Žánr',trigger:'loop'},{value:1,label:'Jak se u knihy cítím',trigger:'loop'},{value:2,label:'Počet stran',trigger:'loop'}]},{id:'Actionpages',options:[{value:1,label:Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["b" /* GetRandomAnswer */])('pages','true'),trigger:'loop'},{value:0,label:Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["b" /* GetRandomAnswer */])('pages','false'),trigger:'loop'}]},{id:'Actionend',options:[{value:2,label:'Chci více o knize',trigger:'loop'},{value:0,label:'Tato kniha se mi nelíbí',trigger:'loop'},{value:1,label:'Začít znovu',trigger:'loop'}]},{id:'ActionendReload',options:[{value:2,label:'Chci více o knize',trigger:'loop'},{value:1,label:'Začít znovu',trigger:'loop'}]},{id:'ActionendNoDetail',options:[{value:0,label:'Tato kniha se mi nelíbí',trigger:'loop'},{value:1,label:'Začít znovu',trigger:'loop'}]},{id:'ActionendReloadNoDetail',options:[{value:1,label:'Začít znovu',trigger:'loop'}]},{id:'Actiontype',options:[{value:0,label:'Próza',trigger:'loop'},{value:1,label:'Drama',trigger:'loop'},{value:2,label:'Poezie',trigger:'loop'}]},{id:'Actiontheme',options:[{value:0,label:'Život',trigger:'loop'},{value:1,label:'Příroda',trigger:'loop'},{value:2,label:'Válka',trigger:'loop'},{value:3,label:'Volnočasové aktivity',trigger:'loop'},{value:4,label:'Komunismus',trigger:'loop'},{value:5,label:'Náboženství',trigger:'loop'}]},{id:'ActionProzacategory',options:[{value:0,label:'Historický román',trigger:'loop'},{value:1,label:'Román',trigger:'loop'},{value:2,label:'Humoristický román',trigger:'loop'},{value:4,label:'Naučná literatura',trigger:'loop'},{value:6,label:'Literatura pro děti',trigger:'loop'},{value:7,label:'Pohádky',trigger:'loop'},{value:8,label:'Biografický román',trigger:'loop'},{value:9,label:'Deníky',trigger:'loop'},{value:10,label:'Povídky',trigger:'loop'},{value:12,label:'Novela',trigger:'loop'},{value:14,label:'Duchovní literatura',trigger:'loop'}]},{id:'ActionDramacategory',options:[{value:3,label:'Komedie',trigger:'loop'},{value:11,label:'Absurdní drama',trigger:'loop'},{value:13,label:'Tragédie',trigger:'loop'}]},{id:'Actionmood',options:[{value:1,label:Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["d" /* default */])('moodHappy'),trigger:'loop'},{value:2,label:'Smutné',trigger:'loop'},{value:0,label:'Něco mezi',trigger:'loop'}]},{id:'Actionimages',options:[{value:0,label:Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["b" /* GetRandomAnswer */])('images','true'),trigger:'loop'},{value:1,label:Object(__WEBPACK_IMPORTED_MODULE_15__lib_MessagesHelper__["b" /* GetRandomAnswer */])('images','false'),trigger:'loop'}]}];};var theme={background:'#f5f8fb',fontFamily:'-apple-system,BlinkMacSystemFont,Segoe UI,Roboto Oxygen-Sans,Ubuntu,Cantarell,“Fira Sans”,“Droid Sans”,Helvetica Neue,Helvetica,Hiragino Kaku Gothic Pro,Meiryo,Arial,sans-serif',headerBgColor:'#EF6C00',headerFontColor:'#fff',headerFontSize:'16px',botBubbleColor:identity.color,botFontColor:'#fff',userBubbleColor:'#fff',userFontColor:'#000'};var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={features:{pages:null,type:null,theme:null,category:null,mood:null,images:null},isDetail:true,end:0,currentContext:'',waitAnswer:false,messages:[],books:[],actions:{setState:function setState(obj){return _this.setState(obj);},getState:_this.getState.bind(_this)}};return _this;}_createClass(App,[{key:'getState',value:function getState(name){return this.state[name];}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BotWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_styled_components__["a" /* ThemeProvider */],{theme:theme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_simple_chatbot___default.a,{bubbleStyle:{lineHeight:1.25,fontSize:'16px',padding:'8px 12px'},style:{boxShadow:'none',width:'100%',borderRadius:0},hideHeader:true,footerStyle:{display:'none'},hideUserAvatar:true,botAvatar:identity.avatar,avatarStyle:{"WebkitAnimation":"Lmuha .3s ease forwards","animation":"Lmuha .3s ease forwards","borderRadius":"50%","boxShadow":"none","height":"40px","float":"left","border":"1px solid #eff0f1","background":"#fff","minWidth":"40px","padding":"2px","WebkitTransform":"scale(0)","MsTransform":"scale(0)","transform":"scale(0)","WebkitTransformOrigin":"bottom right","MsTransformOrigin":"bottom right","transformOrigin":"bottom right","fontFamily":"sans-serif","letterSpacing":"0.5px"},userDelay:0,botDelay:__WEBPACK_IMPORTED_MODULE_16__registerServiceWorker__["b" /* isLocalhost */]?0:1000,steps:stepsWithState(this.state)}))),__WEBPACK_IMPORTED_MODULE_16__registerServiceWorker__["b" /* isLocalhost */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_json_pretty___default.a,{style:{resize:'horizontal',background:'#000',color:'#fff',padding:0,position:'fixed',width:300,zIndex:10000,top:0,margin:0,left:0,bottom:0,overflow:'auto'},json:this.state}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable no-unused-vars */
var React = __webpack_require__(0);
/* eslint-enable no-unused-vars */
var createReactClass = __webpack_require__(30);

module.exports = createReactClass({
  displayName: 'exports',

  // 格式化函数
  _replace: function _replace(match, ind, key, val, tra) {
    var spanEnd = '</span>';
    var keySpan = '<span class=json-key>';
    var valSpan = '<span class=json-value>';
    var strSpan = '<span class=json-string>';
    var booSpan = '<span class=json-boolean>';
    var sps = ind || '';
    if (key) {
      sps = sps + '"' + keySpan + key.replace(/^"|":\s$/g, '') + spanEnd + '": ';
    }

    if (val) {
      if (val === 'true' || val === 'false') {
        sps = sps + booSpan + val + spanEnd;
      } else {
        sps = sps + (val[0] == '"' ? strSpan : valSpan) + val + spanEnd;
      }
    }

    return sps + (tra || '');
  },
  // JSON =》 HTML转换器
  _pretty: function _pretty(obj, replacer, space) {
    // 逐行匹配，列举：“key”: "value" | "key": value | "key": [ | "key": { | "key": [],| "Key": {},
    var regLine = /^( *)("[^"]+": )?("[^"]*"|[\w.+-]*)?([,[{]|\[\s*\],?|\{\s*\},?)?$/mg;
    var text = JSON.stringify(obj, typeof replacer === 'function' ? replacer : null, isNaN(space) ? 2 : space);

    if (!text) {
      return text;
    }

    return text.replace(/&/g, '&amp;').replace(/\\"([^,])/g, '&quot;$1').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(regLine, this._replace);
  },
  render: function render() {

    // See https://facebook.github.io/react/warnings/unknown-prop.html
    var _props = this.props,
        json = _props.json,
        replacer = _props.replacer,
        space = _props.space,
        className = _props.className,
        themeClassName = _props.themeClassName,
        rest = _objectWithoutProperties(_props, ['json', 'replacer', 'space', 'className', 'themeClassName']);

    themeClassName = themeClassName ? themeClassName.trim() : themeClassName;
    className = className ? className.trim() : className;
    var themeClassNameFinal = themeClassName || 'json-pretty';
    var classNameFinal = className ? className + ' ' + themeClassNameFinal : themeClassNameFinal;

    if (typeof json === 'string') {
      try {
        json = JSON.parse(json);
      } catch (e) {
        console.error('The string is not a valid json data!', e);
        return React.createElement('pre', _extends({}, rest, { className: classNameFinal || 'json-pretty', dangerouslySetInnerHTML: { __html: json } }));
      }
    }

    return React.createElement('pre', _extends({}, rest, { className: classNameFinal || 'json-pretty', dangerouslySetInnerHTML: { __html: this._pretty(json, replacer, +space) } }));
  }
});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(31);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(1);

var emptyObject = __webpack_require__(3);
var _invariant = __webpack_require__(2);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bot-alice.88a335fb.png";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bot-barbie.0a7ca2a2.png";

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/og-image.a1a71fc9.png";

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* unused harmony export css */
/* unused harmony export keyframes */
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeProvider; });
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);








/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

// 
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      return [].concat(ruleSet, flatten(chunk, executionContext));
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    return ruleSet.concat(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

// 
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

// 
var css = (function (strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  return flatten(interleave(strings, interpolations));
});

var stream = {}

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof false === 'boolean' && false || "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new Error();
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i >= lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 
/* eslint-disable flowtype/object-type-delimiter */
/* eslint-disable react/prop-types */

/* this error is used for makeStyleTag */
var parentNodeUnmountedErr =  false ? '\nTrying to insert a new style tag, but the given Node is unmounted!\n- Are you using a custom target that isn\'t mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n'.trim() : '';

/* this error is used for tags */
var throwCloneTagErr = function throwCloneTagErr() {
  throw new Error( false ? '\nThe clone method cannot be used on the client!\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n'.trim() : '');
};

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new Error(parentNodeUnmountedErr);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    var marker = markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);
    return marker;
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    styleTag: el,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: throwCloneTagErr
  };
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;
  var makeTextNode = function makeTextNode(id) {
    return document.createTextNode(makeTextMarker(id));
  };

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    var marker = markers[id] = makeTextNode(id);
    el.appendChild(marker);
    names[id] = Object.create(null);
    return marker;
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    styleTag: el,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: throwCloneTagErr
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    styleTag: null,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: clone
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);
    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, names, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0; i < extracted.length; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0; _i < els.length; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    this.id = sheetRunningId += 1;
    this.sealed = false;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var names = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      isStreamed = !!el.getAttribute(SC_STREAM_ATTR) || isStreamed;

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(/\s+/);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
        names.push(name);
      }

      /* extract all components and their CSS */
      extracted = extracted.concat(extractComps(el.textContent));
      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, names, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);
    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;
    this.sealed = true;
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !this.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;
    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      this.sealed = false;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    /* add deferred rules for component */
    var injectRules = cssRules;
    var deferredRules = this.deferred[id];
    if (deferredRules !== undefined) {
      injectRules = deferredRules.concat(injectRules);
      delete this.deferred[id];
    }

    var tag = this.getTagForId(id);
    tag.insertRules(id, injectRules, name);
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    delete this.deferred[id];
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

// 
/* this error is used for makeStyleTag */
var targetPropErr =  false ? '\nThe StyleSheetManager expects a valid target or sheet prop!\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n'.trim() : '';

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new Error(targetPropErr);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);

 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 
/* eslint-disable no-underscore-dangle */
/* this error is used for makeStyleTag */
var sheetClosedErr =  false ? '\nCan\'t collect styles once you\'ve consumed a ServerStyleSheet\'s styles!\nServerStyleSheet is a one off instance for each server-side render cycle.\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n'.trim() : '';

var streamBrowserErr =  false ? 'Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.' : '';

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new Error(sheetClosedErr);
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new Error(streamBrowserErr);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';
    var ourStream = new stream.Readable();
    // $FlowFixMe
    ourStream._read = function () {};

    readableStream.on('data', function (chunk) {
      var tags = instance.tags;

      var html = '';

      /* retrieve html for each new style tag */
      for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
        var tag = tags[instanceTagIndex];
        html += tag.toHTML(streamAttr);
      }

      /* force our StyleSheets to emit entirely new tags */
      instance.sealAllTags();
      /* prepend style html to chunk */
      ourStream.push(html + chunk);
    });

    readableStream.on('end', function () {
      _this.complete();
      ourStream.push(null);
    });

    readableStream.on('error', function (err) {
      _this.complete();
      ourStream.emit('error', err);
    });

    return ourStream;
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 **/
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur|Invalid)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur|Invalid)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _ThemeProvider$childC;
var _ThemeProvider$contex;

// 
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (false) {
        throw new Error(process.env.NODE_ENV !== 'production' ? '[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!' : '');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error( false ? '[ThemeProvider] Please make your theme prop a plain object' : '');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

// 

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var identifiers = {};

  /* We depend on components having unique IDs */
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

    var componentId = void 0;

    /**
     * only fall back to hashing the component injection order if
     * a proper displayName isn't provided by the babel plugin
     */
    if (!_displayName) {
      var nr = (identifiers[displayName] || 0) + 1;
      identifiers[displayName] = nr;

      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    } else {
      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
    }

    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          attrs = _constructor.attrs,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

      // staticaly styled-components don't need to build an execution context object,
      // and shouldn't be increasing the number of class names
      if (componentStyle.isStatic && attrs === undefined) {
        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
      } else {
        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

        if (false) {
          warnTooManyClasses(className);
        }

        return className;
      }
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var componentStyle = this.constructor.componentStyle;

      var styledContext = this.context[CHANNEL_NEXT];

      // If this is a staticaly-styled component, we don't need to the theme
      // to generate or build styles.
      if (componentStyle.isStatic) {
        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
        this.setState({ generatedClassName: generatedClassName });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
      } else if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately
          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: _generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // If this is a statically-styled component, we don't need to listen to
      // props changes to update styles
      var componentStyle = this.constructor.componentStyle;

      if (componentStyle.isStatic) {
        return;
      }

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, _this3.constructor.defaultProps);
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 
var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (typeof value === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHRMEnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHRMEnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        var css = stringifyRules(flatCSS, '.' + name);
        styleSheet.inject(this.componentId, css, name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 
var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 
var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isValidElementType"])(tag)) {
      throw new Error( false ? 'Cannot create styled-component for component: ' + String(tag) : '');
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes you application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);


/* unused harmony default export */ var _unused_webpack_default_export = (styled);
//# sourceMappingURL=styled-components.browser.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39), __webpack_require__(40)(module)))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(42);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 169 /* <at>i */
	var CHARSET = 163 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							code = body.charCodeAt(caret)

							switch (code) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first + second) {
								case NULL: {
									break
								}
								case IMPORT:
								case CHARSET: {
									flat += chars + body.charAt(caret)
									break
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON)
										break

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				return out.charCodeAt(8) === DASH ? webkit + out + out : out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(4);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(46);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(48);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-is.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol["for"],c=b?Symbol["for"]("react.element"):60103,d=b?Symbol["for"]("react.portal"):60106,e=b?Symbol["for"]("react.fragment"):60107,f=b?Symbol["for"]("react.strict_mode"):60108,g=b?Symbol["for"]("react.provider"):60109,h=b?Symbol["for"]("react.context"):60110,k=b?Symbol["for"]("react.async_mode"):60111,l=b?Symbol["for"]("react.forward_ref"):60112;
function m(a){if("object"===typeof a&&null!==a){var n=a.$$typeof;switch(n){case c:switch(a=a.type,a){case k:case e:case f:return a;default:switch(a=a&&a.$$typeof,a){case h:case l:case g:return a;default:return n}}case d:return n}}}exports.typeOf=m;exports.AsyncMode=k;exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=c;exports.ForwardRef=l;exports.Fragment=e;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===k||a===f||"object"===typeof a&&null!==a&&(a.$$typeof===g||a.$$typeof===h||a.$$typeof===l)};exports.isAsyncMode=function(a){return m(a)===k};exports.isContextConsumer=function(a){return m(a)===h};exports.isContextProvider=function(a){return m(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return m(a)===l};
exports.isFragment=function(a){return m(a)===e};exports.isPortal=function(a){return m(a)===d};exports.isStrictMode=function(a){return m(a)===f};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_simple_chatbot__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_simple_chatbot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_simple_chatbot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_MessagesHelper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_Recommend__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DynamicQuestion=function(_Component){_inherits(DynamicQuestion,_Component);function DynamicQuestion(props){_classCallCheck(this,DynamicQuestion);var _this=_possibleConstructorReturn(this,(DynamicQuestion.__proto__||Object.getPrototypeOf(DynamicQuestion)).call(this,props));_this.state={loading:true,result:'',trigger:false,steps:{}};_this.setThatState=_this.props.actions.setState;// console.log('triggered: DynamicQuestion');
// console.log('previousStep:', props.previousStep);
// console.log(this.props.actions);
_this.setNextMessage=_this.setNextMessage.bind(_this);_this.setNextAction=_this.setNextAction.bind(_this);_this.setRecommendaiton=_this.setRecommendaiton.bind(_this);_this.setBookDescription=_this.setBookDescription.bind(_this);_this.messageController=_this.messageController.bind(_this);return _this;}_createClass(DynamicQuestion,[{key:'messageController',value:function messageController(){var _this2=this;var actions=this.props.actions;var setState=actions.setState,getState=actions.getState;var features=getState('features');var ask1Value=this.props.steps['ask1'].value;if(ask1Value===0){features={pages:this.getRandomBetween(1),type:this.getRandomBetween(2),theme:this.getRandomBetween(5),category:this.getRandomBetween(14),mood:this.getRandomBetween(2),images:this.getRandomBetween(1)};setState({features:features});}else{}var featureKey='';var featureActionKey='';var waitAnswer=getState('waitAnswer');var isDetail=getState('isDetail');var currentContext=getState('currentContext');var end=getState('end');var books=getState('books');var nullFeatures=[];nullFeatures=this.validateFeatures(features);if(currentContext==='category'){switch(features.type){case 0:featureActionKey='Proza';break;default:featureActionKey='Drama';}}// think of this „if, else if“ block below as messages router
// if not waiting for answer
if(!waitAnswer&&currentContext===''&&nullFeatures.length>0){if(features.type===null){featureKey=this.getRandomFeature(nullFeatures.filter(function(item){return item!=='category';}));}else{featureKey=this.getRandomFeature(nullFeatures);}setState({features:features,currentContext:featureKey,waitAnswer:true});this.setNextMessage(Object(__WEBPACK_IMPORTED_MODULE_3__lib_MessagesHelper__["c" /* GetRandomQuestion */])(featureKey));}else if(currentContext!==''&&waitAnswer){// next action
featureKey=featureActionKey+currentContext;setState({waitAnswer:false});this.setNextAction(featureKey);}else if(currentContext!==''&&!waitAnswer){// get value from last action
var key='Action'+featureActionKey+currentContext;var lastValue=this.props.steps[key].value;// if poezie
if(currentContext==='type'&&lastValue===2){features['category']=5;// based on books metadata
}features[currentContext]=lastValue;setState({currentContext:'',features:features});this.props.triggerNextStep();}else if(!waitAnswer&&nullFeatures.length===0){switch(end){case 0:var k=books.length;setTimeout(function(){var recommendation=Object(__WEBPACK_IMPORTED_MODULE_4__lib_Recommend__["a" /* default */])(features,k+1);recommendation.then(function(result){return _this2.setRecommendaiton(result);});},1500);if(k===0){setState({end:1,isDetail:true});}else{setState({end:2,isDetail:true});}break;case 1:if(books.length===1){if(ask1Value===0){this.setNextMessage(Object(__WEBPACK_IMPORTED_MODULE_3__lib_MessagesHelper__["d" /* default */])('endAlternate'));}else{this.setNextMessage(Object(__WEBPACK_IMPORTED_MODULE_3__lib_MessagesHelper__["d" /* default */])('end'));}}setState({end:5});break;case 5:this.setNextMessage(Object(__WEBPACK_IMPORTED_MODULE_3__lib_MessagesHelper__["d" /* default */])('endInfo'));setState({end:2});break;case 6:setState({end:3});if(books.length===3){this.setNextAction('endReloadNoDetail');}else{this.setNextAction('endNoDetail');}break;case 2:setState({end:3});if(books.length===3){this.setNextAction('endReload');}else{this.setNextAction('end');}break;case 3:var _lastValue=1;if(books.length===3){if(isDetail){_lastValue=this.props.steps['ActionendReload'].value;}else{_lastValue=this.props.steps['ActionendReloadNoDetail'].value;}}else{if(isDetail){_lastValue=this.props.steps['Actionend'].value;}else{_lastValue=this.props.steps['ActionendNoDetail'].value;}}switch(_lastValue){case 0:setState({end:0});this.props.triggerNextStep();break;case 1:window.location.reload();break;case 2:setState({end:6,isDetail:false});this.setBookDescription();break;}break;}}//this.setMessage(GetRandomMessage(featureKey));
}},{key:'validateFeatures',value:function validateFeatures(features){var arr=[];for(var key in features){if(features.hasOwnProperty(key)&&features[key]==null){arr.push(key);}}return arr;}},{key:'getRandomFeature',value:function getRandomFeature(features){return features[Math.floor(Math.random()*features.length)];}},{key:'setMessage',value:function setMessage(message){var messages=this.props.messages;messages.push(message);this.setThatState({messages:messages});this.setState({loading:false,result:message});}},{key:'setRecommendaiton',value:function setRecommendaiton(book){var books=this.props.books;books.push(book);this.setThatState({books:books});if(book){this.props.triggerNextStep({trigger:'showBook',value:null});}}},{key:'setBookDescription',value:function setBookDescription(){this.props.triggerNextStep({trigger:'showBookDescription',value:null});}},{key:'getRandomBetween',value:function getRandomBetween(max){return Math.floor(Math.random()*max);}},{key:'setNextMessage',value:function setNextMessage(message){var end=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var messages=this.props.messages;messages.push(message);this.setThatState({messages:messages});var nextStep=!end?'showMessage':'showMessageEnd';if(message){this.props.triggerNextStep({trigger:nextStep,value:null});}else{this.props.triggerNextStep();}}},{key:'setNextAction',value:function setNextAction(context){if(context){this.props.triggerNextStep({trigger:'Action'+context,value:null});}else{this.props.triggerNextStep();}}},{key:'componentDidMount',value:function componentDidMount(){this.messageController();}},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,result=_state.result;if(loading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_simple_chatbot__["Loading"],null);}else{return result;}}}]);return DynamicQuestion;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DynamicQuestion);DynamicQuestion.propTypes={steps:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,triggerNextStep:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,step:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,previousStep:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};DynamicQuestion.defaultProps={steps:undefined,triggerNextStep:undefined,step:undefined,previousStep:undefined};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({SayHi:{petr:'Dobrý den, já jsem robot Petr!',alice:'Ahoj, jsem robotka Alice :)',barbie:'Dobrý den! Jsem robotka Barbora :)',dalibor:'Zdravím Vás :) Jsem Dalibor.'},SayHi2:['Mohu Vám doporučit jednu z vystavených knih Knihovny Jiřího Mahena? Zabere to jen chvíli.','Mohu Vám pomoci s výběrem knihy z výstavy 100 let 100 knih? Zabere to jen chvíli :)'],yes1:['Určitě!','Ano, prosím!','Ano :)'],no1:['Ne, děkuji.','Ne.','Raději ne.'],moodHappy:['Veselé','Šťastné'],end:['Snad se Vám bude líbit :)','Přeji Vám příjemné čtení!','Užijte si knihu! :)'],endInfo:['Kniha je označena rokem vydání. Knihu tak na výstavě snadno najdete :)','Pomocí roku vydání knihu snadno najdete na výstavě 100 let 100 knih.'],endAlternate:['Nevadí :) tady stejně jednu máte.'],SayHi3:['Dobře tedy.','Dobře.'],SayHi4:['Položím Vám pár otázek. Podle Vašich odpovědí se pokusím najít knihu, která bude nejvíce odpovídat vašim preferencím.','Zeptám se Vás na několik otázek. Poté se pokusím najít knihu, která bude nejvíce odpovídat Vašim odpovědím.','Položím Vám několik dotazů a podle toho, jak odpovíte, se pokusím vybrat knihu.'],dummy:['Nevadí :(','Tak snad příště.','Dobře...'],mood:{questions:['Které knihy vyhledáváte?']},weights:{questions:['Co je pro tebe nejdůležitější?']},category:{questions:['Jaký žánr máte nejraději?']},theme:{questions:['Které z těchto témat Vás nějvíce zajímá?','Které z témat Vás nejvíce zajímá?']},images:{questions:['Upřednostňujete ilustrované knihy?'],answers:{true:['Ano.','Ano!'],false:['Ne','Raději bez obrázků.','Ani ne.']}},type:{questions:['Vyberte, co máte nejraději','Vyberte, co Vás zajímá.','Co je Vám blízké?']},pages:{questions:['Považujete se za častého čtenáře?'],answers:{true:['Ano.','Jistě!','Jo.'],false:['Ne.','Moc nečtu...','Čtu málo.']}}});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recommendation_data_json__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recommendation_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__recommendation_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_json__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_alike__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_alike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_alike__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* harmony default export */ __webpack_exports__["a"] = ((function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(features,k){var results,result,fullResult;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_3_alike___default()(features,__WEBPACK_IMPORTED_MODULE_1__recommendation_data_json___default.a,{k:k,weights:{id:0,pages:1/6,type:1/6,category:1/6,theme:1/6,mood:1/6,images:1/6}});case 3:results=_context.sent;result=results[k-1];fullResult=__WEBPACK_IMPORTED_MODULE_2__data_json___default.a.find(function(book){return book.id===result.id;});return _context.abrupt('return',fullResult);case 9:_context.prev=9;_context.t0=_context['catch'](0);console.log('recommendation failed:',_context.t0);case 12:case'end':return _context.stop();}}},_callee,this,[[0,9]]);}));function Recommend(_x,_x2){return _ref.apply(this,arguments);}return Recommend;})());

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(54);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(55);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"pages":0,"type":0,"category":0,"theme":0,"mood":0,"images":0},{"id":2,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":3,"pages":1,"type":0,"category":1,"theme":1,"mood":0,"images":0},{"id":3,"pages":1,"type":0,"category":1,"theme":0,"mood":0,"images":0},{"id":4,"pages":0,"type":0,"category":2,"theme":2,"mood":1,"images":0},{"id":5,"pages":1,"type":0,"category":2,"theme":3,"mood":1,"images":0},{"id":6,"pages":1,"type":1,"category":3,"theme":0,"mood":1,"images":1},{"id":7,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":0},{"id":7,"pages":0,"type":0,"category":1,"theme":3,"mood":0,"images":0},{"id":8,"pages":0,"type":0,"category":4,"theme":0,"mood":0,"images":1},{"id":8,"pages":0,"type":0,"category":4,"theme":2,"mood":0,"images":1},{"id":9,"pages":1,"type":0,"category":2,"theme":0,"mood":0,"images":0},{"id":10,"pages":1,"type":2,"category":5,"theme":0,"mood":2,"images":1},{"id":11,"pages":0,"type":0,"category":4,"theme":0,"mood":0,"images":0},{"id":12,"pages":1,"type":0,"category":6,"theme":3,"mood":1,"images":0},{"id":13,"pages":0,"type":0,"category":0,"theme":0,"mood":2,"images":1},{"id":13,"pages":0,"type":0,"category":0,"theme":2,"mood":2,"images":1},{"id":14,"pages":0,"type":0,"category":2,"theme":3,"mood":1,"images":0},{"id":15,"pages":1,"type":2,"category":5,"theme":2,"mood":2,"images":1},{"id":16,"pages":0,"type":0,"category":4,"theme":0,"mood":0,"images":1},{"id":16,"pages":0,"type":0,"category":4,"theme":2,"mood":0,"images":1},{"id":17,"pages":1,"type":0,"category":1,"theme":0,"mood":2,"images":1},{"id":18,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":19,"pages":1,"type":0,"category":6,"theme":1,"mood":1,"images":0},{"id":19,"pages":1,"type":0,"category":6,"theme":0,"mood":1,"images":0},{"id":19,"pages":1,"type":0,"category":7,"theme":1,"mood":1,"images":0},{"id":19,"pages":1,"type":0,"category":7,"theme":0,"mood":1,"images":0},{"id":20,"pages":1,"type":1,"category":5,"theme":0,"mood":0,"images":1},{"id":21,"pages":0,"type":0,"category":1,"theme":0,"mood":2,"images":1},{"id":22,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":0},{"id":22,"pages":0,"type":0,"category":8,"theme":0,"mood":0,"images":0},{"id":23,"pages":0,"type":0,"category":1,"theme":0,"mood":2,"images":1},{"id":24,"pages":1,"type":0,"category":1,"theme":3,"mood":1,"images":0},{"id":24,"pages":1,"type":0,"category":1,"theme":0,"mood":1,"images":0},{"id":24,"pages":1,"type":0,"category":6,"theme":3,"mood":1,"images":0},{"id":24,"pages":1,"type":0,"category":6,"theme":0,"mood":1,"images":0},{"id":25,"pages":0,"type":0,"category":2,"theme":0,"mood":1,"images":0},{"id":26,"pages":1,"type":2,"category":6,"theme":0,"mood":1,"images":0},{"id":26,"pages":1,"type":2,"category":6,"theme":3,"mood":1,"images":0},{"id":27,"pages":0,"type":0,"category":1,"theme":0,"mood":2,"images":1},{"id":28,"pages":0,"type":0,"category":1,"theme":2,"mood":2,"images":1},{"id":28,"pages":0,"type":0,"category":1,"theme":0,"mood":2,"images":1},{"id":29,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":0},{"id":29,"pages":0,"type":0,"category":1,"theme":3,"mood":0,"images":0},{"id":29,"pages":0,"type":0,"category":6,"theme":0,"mood":0,"images":0},{"id":29,"pages":0,"type":0,"category":6,"theme":3,"mood":0,"images":0},{"id":29,"pages":0,"type":0,"category":2,"theme":0,"mood":0,"images":0},{"id":29,"pages":0,"type":0,"category":2,"theme":3,"mood":0,"images":0},{"id":30,"pages":1,"type":0,"category":1,"theme":2,"mood":2,"images":1},{"id":30,"pages":1,"type":0,"category":1,"theme":0,"mood":2,"images":1},{"id":31,"pages":0,"type":0,"category":9,"theme":0,"mood":2,"images":1},{"id":32,"pages":1,"type":0,"category":9,"theme":0,"mood":0,"images":0},{"id":33,"pages":1,"type":2,"category":5,"theme":0,"mood":2,"images":0},{"id":34,"pages":1,"type":2,"category":5,"theme":2,"mood":2,"images":1},{"id":34,"pages":1,"type":2,"category":5,"theme":4,"mood":2,"images":1},{"id":35,"pages":1,"type":2,"category":5,"theme":0,"mood":1,"images":0},{"id":36,"pages":1,"type":2,"category":5,"theme":0,"mood":1,"images":0},{"id":37,"pages":0,"type":0,"category":1,"theme":3,"mood":0,"images":0},{"id":37,"pages":0,"type":0,"category":6,"theme":3,"mood":0,"images":0},{"id":37,"pages":0,"type":0,"category":0,"theme":3,"mood":0,"images":0},{"id":38,"pages":1,"type":0,"category":10,"theme":0,"mood":0,"images":0},{"id":39,"pages":1,"type":0,"category":6,"theme":0,"mood":1,"images":0},{"id":39,"pages":1,"type":0,"category":7,"theme":0,"mood":1,"images":0},{"id":40,"pages":0,"type":0,"category":1,"theme":2,"mood":0,"images":1},{"id":40,"pages":0,"type":0,"category":1,"theme":4,"mood":0,"images":1},{"id":40,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":41,"pages":1,"type":1,"category":5,"theme":0,"mood":1,"images":1},{"id":42,"pages":1,"type":0,"category":6,"theme":0,"mood":1,"images":0},{"id":42,"pages":1,"type":0,"category":7,"theme":0,"mood":1,"images":0},{"id":43,"pages":1,"type":2,"category":5,"theme":0,"mood":0,"images":0},{"id":44,"pages":1,"type":2,"category":5,"theme":0,"mood":0,"images":0},{"id":45,"pages":1,"type":1,"category":11,"theme":0,"mood":0,"images":1},{"id":46,"pages":1,"type":2,"category":5,"theme":0,"mood":2,"images":0},{"id":47,"pages":1,"type":2,"category":5,"theme":0,"mood":2,"images":0},{"id":48,"pages":1,"type":1,"category":11,"theme":0,"mood":0,"images":1},{"id":48,"pages":1,"type":1,"category":3,"theme":0,"mood":0,"images":1},{"id":49,"pages":0,"type":0,"category":1,"theme":4,"mood":2,"images":1},{"id":49,"pages":0,"type":0,"category":1,"theme":0,"mood":2,"images":1},{"id":50,"pages":1,"type":0,"category":4,"theme":4,"mood":2,"images":1},{"id":50,"pages":1,"type":0,"category":8,"theme":4,"mood":2,"images":1},{"id":50,"pages":1,"type":0,"category":9,"theme":4,"mood":2,"images":1},{"id":51,"pages":0,"type":0,"category":0,"theme":5,"mood":2,"images":0},{"id":52,"pages":1,"type":0,"category":6,"theme":0,"mood":1,"images":0},{"id":52,"pages":1,"type":0,"category":7,"theme":0,"mood":1,"images":0},{"id":53,"pages":1,"type":0,"category":10,"theme":2,"mood":0,"images":1},{"id":53,"pages":1,"type":0,"category":10,"theme":1,"mood":0,"images":1},{"id":54,"pages":0,"type":0,"category":1,"theme":4,"mood":2,"images":1},{"id":55,"pages":0,"type":0,"category":1,"theme":4,"mood":1,"images":1},{"id":56,"pages":0,"type":0,"category":1,"theme":0,"mood":1,"images":1},{"id":56,"pages":0,"type":0,"category":1,"theme":2,"mood":1,"images":1},{"id":56,"pages":0,"type":0,"category":1,"theme":4,"mood":1,"images":1},{"id":56,"pages":0,"type":0,"category":1,"theme":3,"mood":1,"images":1},{"id":57,"pages":0,"type":0,"category":1,"theme":2,"mood":2,"images":1},{"id":58,"pages":0,"type":0,"category":1,"theme":4,"mood":0,"images":1},{"id":58,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":59,"pages":1,"type":0,"category":0,"theme":5,"mood":2,"images":1},{"id":59,"pages":1,"type":0,"category":0,"theme":0,"mood":2,"images":1},{"id":59,"pages":1,"type":0,"category":12,"theme":5,"mood":2,"images":1},{"id":59,"pages":1,"type":0,"category":12,"theme":0,"mood":2,"images":1},{"id":60,"pages":1,"type":2,"category":5,"theme":0,"mood":2,"images":1},{"id":60,"pages":1,"type":2,"category":5,"theme":2,"mood":2,"images":1},{"id":61,"pages":0,"type":0,"category":1,"theme":2,"mood":2,"images":1},{"id":61,"pages":0,"type":0,"category":1,"theme":4,"mood":2,"images":1},{"id":61,"pages":0,"type":0,"category":8,"theme":2,"mood":2,"images":1},{"id":61,"pages":0,"type":0,"category":8,"theme":4,"mood":2,"images":1},{"id":62,"pages":0,"type":0,"category":4,"theme":4,"mood":0,"images":0},{"id":62,"pages":0,"type":0,"category":8,"theme":4,"mood":0,"images":0},{"id":62,"pages":0,"type":0,"category":9,"theme":4,"mood":0,"images":0},{"id":63,"pages":0,"type":0,"category":1,"theme":0,"mood":1,"images":1},{"id":64,"pages":1,"type":2,"category":5,"theme":0,"mood":2,"images":1},{"id":65,"pages":0,"type":0,"category":1,"theme":4,"mood":0,"images":1},{"id":65,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":66,"pages":1,"type":2,"category":5,"theme":4,"mood":0,"images":1},{"id":66,"pages":1,"type":2,"category":5,"theme":0,"mood":0,"images":1},{"id":67,"pages":1,"type":0,"category":10,"theme":0,"mood":1,"images":1},{"id":68,"pages":0,"type":0,"category":4,"theme":0,"mood":0,"images":1},{"id":68,"pages":0,"type":0,"category":4,"theme":4,"mood":0,"images":1},{"id":68,"pages":0,"type":0,"category":8,"theme":0,"mood":0,"images":1},{"id":68,"pages":0,"type":0,"category":8,"theme":4,"mood":0,"images":1},{"id":69,"pages":1,"type":1,"category":13,"theme":0,"mood":2,"images":1},{"id":69,"pages":1,"type":1,"category":13,"theme":4,"mood":2,"images":1},{"id":70,"pages":0,"type":0,"category":1,"theme":4,"mood":0,"images":1},{"id":71,"pages":1,"type":0,"category":12,"theme":2,"mood":2,"images":1},{"id":72,"pages":1,"type":2,"category":5,"theme":0,"mood":0,"images":1},{"id":73,"pages":0,"type":0,"category":9,"theme":0,"mood":0,"images":1},{"id":73,"pages":0,"type":0,"category":9,"theme":4,"mood":0,"images":1},{"id":74,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":75,"pages":0,"type":0,"category":1,"theme":4,"mood":0,"images":1},{"id":76,"pages":0,"type":0,"category":1,"theme":0,"mood":1,"images":1},{"id":76,"pages":0,"type":0,"category":1,"theme":4,"mood":1,"images":1},{"id":77,"pages":1,"type":0,"category":4,"theme":0,"mood":0,"images":1},{"id":78,"pages":0,"type":2,"category":5,"theme":0,"mood":0,"images":1},{"id":78,"pages":0,"type":2,"category":5,"theme":4,"mood":0,"images":1},{"id":79,"pages":1,"type":0,"category":2,"theme":4,"mood":1,"images":1},{"id":80,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":80,"pages":0,"type":0,"category":1,"theme":4,"mood":0,"images":1},{"id":80,"pages":0,"type":0,"category":8,"theme":0,"mood":0,"images":1},{"id":80,"pages":0,"type":0,"category":8,"theme":4,"mood":0,"images":1},{"id":81,"pages":0,"type":0,"category":4,"theme":0,"mood":0,"images":1},{"id":81,"pages":0,"type":0,"category":4,"theme":2,"mood":0,"images":1},{"id":81,"pages":0,"type":0,"category":4,"theme":4,"mood":0,"images":1},{"id":81,"pages":0,"type":0,"category":8,"theme":0,"mood":0,"images":1},{"id":81,"pages":0,"type":0,"category":8,"theme":2,"mood":0,"images":1},{"id":81,"pages":0,"type":0,"category":8,"theme":4,"mood":0,"images":1},{"id":82,"pages":0,"type":0,"category":10,"theme":0,"mood":2,"images":1},{"id":83,"pages":0,"type":0,"category":4,"theme":1,"mood":0,"images":0},{"id":84,"pages":0,"type":0,"category":1,"theme":5,"mood":0,"images":1},{"id":84,"pages":0,"type":0,"category":14,"theme":5,"mood":0,"images":1},{"id":85,"pages":0,"type":0,"category":0,"theme":4,"mood":0,"images":1},{"id":86,"pages":1,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":86,"pages":1,"type":0,"category":1,"theme":4,"mood":0,"images":1},{"id":87,"pages":1,"type":0,"category":14,"theme":5,"mood":0,"images":1},{"id":88,"pages":0,"type":0,"category":8,"theme":0,"mood":0,"images":1},{"id":88,"pages":0,"type":0,"category":8,"theme":4,"mood":0,"images":1},{"id":88,"pages":0,"type":0,"category":9,"theme":0,"mood":0,"images":1},{"id":88,"pages":0,"type":0,"category":9,"theme":4,"mood":0,"images":1},{"id":89,"pages":0,"type":0,"category":4,"theme":0,"mood":2,"images":1},{"id":89,"pages":0,"type":0,"category":8,"theme":0,"mood":2,"images":1},{"id":90,"pages":0,"type":0,"category":6,"theme":0,"mood":1,"images":0},{"id":90,"pages":0,"type":0,"category":7,"theme":0,"mood":1,"images":0},{"id":91,"pages":0,"type":0,"category":0,"theme":2,"mood":2,"images":1},{"id":91,"pages":0,"type":0,"category":0,"theme":0,"mood":2,"images":1},{"id":92,"pages":0,"type":0,"category":4,"theme":4,"mood":2,"images":1},{"id":92,"pages":0,"type":0,"category":4,"theme":5,"mood":2,"images":1},{"id":92,"pages":0,"type":0,"category":8,"theme":4,"mood":2,"images":1},{"id":92,"pages":0,"type":0,"category":8,"theme":5,"mood":2,"images":1},{"id":93,"pages":0,"type":0,"category":4,"theme":2,"mood":0,"images":1},{"id":94,"pages":0,"type":0,"category":1,"theme":0,"mood":0,"images":1},{"id":94,"pages":0,"type":0,"category":1,"theme":4,"mood":0,"images":1},{"id":94,"pages":0,"type":0,"category":8,"theme":0,"mood":0,"images":1},{"id":94,"pages":0,"type":0,"category":8,"theme":4,"mood":0,"images":1},{"id":95,"pages":0,"type":0,"category":1,"theme":0,"mood":2,"images":1},{"id":95,"pages":0,"type":0,"category":1,"theme":1,"mood":2,"images":1},{"id":96,"pages":1,"type":0,"category":14,"theme":5,"mood":1,"images":1},{"id":97,"pages":0,"type":0,"category":0,"theme":0,"mood":2,"images":1}]

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = [{"author":"Eduard Štorch","name":"Lovci mamutů","pages":272,"type":"próza","categories":"historický román","theme":"život","mood":"neutrální","year":1918,"images":"TRUE","description":"Tento příběh vypráví o kmeni pravěkých lidí ,,Lovců mamutů“. Udál se asi před dvaceti až třiceti tisíci lety. Tehdy žila na Bílé skále tlupa pravěkých lidí. Ovládali jednoduchou řeč a doplňovali ji posunky a mimikou v obličeji. Věděli, že je oheň nejen zahřeje, ale dokáže upéct maso a chránit před divokou zvěří. Oheň hořel před vchodem do jeskyně, aby dovnitř nemohly šelmy. Tehdy ho ještě neuměli rozdělat, tak spoléhali na přírodu a oheň donášeli. Příběh nám bude vyprávět o tom, jak lovili zvěř a jak z ní vše dokázali zužitkovat. Vnitřnosti zvěře jedli syrové, protože byly ještě teplé. Stažené kůže hned zpracovávaly ženy a děti. Lovili například zubry, lišky, ryby, ale také vlky a mamuty. Věřte, chytit takového mamuta je věc těžká, na kterou se museli dlouho připravovat. Museli nejdřív vykopat obrovskou jámu, do které toho mamuta museli vehnat. Učili se také vyrábět si nástroje, jako je například kámen opracovaný do tvaru slzy (pazourek). Díky pazourku, který poté použili na rozbíjení kamenů, dokázali vykřesat oheň. Ale to chtělo zručnost a trpělivost. Později se jim podařilo dokonce rozdělat oheň za pomoci kousku dřeva. Oheň byl totiž v pravěku největší vynález pravěkých lidí a měl pro ně opravdu obrovský význam. Dovídáme se tu také o cizích tlupách, například jak mezi sebou bojovali o území, o kořist atd. Při lovu nebo boji o území zahynula velká spousta pravěkých lidí. Byl to pro ně boj na život a na smrt.","smallThumbnail":"http://books.google.com/books/content?id=BywvCwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/90_/903/lovci-mamutu-903.jpg","url":"https://www.databazeknih.cz/knihy/lovci-mamutu-903","id":1},{"author":"Fráňa ŠRÁMEK","name":"Stříbrný vítr","pages":245,"type":"próza","categories":"román","theme":"život","mood":"neutrální","year":1919,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/stribrny-vitr-12398","thumbnail":"https://www.databazeknih.cz/images_books/12_/12398/stribrny-vitr-12398.jpg","description":"Lyrický román českého básníka o problémech dospívání a prvních milostných zmatcích. ","id":2},{"author":"Jiří MAHEN","name":"Měsíc","url":"https://www.databazeknih.cz/knihy/mesic-8968","pages":90,"type":"próza","categories":"román","theme":"příroda, život","mood":"neutrální","year":1920,"images":"TRUE","smallThumbnail":"http://books.google.com/books/content?id=0YIYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/89_/8968/mesic-8968.jpg","description":"Měsíc (1920) je sbírka fantastických hříček, předznamenání poetismu","id":3},{"author":"Jaroslav HAŠEK","name":"Osudy dobrého vojáka Švejka za světové války","pages":228,"type":"próza","categories":"humoristický román","theme":"válka","mood":"šťastný","year":1923,"images":"TRUE","smallThumbnail":"http://books.google.com/books/content?id=ZGnnAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/83_/83409/big_osudy-dobreho-vojaka-svejka-za-svet-KgW-83409.jpg","url":"https://www.databazeknih.cz/knihy/osudy-dobreho-vojaka-svejka-za-svetove-valky-83409","description":"Tento okřídlený výrok je však třeba ještě rozvést dále: každá česká umělecká generace, která se chce duchovně osamostatnit, by si měla nalézt svůj vlastní pohled na ústřední dílo naší literatury, Haškovy Osudy dobrého vojáka Švejka za světové války. Nový zorný úhel překvapivě po dlouhá léta scházel, snad proto, že kresby Josefa Lady se všeobecně považovaly za klasické a v Čechách tudíž za posvátné a nedotknutelné. Nová edice nejčastěji vydávaného českého literárního díla je proto příjemným překvapením. Čtenáře jistě potěší padesáti vynikajícími moderními kresbami Karla Klose, které posunují geniální Haškovu klasiku na úroveň dneška.","id":4},{"author":"Eduard Bass","name":"Klapzubova jedenáctka","pages":149,"type":"próza","categories":"humoristický román","theme":"volnočasové aktivity","mood":"šťastný","year":1922,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/klapzubova-jedenactka-279","thumbnail":"https://www.databazeknih.cz/images_books/27_/279/klapzubova-jedenactka.jpg","description":"Klasický humoristický román ze sportovního prostředí, o tom, jak chalupník Klapzuba vychová ze svých synů slavnou fotbalovou jedenáctku. ","id":5},{"author":"František Langer","name":"Velbloud uchem jehly","pages":93,"type":"drama","categories":"komedie","theme":"život","mood":"šťastný","year":1923,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/velbloud-uchem-jehly-62555","thumbnail":"https://www.databazeknih.cz/images_books/62_/62555/velbloud-uchem-jehly-vxi-62555.jpg","description":"Divadelní hra Františka Langera s Hugo Haasem a Antonií Nedošínskou v hlavních rolích. Ironická komedie o chudácích, kteří s pochopením přijímají dary boháčů a polepšeném synovi pana továrníka.","id":6},{"author":"Karel Čapek","name":"Krakatit","pages":224,"type":"próza","categories":"román","theme":"život, volnočasové aktivity","mood":"neutrální","year":1924,"images":"TRUE","description":"Čapkův román Krakatit vychází z obdobného vynálezu, jaký autor popsal v Továrně na absolutno. Vynálezce Prokop objeví způsob, jak nechat jakoukoliv látku rozpadnout na atomy. Při tom se výbuchem uvolní obrovské množství energie. Vyrobí látku zvanou \"krakatit\" nejstrašnější výbušninu na světě, kterou je možné přivést k výbuchu na dálku elektromagnetickými vlnami. Prokop si uvědomí dosah svého objevu vlastník krakatitu by se mohl stát vládcem světa. Uvědomí si to i jiní a pokoušejí se Prokopa o vynález připravit. Část vzorce získá bývalý Prokopův spolupracovník Tomeš a snaží se výbušninu vyrobit také. Prokop svodům odolá, vzorec neprozradí a ke konci je svědkem tragického výbuchu laboratoře, v níž se Tomeš pokoušel výbušninu připravit. Prokop, blouznící v horečkách, se na závěr setkává s pohádkovým stařečkem-bohem a přijímá od něj smiřující poselství o dobru a nutnosti dělat pouze věci prospěšné lidem.","smallThumbnail":"http://books.google.com/books/content?id=rhwdAgAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/68_/688/krakatit-688.jpg","url":"https://www.databazeknih.cz/knihy/krakatit-688","id":7},{"author":"Tomáš Garrigue MASARYK","name":"Světová revoluce","pages":639,"type":"próza","categories":"literatura náuční","theme":"život, válka","mood":"neutrální","year":1925,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/svetova-revoluce-135796","thumbnail":"https://www.databazeknih.cz/images_books/13_/135796/svetova-revoluce-135796.jpg","description":"Světová revoluce je poslední velkým spisem T. G. Masaryka a v jistém smyslu bilancí jeho celoživotních ideově politických východisek, postojů a snah.","id":8},{"author":"Vladislav Vančura","name":"Rozmarné léto","pages":122,"type":"próza","categories":"humoristický román","theme":"život","mood":"neutrální","year":1926,"images":"TRUE","description":"Příběh jednoho léta „poněkud nešťastného způsobu“. Banální historky třech pánů, nudících se v dešti, změnila květnatá spisovatelova čeština v dobrodružství ještě předtím, než přijel Arnoštek se svou krásnou společnicí.","smallThumbnail":"http://books.google.com/books/content?id=L4e1CgAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/59_/596/big_rozmarne-leto-nRQ-596.JPG","url":"https://www.databazeknih.cz/knihy/rozmarne-leto-596","id":9},{"author":"Vítězslav Nezval","name":"Akrobat","pages":44,"type":"poezie","categories":"","theme":"život","mood":"smutný","year":1927,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=AIY_AAAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/17_/176343/akrobat-jZs-176343.jpg","url":"https://www.databazeknih.cz/knihy/akrobat-176343","description":"Báseň je zlomem v Nezvalově tvorbě, silně ovlivněná geniálním překladem Apollinairova Pásma od Karla Čapka. Patří do druhé fáze poetismu a představuje paralelu akrobata, který symbolizuje poetistickou poezii a krize v Nezvalově tvorbě. Na konci třetího zpěvu je autor rozhodnut opustit poetistickou poezii: „na shledanou město akrobatů“, ale není připraven vejít do nového města. První a třetí zpěv tvoří rám celé básně. Jsou monotematické, psané v er-formě, v minulém čase. Můžeme v nich nalézt jednotnou konstrukci času (báseň začíná brzy ráno a končí pozdě večer) a místa (děj se odehrává ve městě, zřejmě v centru a uzavírá se odchodem z města). Druhý zpěv je naprosto odlišně sestaven a je vystaven na principu pásma. Lyrický subjekt čtenáře provází obrazy ze svého života. Je užito přítomného času. Jednotlivé obrazy jsou asociativně spojeny. Charakteristická je polytematičnost a prvky autobiografie. Ve třetím zpěvu dochází k syntéze básníka a akrobata. Poetistický optimismus je nahrazen autorovou skepsí o vlastním smyslu poezie a již jsou patrné náznaky budoucí surrealistické tvorby.","id":10},{"author":"Karel Čapek","name":"Hovory s TGM","pages":308,"type":"próza","categories":"literatura náuční","theme":"život","mood":"neutrální","year":1928,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/hovory-k-sobe-26195","thumbnail":"https://www.databazeknih.cz/images_books/26_/26195/hovory-k-sobe-26195.jpg","description":"Hovory k sobě jsou jeho jediným, zato nesmírně významným spisem a patří mezi skvosty kulturního dědictví antiky. Jedná se o netradiční formu aforistických zápisků, které si císař pořizoval příležitostně kdekoli, a tak se nám naskýtá zajímavý náhled do myšlení tohoto velkého člověka, který bývá právem nazýván jako „filozof na trůně“. Marcus Aurelius byl oddán své filozofii, a proto pohlížel na svá neštěstí jako na prověrku osudu, v níž lidé prokáží svou vnitřní sílu tím, jak svůj osud dokáží přijmout a jak se s ním vyrovnají.  Text překladu i ediční poznámka jsou převzaty z vyd. v nakl. Svoboda z r. 1969.","id":11},{"author":"Josef ĆAPEK","name":"Povídání o pejskovi a kočičce","pages":110,"type":"próza","categories":"literatura pro deti","theme":"volnočasové aktivity","mood":"šťastný","year":1929,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/o-pejskovi-a-kocicce-povidani-o-pejskovi-a-kocicce-12009","thumbnail":"https://www.databazeknih.cz/images_books/12_/12009/big_povidani-o-pejskovi-a-kocicce-Lbp-12009.jpg","description":"Jak spolu hospodařili a ještě o všelijakých jiných věcech. Veselá vyprávění o dvou nerozlučných kamarádech, která potěšila již několik generací čtenářů. Povídání o tom, jak pejsek a kočička myli podlahu, jak pekli dort nebo o tom, jak si pejsek roztrhl kalhoty a kočička mu je zašila dešťovkou, si čítávali už prarodiče dnešních dětí. Autorův laskavý humor, kterým si bere na mušku drobné dětské nectnosti, jeho vcítění do dětského myšlení a krásný vroucný jazyk tvoří tuto milou knížku nesmrtelnou.","id":12},{"author":"Jaroslav DURYCH","name":"Bloudění","pages":836,"type":"próza","categories":"historický román","theme":"život, válka","mood":"smutný","year":1930,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/bloudeni-12752","thumbnail":"https://www.databazeknih.cz/images_books/12_/12752/bloudeni-12752.jpg","description":"Větší valdštejnská trilogie. Příběh Čecha prožívajícího v pobělohorské době hlubokou krizi a provázeného láskou dívky španělského původu, která mu přináší zvěst o zakotvení v pevné víře. ","id":13},{"author":"Karel Poláček","name":"Muži v offsidu","pages":252,"type":"próza","categories":"humoristický román","theme":"volnočasové aktivity","mood":"šťastný","year":1931,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/muzi-v-offsidu-602","thumbnail":"https://www.knihydobrovsky.cz/files/thumbs/mod_eshop/produkty/m/muzi-v-offsidu-9788072872114.280299474.1475005237.jpg","description":"Děj tohoto románu se odehrává v prostředí fotbalových klubů Viktorie Žižkov a Slavie Praha. Autor podává humorným způsobem obraz několika obyčejných pražských obyvatel a přibližuje jejich zajímavý způsob života.   Nejdůležitější je osoba Emana Habáska mladšího. Kolem něj se totiž točí celý děj. Eman je náruživým divákem při fotbalových zápasech. Fandí Viktorii Žižkov. Při jednom takovém zápase se pohádá a nakonec dokonce popere s panem Nečeradcem, který fandí Slávii. Vše se ale urovná, a když pan Nečeradec zjistí, že Eman je bez práce, nabídne mu zaměstnání ve svém obchodě. Emanova pověst se tím velice vylepšila. Časem se seznámí se slečnou Emilkou. Jejich vztahu ale nepřeje Emilčin otec, pan Šefelín. To však oba mladé moc nezajímá. A tak se po nějaké době dozví pan Šefelín, že jeho drahá dceruška je v jiném stavu.  Samozřejmě by Emana nejraději zastřelil, ale nakonec se vše zase urovná, protože Eman souhlasí s tím, že si Emilku vezme za manželku. A tak nám kniha končí šťastnou svatbou.","id":14},{"author":"Vilém Závada","name":"Siréna","pages":155,"type":"poezie","categories":"","theme":"válka","mood":"smutný","year":1932,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/sirena-323526","thumbnail":"https://www.databazeknih.cz/images_books/32_/323526/big_sirena-Zx0-323526.jpg","description":"Oceán zachránil Kahlen před smrtí. Je to už dávno, co ji nenechal utonout, a od té doby mu slouží jako siréna. Svým zpěvem láká bezpočet neznámých do hlubin moře, aby tak splatila dluh. Může se pohybovat také na zemi mezi lidmi, ale protože by i jediným slovem mohla způsobit smrt, musí držet jazyk za zuby. Dívá se, jak žijí obyčejní lidé a těší se, až bude taky smět hlasitě mluvit, smát se a svobodně žít. Je smířená se samotou až do konce služby… ale pak se seznámí s Akinlim. Je to kluk, který má všechno, o čem kdy snila. Vypadá dobře, je srdečný, vtipný a bezprostřední, zajímá ho nejenom její krása. Všemožně se s ní snaží komunikovat, úžasně si rozumějí a vztah mezi nimi rychle přeroste kamarádství. Ať chtějí nebo ne, jsou spojeni poutem lásky… A Kahlen chce. Jsou tu však pravidla daná Oceánem a zamilovat se do člověka? To by jistě žádná siréna neměla. Bude muset Akinliho opustit. Žádný člověk nesmí v životě poznat mořský svět sirén. Jenomže poprvé po létech poslušnosti je Kahlen rozhodnutá následovat hlas srdce.","id":15},{"author":"Ferdinand PEROUTKA","name":"Budování státu","pages":1830,"type":"próza","categories":"literatura náuční","theme":"život, válka","mood":"neutrální","year":1933,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=Q6VnAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/25_/252837/big_budovani-statu-komplet-0uk-252837.jpg","url":"https://www.databazeknih.cz/knihy/budovani-statu-komplet-252837","description":"Stěžejní dílo autora vydané ve 4 svazcích, ve kterém se zabývá historií Československa v letech 1918-1922.","id":16},{"author":"Jakub DEML","name":"Zapomenuté světlo","pages":144,"type":"próza","categories":"román","theme":"život","mood":"smutný","year":1934,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/zapomenute-svetlo-25098","thumbnail":"https://www.databazeknih.cz/images_books/25_/25098/zapomenute-svetlo-25098.jpg","description":"Soubor prozaických esejů vzniklých jako reakce na smrt autorovy přítelkyně, spisovatelky Pavly Kytlicové a básníka Otokara Březiny.  Formálně je text koncipován jako odpověď na dopis velkomeziříčského spisovatele Bohumila H. Ptáčka, obsahem je však osobní výpovědí či zpovědí osamělého člověka, zmítajícího se v mučivých rozporech mezi svou vírou a realitou okolního světa.","id":17},{"author":"Jan ČEP","name":"Hranice stínu","pages":251,"type":"próza","categories":"román","theme":"život","mood":"neutrální","year":1935,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/nocni-andel-hranice-stinu-56868","thumbnail":"https://www.databazeknih.cz/images_books/56_/56868/big_nocni-andel-hranice--56868.jpg","description":"Cenarie dobytá Khalidořany úpí pod krutovládou Bohokrále. Ubohé zbytky odporu se pokouší organizovat mocná zločinecká organizace Sa'kagé pod vedením svých posledních dvou Shingů – mladíka Jarla a bývalé prostitutky Mámy K. Jejich jedinou nadějí na úspěch je ale nejlepší wetboy ve městě a Noční anděl Kylar. Jen on je schopen postavit se Bohokráli. Kylar však zavrhuje život nájemného vraha. Mladý muž chce začít znova – v novém městě, s novými přáteli a novou profesí. Když však zjistí, že jeho přítel Logan je možná naživu, je Kylar postaven před trýznivou volbu. Vzdá se navždy cesty stínů a bude žít se svou novou rodinou, nebo překročí hranice stínů a bude vše riskovat kvůli poslední zakázce?","id":18},{"author":"Ondřej SEKORA","name":"Ferda Mravenec","url":"https://www.databazeknih.cz/knihy/ferda-mravenec-ferda-mravenec-33976","pages":70,"type":"próza","categories":"literatura pro deti, pohádky","theme":"příroda, život","mood":"šťastný","year":1936,"images":"TRUE","thumbnail":"https://www.databazeknih.cz/images_books/33_/33976/ferda-mravenec-33976.jpg","description":"Vyprávění o Ferdovi Mravencovi, Brouku Pytlíkovi, Berušce a dalších kamarádech z hmyzí říše. Pro děti od 6 let.","id":19},{"author":"Jiří Voskovec – Jan Werich","name":"Těžká Barbora","pages":129,"type":"drama","categories":"","theme":"život","mood":"neutrální","year":1937,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/tezka-barbora-274033","thumbnail":"https://www.databazeknih.cz/images_books/27_/274033/big_tezka-barbora-rTx-274033.jpg","description":"Děj se odehrává v Eidamu, městě, do něhož se dostane dělo a eidamští občané nevědí, co s ním. Někteří chtějí, aby bylo roztaveno a byl z něj ulit zvon míru, jiní chtějí, aby zůstalo ve městě. Hejtman chce, aby byla postavena socha jemu na počest. S tím nikdo, ani starosta nesouhlasí. Hejtman však ví o starostových pletkách se služkou, dal mu podmínku, že to neřekne veřejnosti, pokud vysloví souhlas se sochou. Starosta nakonec souhlasí. Nakonec dělo ve městě zůstalo - zachránilo město od nepřátel. (spirlice)","id":20},{"author":"Jarmila GLAZAROVÁ","name":"Vlčí jáma","pages":256,"type":"próza","categories":"román","theme":"život","mood":"smutný","year":1938,"images":"FALSE","description":"Román zachycuje příběh osmnáctiletého děvčete, sirotka, které přichází jako schovanka do rodiny bezdětného zvěrolékaře - slezského osvětového pracovníka a lidumila. Dívka se stane nenáročnou pomocnicí a opatrovnicí jeho o mnoho let starší ženy, která na svém muži lpí sobeckou a nepřirozenou láskou. Sympatický vztah mezi dívkou a otčímem se pozvolna mění v milostný cit. Teprve smrt obou manželů vysvobodí hrdinku z nesnesitelných poměrů a dává jí naději na nový život.","smallThumbnail":"http://books.google.com/books/content?id=C5sYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/28_/2876/big_vlci-jama-0oV-2876.jpg","url":"https://www.databazeknih.cz/knihy/vlci-jama-2876","id":21},{"author":"František KOŽÍK","name":"Největší z pierotů","pages":419,"type":"próza","categories":"román, biografický román","theme":"život","mood":"neutrální","year":1939,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/nejvetsi-z-pierotu-11783","thumbnail":"https://www.databazeknih.cz/images_books/11_/11783/nejvetsi-z-pierotu-11783.jpg","description":"Rozsáhlý román inspirovaný životní a uměleckou dráhou mistra pantomimy Jeana Gaspara Debureaua (1796-1846), který byl po své matce českého původu.  Autor líčí jeho dětství a mládí strávené uprostřed kočovné artistické společnosti, léta čekání na výraznější umělecký úspěch a konečně i léta triumfu a uznání. V Paříži dosáhl po mnoha letech nesmírné popularity a byl milován a obdivován všemi - od prostého publika až po představitele kulturní elity tehdejší Francie. Román není životopisem v pravém slovy smyslu, ale především psychologickou studií o cestě umělce za vyjádřením svých představ a poetickou básní o divadle a lidském životě.","id":22},{"author":"Václav Řezáč","name":"Černé světlo","pages":290,"type":"próza","categories":"román","theme":"život","mood":"smutný","year":1940,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=6J_nAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/32_/326088/big_cerne-svetlo-hJz-326088.jpg","url":"https://www.databazeknih.cz/knihy/cerne-svetlo-326088","description":"Enzo Macleod, Skot vyučující biologii na univerzitě v Toulouse na jihozápadě Francie, se rozhodl, že s využitím svých znalostí vyřeší sedm nechvalně proslulých vražd popsaných v knize odložených případů pařížského novináře Rogera Raffina. Enzo už dokázal rozlousknout první dva zločiny, ale na třetí případ teď nemá ani pomyšlení. Právě mu diagnostikovali rakovinu, a navíc se objevil někdo, kdo má v plánu zničit jeho pověst i vztahy.  Souvisí nějak Enzovy osobní strasti s šestnáct let starou brutální vraždou mladého prostituta v pařížském bytě? Dokáže najít alespoň nějaké zbytky důkazů — a zůstane naživu dost dlouho na to, aby dopadl vraha?","id":23},{"author":"Jaroslav FOGLAR","name":"Záhada hlavolamu","pages":192,"type":"próza","categories":"román, literatura pro deti","theme":"volnočasové aktivity, život","mood":"šťastný","year":1941,"images":"TRUE","description":"Hlavní roli v knize hraje chlapecký klub Rychlé šípy, již dříve čtenářům známý z komiksů. Foglar v knize poprvé představuje záhadnou čtvrť Stínadla a organizaci Vontů, hlavolam zvaný „ježek v kleci“ a ztraceného vynálezce Jana Tleskače, motivy později využité v dalších knihách, které se následně staly téměř kultovní součástí české kultury. -- by Giro  Osmé vydání. V roce 2005 dotisk.","url":"https://www.databazeknih.cz/knihy/zahada-hlavolamu-248","thumbnail":"https://www.databazeknih.cz/images_books/24_/248/zahada-hlavolamu-248.jpg","id":24},{"author":"Zdeněk JIROTKA","name":"Saturnin","url":"https://www.databazeknih.cz/knihy/saturnin-saturnin-1615","pages":215,"type":"próza","categories":"humoristický román","theme":"život","mood":"šťastný","year":1942,"images":"TRUE","thumbnail":"https://www.databazeknih.cz/images_books/16_/1615/big_saturnin-gbv-1615.jpg","description":"Slavná humoristická kniha, která pobavila již několik generací čtenářů. Na jejích stránkách se čtenáři dozví, co se stane, když věrný sluha Saturnin přestěhuje svého pána z pohodlného bytu na loď, kde se pak objeví teta Kateřina se synem Miloušem, a co se přihodí při rodinné dovolené u dědečka, jehož dům je díky povodni načas odříznut od civilizace. Všem nepříjemnostem, katastrofám a přetvářce tety Kateřiny naštěstí umí s jiskřivým vtipem čelit Saturnin. Jeho schopnosti jsou téměř geniální, jak o něm píše v jednom dopise dědeček: „V bláznivých nápadech toho chlapíka je kus poezie, jeho humor, fantazie a podivuhodné myšlenkové přemety dovedou udělat detektivku z jízdního řádu.\"","id":25},{"author":"František Hrubín","name":"Říkejte si se mnou","pages":46,"type":"poezie","categories":"literatura pro deti","theme":"život, volnočasové aktivity","mood":"šťastný","year":1943,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/rikejte-si-se-mnou-26288","thumbnail":"https://www.databazeknih.cz/images_books/26_/26288/rikejte-si-se-mnou-26288.jpg","description":"Zpěvné rytmické verše, které jsou doplněny Trnkovými obrázky.","id":26},{"author":"Jaroslav HAVLÍČEK","name":"Petrolejové lampy","pages":280,"type":"próza","categories":"román","theme":"život","mood":"smutný","year":1944,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/petrolejove-lampy-3015","thumbnail":"https://www.databazeknih.cz/images_books/30_/3015/big_petrolejove-lampy-cMe-3015.jpg","description":"Mistrovské psychologické drama je realistickou studií maloměsta (rodné Jilemnice) na přelomu devatenáctého a dvacátého století. Příběh energické a nepoddajné Štěpky se zapsal do povědomí především díky stejnojmenné filmové interpretaci režiséra Juraje Herze s Petrem Čepkem a Ivou Janžurovou v hlavních rolích. Kniha vyšla původně pod názvem Vyprahlé touhy (1935), přepracované vyšlo 1944 pod názvem Petrolejové lampy.","id":27},{"author":"Jiří WEIL","name":"Život s hvězdou","pages":238,"type":"próza","categories":"román","theme":"válka, život","mood":"smutný","year":1945,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=LghhAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/38_/38546/zivot-s-hvezdou-38546.jpg","url":"https://www.databazeknih.cz/knihy/zivot-s-hvezdou-na-strese-je-mendelssohn-zalozpev-za-77-297-obeti-38546","description":"První román vypráví o židovském úředníkovi, který se skrývá před transportem a žije v očekávání nevyhnutelné smrti. V kritickém okamžiku se vzchopí a rozhodne se zápasit o život. Druhý je inspirován odstraněním Mendelssohnovy sochy ze střechy Rudolfina. Od toho se odvíjejí osudy protagonistů různého společenského postavení v široké škále výstižných charakteristik. Žalozpěv za 77 297 obětí je pásmo, zaznamenávající chronologicky události v protektorátu od příchodu Němců přes první sankce, registrace, transporty, až po konečnou likvidaci v Osvětimi. Jako komplet zobrazuje kniha svět zbavený jistot, v němž je jednotlivec bez viny nucen k nejtěžším zkouškám.","id":28},{"author":"Karel POLÁČEK","name":"Bylo nás pět","pages":220,"type":"próza","categories":"román, literatura pro deti, humoristický román","theme":"život, volnočasové aktivity","mood":"neutrální","year":1946,"images":"TRUE","smallThumbnail":"http://books.google.com/books/content?id=fJUYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/35_/35558/big_bylo-nas-pet-8BO-35558.jpg","url":"https://www.databazeknih.cz/knihy/bylo-nas-pet-35558","description":"Půvabná vyprávění o dobrodružstvích pěti nezbedných chlapců z malého českého městečka, psaná formou dětského deníku kupeckého synka Petra Bajzy. Klukovskýma očima viděný rok na maloměstě připomíná všechny sezónní dospělé i dětské zábavy, životní styl i hierarchii obyvatel malého města za první republiky. Kouzelná knížka, napsaná v době okupace, byla zároveň i autorovým posledním dílem a našla velkou odezvu mezi čtenáři všech kategorií.","id":29},{"author":"Egon Hostovský","name":"Cizinec hledá byt","pages":168,"type":"próza","categories":"román","theme":"válka, život","mood":"smutný","year":1947,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=TFIDAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/64_/64857/cizinec-hleda-byt-64857.jpg","url":"https://www.databazeknih.cz/knihy/cizinec-hleda-byt-64857","description":"Cizinec hledá byt začíná v prosinci 1945 v New Yorku, kde český emigrant, lékař Václav Marek, marně hledá byt, v němž by našel stůl a klid ke své práci, jíž chce dokončit. Avšak je neustále zatahován do osobních problémů jeho hostitelů. Svoji práci nemůže nikdy dokončit, protože je něčím, co je mimo naše možnosti, je symbolem bloudění a tudíž je hlavní postava na nekonečné pouti života, na které nenalezne to, co hledá. Je člověkem, který nikdy nezakotví, je Ashaverem (věčným poutníkem).","id":30},{"author":"Jan HANČ","name":"Události","pages":250,"type":"próza","categories":"deníky","theme":"život","mood":"smutný","year":1948,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/pruvodce-protektoratni-prahou-177576","thumbnail":"https://www.databazeknih.cz/images_books/17_/177576/pruvodce-protektoratni-prahou-mista-udalosti-lide-177576.jpg","description":"Kniha zavede zájemce na místa konspiračních schůzek odbojářů, do bytů rodin podporovatelů parašutistů, připravujících atentát na Reinharda Heydricha, do kanceláří krycích firem Sicherheitsdienstu, do tajné porodnice, zřízené gestapem, na místa, kde trpěli pražští židé, do podzemí, kde nacisté připravovali výstavbu podzemních továren, do sálů, kde se scházeli čeští fašisté a na barikády a velitelská stanoviště Pražského povstání. Zároveň ukáže, že i během okupace byla Praha místem, kde i přes nacistický útlak existovaly ostrůvky svobody a kulturního života. Publikace je doplněna velkým množstvím dosud nepublikovaného obrazového materiálu a přehlednými mapkami.","id":31},{"author":"Jiří KOLÁŘ","name":"Očitý svědek","pages":172,"type":"próza","categories":"deníky","theme":"život","mood":"neutrální","year":1949,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/ocity-svedek-51274","thumbnail":"https://www.databazeknih.cz/images_books/51_/51274/ocity-svedek-51274.jpg","description":"Deník z roku 1949. Závěrečnou stať napsal Jan Vladislav. 8 celostr. fotogr. vyobr. na přílohách. Autory fotografií jsou Dušan Klimeš a Werner Hannappel. ","id":32},{"author":"Jaroslav SEIFERT","name":"Píseň o Viktorce","pages":60,"type":"poezie","categories":"","theme":"život","mood":"smutný","year":1950,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/pisen-o-viktorce-44330","thumbnail":"https://www.databazeknih.cz/images_books/44_/44330/pisen-o-viktorce-44330.jpg","description":"Známá postava Babičky Boženy Němcové rozehrála autorovu fantazii tak, že básnicky ztvárnil její osobnost, osudy i city, jimiž hořelo i trpělo její srdce, a promítl do nich spisovatelčin trpký lidský a citový úděl.  „Noc byla tenkrát bezmála / a Úpa byla rozvodněna. / Volal jsem do tmy jejich jména, / dvě krásná jména, zoufalá. // Té, která byla raněna / a sežehnuta bleskem krásy, / básnířky, která vplétala si / krvavé trní do jména.“ Tak jako v počátečních verších i v dalších slokách celé Písně konfrontuje básník nejednou osud nešťastné Viktorky – jak ho známe z Babičky – s osudem autorky.","id":33},{"author":"Jan ZAHRADNÍČEK","name":"Znamení moci","pages":35,"type":"poezie","categories":"","theme":"válka, komunizmus","mood":"smutný","year":1951,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/znameni-moci-42284","thumbnail":"https://www.databazeknih.cz/images_books/42_/42284/big_znameni-moci-F9D-42284.jpg","description":"Znamení moci je jedno z nejznámějších a nejvýznamnějších děl Jana Zahradníčka. Jde o rozsáhlou básnickou skladbu o sedmi zpěvech. Není známo, kdy přesně byla napsána; jisté je, že to bylo před básníkovým zatčením a uvězněním v roce 1951, v Čechách byla poprvé vydána knižně r. 1968 přičiněním Bedřicha Fučíka. V básni autor za pomoci básnických prostředků a hlubokých alegorií vykresluje komunistický režim, který uchvátil moc v Československu a dalších zemích světa. Popisuje hroucení lidské společnosti a jejích morálních hodnot a zrůdnost režimu, který obelhal lidi a připravil je o jejich lidství. V určitém smyslu je jakýmsi završením skladby La Saletta z roku 1947 – ovšem zatímco ta první vyjadřuje obavu z toho, co může přijít, a co zatím vypadá jako nepoznaná a jakási beztvará hrůza, Znamení moci mluví o poznané hrůze, která je již zde.","id":34},{"author":"Jaroslav Seifert","name":"Šel malíř chudě do světa","pages":90,"type":"poezie","categories":"","theme":"život","mood":"šťastný","year":1952,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/sel-malir-chude-do-sveta-372207","thumbnail":"https://www.databazeknih.cz/images_books/37_/372207/big_sel-malir-chude-do-sveta-Z9S-372207.jpeg","description":"Jedna z nejčtenějších a nejoblíbenějších básnických sbírek Jaroslava Seiferta. Sbírka veršů, které básník vytvořil k drobným kresbám M. Alše. Zralá mistrovská poezie, přitom přístupná širokému okruhu čtenářů, mladých i starších.","id":35},{"author":"Jaroslav Seifert","name":"Maminka","pages":75,"type":"poezie","categories":"","theme":"život","mood":"šťastný","year":1954,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/maminka-449","thumbnail":"https://www.databazeknih.cz/images_books/44_/449/maminka-449.jpg","description":"Nositel Nobelovy ceny za literaturu napsal svou sbírku zpěvné intimní lyriky už jako zralý, zkušený a známý básník v roce 1954. Půvabné vzpomínky na dětský svět a na maminku, která dokázala udělat domov krásným, oslovily nejednu generaci. Prosté a jednoduché verše (např. Maminčina kytice, Mlýnek na kávu, Všední den, Dědečkův pohřeb, Vjí, Krabice na čaj, Domov... ) opěvují nejen dětství, ale především dobrotu, krásu, práci i únavu maminky a mluví ústy básníka za mnohé z nás. S ilustracemi Jiřího Trnky patří knížka do zlatého fondu české literatury a do pokladnice Albatrosu.","id":36},{"author":"Adolf Branald","name":"Dědeček automobil","pages":319,"type":"próza","categories":"román, literatura pro deti, historický román","theme":"volnočasové aktivity","mood":"neutrální","year":1955,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/dedecek-automobil-4857","thumbnail":"https://www.databazeknih.cz/images_books/48_/4857/big_dedecek-automobil-jw2-4857.JPG","description":"Tato kniha vypráví o mladoboleslavské továrně která se snažila prorazit na všech závodech.A právě kolem závodů, kterých se účastní české vozy, se tato kniha točí.Kolovrát,Vondřich a spoustu dalších postav této knížky, vás vtáhne do děje","id":37},{"author":"Bohumil Hrabal","name":"Hovory lidí","pages":23,"type":"próza","categories":"povídky","theme":"život","mood":"neutrální","year":1956,"images":"TRUE","smallThumbnail":"http://books.google.com/books/content?id=BwMjAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/40_/40552/hovory-lidi-40552.jpg","url":"https://www.databazeknih.cz/knihy/hovory-lidi-40552","description":"Výbor povídek Bohumila Hrabala.","id":38},{"author":"František HRUBÍN","name":"Špalíček pohádek","pages":128,"type":"próza","categories":"literatura pro deti, pohádky","theme":"život","mood":"šťastný","year":1957,"images":"TRUE","description":"Soubor nejkrásnějších českých pohádek a nové příběhy na staré motivy.","url":"https://www.databazeknih.cz/knihy/spalicek-pohadek-28871","thumbnail":"https://www.databazeknih.cz/images_books/28_/28871/spalicek-pohadek-28871.jpg","id":39},{"author":"Josef ŠKVORECKÝ","name":"Zbabělci","pages":365,"type":"próza","categories":"román","theme":"válka, komunizmus, život","mood":"neutrální","year":1958,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=tQcuAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/13_/13051/danny-smiricky-zbabe-13051.jpg","url":"https://www.databazeknih.cz/knihy/zbabelci-13051","description":"Nové, v jednotlivostech částečně přepracované vydání románu, který se při svém prvním vyjití stal terčem ostré kritiky. Vylíčením průběhu květnových dní r. 1945 ve východočeském městě chce být – říká autor sám – analýzou životního pocitu přislušníka zlaté mládeže v době převratných historických událostí.  Vydání 2.","id":40},{"author":"Jiří SUCHÝ","name":"Člověk z půdy","pages":45,"type":"drama","categories":"","theme":"život","mood":"šťastný","year":1959,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/clovek-z-pudy-166274","thumbnail":"https://www.databazeknih.cz/images_books/16_/166274/big_clovek-z-pudy-Qr2-166274.JPG","description":"Spisovatel Antonín Sommer se straní společnosti a žije na půdě, kde ho občas vyrušují ze soustředění milenci. Jednou si ale jednu dvojici (Petra a Martinu) pozve k sobě a chystá se je zapsat do svého nového románu. Na scéně se ale objeví Malý lord, postava z dřívější spisovatelovy knihy, který ničí všechny její výtisky, aby se mohl osvobodit ze spisovatelova vlivu. Zachrání jak milence, tak Hedviku, postavu ze Sommerova nového románu, jejíž duše podle knihy pobývá na Měsíci. Ve hře také vystupuje čtveřice mužů, kteří nahrazují obvyklá revuální girls (zvaní girlsáci).","id":41},{"author":"Jan Werich","name":"Fimfárum","pages":192,"type":"próza","categories":"literatura pro deti, pohádky","theme":"život","mood":"šťastný","year":1960,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/fimfarum-6121","thumbnail":"https://www.databazeknih.cz/images_books/61_/6121/big_fimfarum-6pi-6121.jpg","description":"Fimfárum je sbírka pohádek Jana Wericha, obsahující například pohádky Rozum a štěstí, Lakomá Barka, Fimfárum, Jak vyhynuli obři na Šumavě atd. Kniha je určena nejen pro děti, protože i dospělí v ní najdou jakési Werichovo moudro a jeho osobitý styl humoru.","id":42},{"author":"Miroslav Holub","name":"Slabikář","url":"https://www.databazeknih.cz/knihy/slabikar-71369","pages":128,"type":"poezie","categories":"","theme":"život","mood":"neutrální","year":1961,"images":"TRUE","description":"Sbírka, která kritizuje strnulost, odtrženost od života, nemorálnost, bezdůvodnou nadřazenost a pochybnou sebejisotu a nelidskost. Objevují se kontrasty: lidskost, vytrvalost X samolibost, zlo. Autor akcentuje činnorodost, práci v laboratoři, touhu dobrat se pravdy.","smallThumbnail":"http://books.google.com/books/content?id=iW4IAQAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/71_/71369/big_slabikar-4Fi-71369.png","id":43},{"author":"František Hrubín","name":"Romance pro křídlovku","pages":80,"type":"poezie","categories":"","theme":"život","mood":"neutrální","year":1962,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/romance-pro-kridlovku-155","thumbnail":"https://www.databazeknih.cz/images_books/15_/155/big_romance-pro-kridlovku-9Xr-155.jpg","description":"Romance pro křídlovku představuje lyrickoepický vrchol Hrubínovy básnické tvorby.","id":44},{"author":"Václav HAVEL","name":"Zahradní slavnost","pages":78,"type":"drama","categories":"absurdní drama","theme":"život","mood":"neutrální","year":1963,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/zahradni-slavnost-2471","thumbnail":"https://www.databazeknih.cz/images_books/24_/2471/zahradni-slavnost-2471.jpg","description":"Hlavním hrdinou hry je Hugo Pludek, jehož genialita spočívá v tom, že dokáže jakýkoliv systém přivést k dokonalosti a zcela s ním splynout, čímž vlastně ztrácí svoji identitu.  V příběhu člověka, který na obratném využívání frází vybuduje svou kariéru, ale ztratí přitom svou vlastní tvář, útočí autor na byrokratismus a frázovitost v našem životě. Hra je označována za první české absurdní drama.  Doslov Uvedení Zahradní slavnosti naps. Jan Grossman","id":45},{"author":"Vladimír HOLAN","name":"Noc s Hamletem","pages":78,"type":"poezie","categories":"","theme":"život","mood":"smutný","year":1964,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/noc-s-hamletem-13000","thumbnail":"https://www.databazeknih.cz/images_books/13_/13000/noc-s-hamletem-13000.jpg","description":"Jeden z nejpůsobivějších a současně nejtemnějších skvostů české poezie dvacátého století z pera reflexivního lyrika Vladimíra Holana (1905–1980) vychází tentokrát s ilustracemi Oldřicha Hamery.","id":46},{"author":"Jan Skácel","name":"Smuténka","pages":60,"type":"poezie","categories":"","theme":"život","mood":"smutný","year":1965,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/smutenka-24701","thumbnail":"https://www.databazeknih.cz/images_books/24_/24701/smutenka.jpg","description":"Základní pilíře Skácelovy poezie vycházejí z jeho literárních předků (Erbena, Tomana, Halase, Kainara ale i Mikuláška). Stavbou svých básní má Jan Skácel nejblíže k Františku Halasovi, i on tvoří úsporné a hutné obrazy, rozvíjí v básni jediný základní obraz a zobrazuje většinou jedinou situaci. Básně sbírky Smuténka obyčejně začínají lyrickým popisem a v závěru vyústí do pointy, která míří až do oblasti morálky. Toto etické vyústění básní má Jan Skácel společné zase s jiným českým básníkem, Miroslavem Holubem. Obsahuje básně jako Chvíle, Smlouva, Zlatá brána, Smlouva...    ,,Chvíle\" Za žádnou pravdu na světě. Ale jestli chceš, za malý pětník ticha.  Je chvíle, která půlí krajinu.  Pokorný okamžik, kdy někdo za nás dýchá.","id":47},{"author":"Ladislav SMOČEK","name":"Podivné odpoledne dr. Zvonka Burkeho","pages":72,"type":"drama","categories":"absurdní drama, komedie","theme":"život","mood":"neutrální","year":1966,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/podivne-odpoledne-dr-zvonka-burkeho-50540","thumbnail":"https://www.databazeknih.cz/images_books/50_/50540/podivne-odpoledne-dr-zvonka-burkeho-50540.jpg","description":"Nejúspěšnější a nejčastěji u nás i v zahraničí uváděná hra režiséra L. Smočka „o lidumilovi, který se málem stane několikanásobným vrahem“, vychází jako 75. svazek edice D.","id":48},{"author":"Milan Kundera","name":"Žert","pages":296,"type":"próza","categories":"román","theme":"komunizmus, život","mood":"smutný","year":1967,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=5ZYYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/24_/244/big_zert-VWU-244.jpg","url":"https://www.databazeknih.cz/knihy/zert-244","description":"Román Žert postihuje úděl intelektuála v totalitní společnosti. Ironický lístek adresovaný krásné, ale hloupé dívce a zachycený pozornými funkcionáři uvede do pohybu lavinu, která vrhá lidské osudy do nicoty. Svým existenciálním vyzněním však tento zoufalý románový výkřik přesahuje politické souvislosti.","id":49},{"author":"Jiří Mucha","name":"Studené slunce","pages":186,"type":"próza","categories":"literatura náuční, biografický román, deníky","theme":"komunizmus","mood":"smutný","year":1968,"images":"FALSE","description":"Autobiografické vyprávění o době, kterou autor v padesátých letech prožil ve vězeňském táboře jako horník.  V pauzách při práci si pod zemí na útržky papíru zachycoval své dojmy o práci, spoluvězních apod. Ve vzpomínkách prožívá znovu svůj život. Kniha je psána formou deníku.","smallThumbnail":"http://books.google.com/books/content?id=FKDnAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/33_/33454/studene-slunce-33454.jpg","url":"https://www.databazeknih.cz/knihy/studene-slunce-33454","id":50},{"author":"Jiří Šotola","name":"Tovaryšstvo Ježíšovo","pages":272,"type":"próza","categories":"historický román","theme":"náboženství","mood":"smutný","year":1969,"images":"TRUE","smallThumbnail":"http://books.google.com/books/content?id=wlkjAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/33_/33388/tovarysstvo-jezisovo-33388.jpg","url":"https://www.databazeknih.cz/knihy/tovarysstvo-jezisovo-33388","description":"Román z konce 17. století je strhující zpovědí mladého jezuity, pověřeného úkolem pokatoličtit východní Čechy.  Děj se odvíjí kolem člena jezuitského řádu, ketrý prochází peripetiemi ve vztahu ke svému poslání i k řádu samotnému. Chce se od postavení osvobodit, ale není to možné. ","id":51},{"author":"Václav ČTVRTEK","name":"Rumcajs","url":"https://www.databazeknih.cz/knihy/rumcajs-135509","pages":134,"type":"próza","categories":"literatura pro deti, pohádky","theme":"život","mood":"šťastný","year":1970,"images":"TRUE","description":"Pohádkové příběhy o loupežníku Rumcajsovi - jedné z nejznámějších postav Václava Čtvrtka a ilustrátora Radka Pilaře, kterou děti dobře znají i z televize. Rumcajs je prvním z dílů známé trilogie Rumcajs - Manka - Cipísek. V prvním díle se děti dozvědí, jak se stal Rumcajs loupežníkem, jak utopil draka, jak vysadil duhu na nebe a ještě mnoho krásných příběhů.","thumbnail":"https://www.databazeknih.cz/images_books/13_/135509/rumcajs-135509.jpg","id":52},{"author":"Ota Pavel","name":"Smrt krásných srnců","pages":113,"type":"próza","categories":"povídky","theme":"válka, příroda","mood":"neutrální","year":1971,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=MaXqAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/59_/591/smrt-krasnych-srncu-591.jpg","url":"https://www.databazeknih.cz/knihy/smrt-krasnych-srncu-591","description":"Soubor sedmi povídek, které jsou soustředěny především okolo postavy Pavlova tatínka. Pavel je mistrný lidový vypravěč. Jeho povídky mají jednoduchou dějovou osnovu, ale díky jadrnému podání a původu ve skutečnosti jsou velice oblíbené. Dominantní úlohu ve všech povídkách sehrává řeka Berounka, její okolí a Křivoklátsko, tamní příroda, kterou ostatně celá Pavlova rodina tolik milovala.  Úvodní povídky knihy se jmenuje Nejdražší ve střední Evropě. Tatínkova láska k přírodě a to hlavně k rybářství vyvrcholí tím, že se rozhodne koupit rybník údajně plný kaprů. Netrvalo mu to dlouho, než se mu podařilo najít rybník, který by k prodeji byl, a to za deset tisíc korun. Prodal mu jej jakýsi doktor Václavík, který působil velmi seriózním dojmem. Tatínek chvíli ještě s nákupem otálel, neboť tenkrát deset tisíc bylo docela hodně. Doktor, aby ho přesvědčil, jak výhodná je to koupě, hodil do vody kus housky. Z hloubky se najednou vynořila velká kapří tlama a houska nenávratně zmizela kdesi v rybníce. Tatínek byl šťastný, jak výhodná je to koupě. Veden láskou k rybám si nedovedl představit, že by se mohlo jednat o podvod. Blížila se doba výlovu a šťastný tatínek pozval všechny známé, zkrátka se slavilo a všichni se těšili na bohatý výlov. Rybáři zahájili výlov, jehož výsledkem však byl jediný kapr. Tatínek samozřejmě poznal rybu, byla to ta, která s vervou zhltla onu housku. Všichni se smáli, jen Pavlovi rodiče z toho byli nešťastní.  Uplynula řada let. Pavlův tatínek se živil prodejem ledniček a vysavačů. Jednoho dne za ním přišel i pan Václavík, který sháněl ledničku. Tatínek pookřál a okamžitě myslel na odplatu. Samozřejmě však nedal na sobě nic znát a tvářil se tak, jako by na vše už dávno zapomněl. Sehnal panu doktorovi přenádhernou ledničku, s mramorovou deskou navrch. Byla velmi drahá, stála deset tisíc tři sta, ale tatínkovi se podařilo přesvědčit Václavíka, že člověk na jeho úrovni by měl mít jen to nejkvalitnější. Tatínkova odplata však byla sladká. Lednička navenek působila opravdu dokonale, ale chyběl jí chladící mechanismus. A tak stejně, jako kdysi tatínek koupil rybník bez ryb, koupit nyní pan doktor vlastně jen hezčí bednu.  Ve stejnojmenné povídce Smrt krásných srnců se tatínek vypraví za protektorátu do svého milovaného lesa, aby sehnal nějaké vydatné jídlo pro své syny, kteří odcházejí do koncentračních táborů. Vůbec ho však nenapadne, že vlastně riskuje svůj vlastní život. Zpočátku mu ale štěstí nepřeje a na jeho háček se ne a ne nějaká ta ryby chytit. Rozhodne se tedy, že si půjčí od strýčka Proška psa a uloví srnce. Přes různé útrapy se mu to podaří a dopraví srnce domů. Právě toto poslední vydatné jídlo před nuceným odchodem do koncentračních táborů pravděpodobně zachránilo jeho kamarádům život, který za války byl plný utrpení a skomírání. Další povídky jsou Ve službách Švédska, Kapři pro wehrmacht, Otázka hmyzu vyřešena, Králící s moudrýma očima.  Ota Pavel dokázal v jedné jediné knížce zachytit komické příběhy a zároveň strastiplné a bolestné. Je jedním z mála autorů, který se dokázal věnovat jak útrapám války, tak i době veselí a štěstí. To jen svědčí o jeho uměleckých kvalitách.","id":53},{"author":"Zdena Salivarová","name":"Honzlová","pages":254,"type":"próza","categories":"román","theme":"komunizmus","mood":"smutný","year":1972,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/honzlova-16158","thumbnail":"https://www.databazeknih.cz/images_books/16_/16158/honzlova-16158.jpg","description":"V nezapomenutelném příběhu Jany Honzlové, neprokádrované členky souboru písní a tancí Sedmikráska, dokázala tehdy začínající autorka to, na čem ztroskotalo předtím i později mnoho slavnějších a zkušenějších spisovatelů: pro dnešní i budoucí generace věrně zachytila a spoutala do do živého tvaru frašku zvanou \"budování socialismu\". Román s výrazně autobiografickými prvky začala psát Zdena Salivarová ještě v Praze, dokončila jej až v Torontu, kam se po roce 1968 přestěhovala se svým manželem J. Škvoreckým.","id":54},{"author":"Milan Kundera","name":"Život je jinde","pages":365,"type":"próza","categories":"román","theme":"komunizmus","mood":"šťastný","year":1973,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=-ZRhAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/89_/896/big_zivot-je-jinde-Xop-896.jpg","url":"https://www.databazeknih.cz/knihy/zivot-je-jinde-896","description":"„Tématem mých románů není kritika společnosti. Život je jinde je situován do roku 1948, do doby zešílevšího stalinismu. Ale mou ambicí nebylo kritizovat režim! Kritizovat ho v roce 1969, kdy jsem román dopisoval, by bylo nošení dříví do lesa. Téma románu je existenciální: je to téma lyrismu. Revoluční lyrismus komunistického teroru mne zajímal, protože vrhal netušené demaskující světlo na odvěký lyrický sklon člověka. “Nesmrtelnost. Milan Kundera napsal Život je jinde česky v roce 1969; poprvé vyšel francouzsky pod názvem La vie est ailleurs v Éditions Gallimard roku 1973; v témže roce román získal francouzskou literární cenu Prix Médicis. Česky vyšel poprvé v nakladatelství Sixty-Eight Publishers, Corp. v Torontu roku 1979.","id":55},{"author":"Ota Filip","name":"Nanebevstoupení Lojzka Lapáčka ze Slezské Ostravy","pages":587,"type":"próza","categories":"román","theme":"život, válka, komunizmus, volnočasové aktivity","mood":"šťastný","year":1974,"images":"FALSE","description":"Idylické vyprávění o životě ve Slezsku a zejména v Ostravě od 30. let do r. 1968 je svázáno s postavou typického \"malého\" člověka. ","smallThumbnail":"http://books.google.com/books/content?id=rtAnDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/35_/35568/nanebevstoupeni-lojzka-lapacka-ze-slezske-ostravy-35568.jpg","url":"https://www.databazeknih.cz/knihy/nanebevstoupeni-lojzka-lapacka-ze-slezske-ostravy-35568","id":56},{"author":"Ferdinand Peroutka","name":"Oblak a valčík","pages":312,"type":"próza","categories":"román","theme":"válka","mood":"smutný","year":1976,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/oblak-a-valcik-51321","thumbnail":"https://www.databazeknih.cz/images_books/51_/51321/big_oblak-a-valcik-51321.jpg","description":"Odehrává se převážně v Praze a nejmenovaném koncentračním táboře, a východiskem je předvečer 15. března 1939, kdy se zásadně mění osud několika stálých návštěvníků jedné pražské kavárny, převážně bankovních úředníků a Židů. Autorovým cílem bylo vytvořit s odstupem času panoráma, v němž doba a lidé navzájem prorůstají a které ukazuje jednotlivce tragicky zasaženého dějinnými událostmi.","id":57},{"author":"Josef Škvorecký","name":"Příběh inženýra lidských duší","pages":680,"type":"próza","categories":"román","theme":"komunizmus, život","mood":"neutrální","year":1977,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=1DBDAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/14_/142595/pribeh-inzenyra-lidskych-dusi-142595.jpg","url":"https://www.databazeknih.cz/knihy/pribeh-inzenyra-lidskych-dusi-142595","description":"V roce 1984 Josef Škvorecký o svém románu napsal: „Pokrývá asi třicet pět let života, příběhy se odehrávají v různých a velice sobě nepodobných místech na zeměkouli, v Čechách, v Německu, ve Spojených státech, v Kanadě. Zdálo se mi, že chronologické zachycení osudů na pozadí naší doby, kde šílenství války a místní despotové se zmocňují celých zemí a kontinentů, je neadekvátní. ... Hlavou se mi honily stovky historek, tucty bezdějových dějů; odmítaly srovnat se do přehledných vzorů. Nahodil jsem epizody, konverzace, images na kousíčky papíru, pak jsem se usadil na podlaze, a jako kdybych dával dohromady gigantickou skládačku, začal jsem těmi útržky minulosti šoupat.“ ","id":58},{"author":"Vladimír KÖRNER","name":"Údolí včel","pages":150,"type":"próza","categories":"historický román, novela","theme":"náboženství, život","mood":"smutný","year":1978,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=9JvqAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/28_/28513/udoli-vcel-Zyr-28513.jpg","url":"https://www.databazeknih.cz/knihy/udoli-vcel-28513","description":"Středověký příběh z krajiny včel a německých rytířů, který je znám rovněž z vynikajícího filmového zpracování Františka Vláčila.","id":59},{"author":"Jaroslav Seifert","name":"Deštník z Piccadilly","pages":122,"type":"poezie","categories":"","theme":"život, válka","mood":"smutný","year":1979,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/destnik-z-piccadilly-127732","thumbnail":"https://www.databazeknih.cz/images_books/12_/127732/destnik-z-piccadilly-127732.jpg","description":"Sbírka veršů, které jsou jakýmsi vyrovnáním se životem a stářím. Básně jsou psány volným veršem a přes vědomí blízkosti smrti vyznívají jako vášnivý chvalozpěv života a lásky.","id":60},{"author":"Karel PECKA","name":"Motáky nezvěstnému","pages":399,"type":"próza","categories":"román, biografický román","theme":"válka, komunizmus","mood":"smutný","year":1980,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/motaky-nezvestnemu-3507","thumbnail":"https://www.databazeknih.cz/images_books/35_/3507/motaky-nezvestnemu-3507.png","description":"Román se opírá o autorovy autentické zážitky: strávil léta v československém koncentračním táboře a podal obraz muže, který ve vězeňských podmínkách zápasí o to, aby zůstal člověkem. Autor bývá nazýván českým Solženicynem a jeho kniha je ojedinělá i v souvislosti evropských literatur.","id":61},{"author":"Ludvík VACULÍK","name":"Český snář","pages":481,"type":"próza","categories":"literatura náuční, biografický román, deníky","theme":"komunizmus","mood":"neutrální","year":1981,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/cesky-snar-19812","thumbnail":"https://www.databazeknih.cz/images_books/19_/19812/cesky-snar-19812.jpg","description":"Autorův deník z let 1979-1980 se před očima čtenáře skládá v promyšlenou mozaiku činů, myšlenek a postav a vytváří pestrý a mnohovrstevný obraz normalizační doby. Líčí autenticky existenci českých chartistů i ostatní české intelektuální společnosti v letech, kdy nikdo nedoufal v konec totalitního režimu. Ve zpodobení každodenního života disidentů dominuje autorova činnost kolem samizdatové edice Petlice, společenský život jako způsob disidentské ochrany před ztrátou normálního rozměru lidského života a rozmanité způsoby obrany před průběžným pronásledováním STB. Kniha je jedinečným dokumentem období a zároveň i ojedinělým literárním dílem, plným moudrosti a humoru. ","id":62},{"author":"Bohumil Hrabal","name":"Obsluhoval jsem anglického krále","pages":238,"type":"próza","categories":"román","theme":"život","mood":"šťastný","year":1982,"images":"FALSE","description":"Od dvacátých do padesátých let prožívá svůj příběh od mládí snaživý a podnikavý muž, který touží po bohatství, po lásce a uznání ve své profesi a poznává život od vybrané společnosti a velkého světa po věznění a osamocení v opuštěném pohraničí, kde končí jako cestář. Existenciální téma autor nepojímá tragicky. Hlavnímu hrdinovi samota umožňuje zbavit se touhy po majetku a uznání, zbavit se lpění na nich a dojít ke svérázné, prosté filozofii života, kde se hořkostí a samotou platí za požitek krásy a svobody.","smallThumbnail":"http://books.google.com/books/content?id=Nc3pAgAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/24_/243/big_obsluhoval-jsem-anglickeho-krale-kSJ-243.jpeg","url":"https://www.databazeknih.cz/knihy/obsluhoval-jsem-anglickeho-krale-243","id":63},{"author":"Jaroslav Seifert","name":"Býti básníkem","pages":112,"type":"poezie","categories":"","theme":"život","mood":"smutný","year":1983,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/byti-basnikem-12352","thumbnail":"https://www.databazeknih.cz/images_books/12_/12352/big_byti-basnikem-uUw-12352.jpg","description":"Autorovy verše, načrtnuty záměrně jednoduchou melodickou linkou, jsou protknuty láskou k ženě i pevným přátelstvím ke generačním umělcům, z nichž téměř všichni došli na konec své životní cesty. Svébytné místo v této sbírce zaujímá Praha v nejrůznějších proměnách. Smutek a nostalgie, které dýchají z většiny básní, však nejsou pocity rezignujícími.","id":64},{"author":"Milan KUNDERA","name":"Nesnesitelná lehkost bytí","pages":342,"type":"próza","categories":"román","theme":"komunizmus, život","mood":"neutrální","year":1984,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=y88YAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/89_/898/nesnesitelna-lehkost-byti-898.jpg","url":"https://www.databazeknih.cz/knihy/nesnesitelna-lehkost-byti-898","description":"Slavný román Milana Kundery vychází poprvé v České republice; s obvyklou Poznámkou autora a s doslovem Květoslava Chvatíka. Poprvé vyšel ve francouzském překladu v roce 1984 v Paříži u Gallimarda, v roce 1985 česky v Kanadě v nakladatelství Sixty-Eight Publishers. Vyprávění o lásce, o Tereze a Tomášovi, o Sabině a Franzovi, o lehkosti a tíze bytí...  „Po čtyřech letech strávených v Ženevě ubytovala se Sabina v Paříži a nemohla se vzpamatovat z melancholie. Kdyby se jí někdo ze ptal, co se jí stalo, nenašla by pro to slov. Životní drama se dá vždycky vyjádřit metaforou tíže. Říkáme, že na člověka dopadlo nějaké břemeno. Člověk to břemeno unese nebo neunese, padá pod ním, zápasí s ním, prohrává nebo vítězí. Ale co se vlastně stalo Sabině? Nic. Opustila jednoho muže, protože ho chtěla opustit. Pronásledoval ji pak? Mstil se jí? Ne. Její drama nebylo dramatem tíhy, ale lehkosti. Na Sabinu dopadlo nikoli břemeno, ale nesnesitelná lehkost bytí.“   (4. dotisk r. 2007, ISBN 978-80-7108-281-1)","id":65},{"author":"Ivan Martin Jirous","name":"Magorovy labutí písně","pages":86,"type":"poezie","categories":"","theme":"komunizmus, život","mood":"neutrální","year":1985,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/magorovy-labuti-pisne-6421","thumbnail":"https://www.databazeknih.cz/images_books/64_/6421/magorovy-labuti-pisne-6421.jpg","description":"Pro velký zájem čtenářů vydává nakladatelství Torst samostatné knižní vydání jedné z nejvýznamnějších českých básnických knih druhé poloviny 20. století. Dnes již klasické a v mnoha případech zlidovělé verše napsané v 80. letech ve věznicích v Litoměřicích, Ostrově a Valdicích propašoval z valdického vězení na motacích Jiří Gruntorád. Nové vydání je doplněno barevnou kresbou svatého Huga od Juliany Jirousové a ukázkami faksimilí původního Jirousova rukopisu.","id":66},{"author":"Alexandra Berková","name":"Knížka s červeným obalem","pages":163,"type":"próza","categories":"povídky","theme":"život","mood":"šťastný","year":1986,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/knizka-s-cervenym-obalem-6209","thumbnail":"https://www.databazeknih.cz/images_books/62_/6209/knizka-s-cervenym-obalem-6209.jpg","description":"Kniha povídek, která při svém prvním vydání v roce 1986 dosáhla obrovského nákladu díky hladu čtenářů po nekomerčním, totiž nepartajním, autentickém psaní.","id":67},{"author":"Pavel Kohout","name":"Kde je zakopán pes","pages":547,"type":"próza","categories":"literatura náuční, biografický román","theme":"život, komunizmus","mood":"neutrální","year":1987,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=M4VhAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/21_/21107/kde-je-zakopan-pes-memoaroman-21107.jpg","url":"https://www.databazeknih.cz/knihy/kde-je-zakopan-pes-memoaroman-21107","description":"„Memoáromán“ o zakopaném psu je zprávou o skutečných lidech a činech, které pokryly jedny ctí a druhé hanbou. Je to politická sága sedmdesátých let a zároveň kriminální příběh tím napínavější, že pravdivý. Hlavními protagonisty jsou autor, jeho žena a pes jezevčík, ale také Státní bezpečnost a společnost chartistů. Příběh končí v říjnu 1979, kdy bylo manželům Kohoutovým znemožněno vrátit se po pobytu v zahraničí do Československa, takže byli nuceni emigrovat.","id":68},{"author":"Milan Uhde","name":"Velice tiché Ave","pages":36,"type":"drama","categories":"tragedie","theme":"život, komunizmus","mood":"smutný","year":1988,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=kS8HAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/45_/45374/velice-tiche-ave-45374.jpg","url":"https://www.databazeknih.cz/knihy/velice-tiche-ave-45374","description":"Původně rozhlasová hra. Děj se odehrává převážně v rodinném kruhu. Postavy jsou nazvány jednoduše Matka, Syn, Otec... Syn se baví se zesnulou matkou o minulosti a životě, který prožili v útrapách minulého režimu. Dějem je v podstatě jejich rozhovor plný vzpomínek a objasňování minulých věcí.","id":69},{"author":"Ota Filip","name":"Kavárna Slavia","pages":244,"type":"próza","categories":"román","theme":"komunizmus","mood":"neutrální","year":1989,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/kavarna-slavia-35567","thumbnail":"https://www.databazeknih.cz/images_books/35_/35567/kavarna-slavia-35567.jpg","description":"Pikareskní román, který na příbězích potomka údajné pobělohorské šlechty zachycuje běh našich dějin 20. století s tragikomickou nadsázkou.  Prostor mezi kavárnou Slávií, Karlovým mostem a Malou Stranou je jevištěm, po němž se v různých maskách pohybuje Mikuláš Belecredos, kavárenský povaleč s bujnou fantazií, který pozoruje dějinné události kolem sebe jedním krátkozrakým a druhým dalekozrakým okem. Jeho vidění historie od návštěvy Lenina v Praze až po okupaci 1968 je groteskně deformované, bláznivé a poetické. ","id":70},{"author":"Viktor Fischl","name":"Dvorní šašci","pages":156,"type":"próza","categories":"novela","theme":"válka","mood":"smutný","year":1990,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=LIgYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/15_/15258/dvorni-sasci-15258.jpg","url":"https://www.databazeknih.cz/knihy/dvorni-sasci-15258","description":"Spisy Viktora Fischla. V dalším svazku Spisů Viktora Fischla se mohou čtenáři znovu setkat s proslulou autorovou prózou, která vyšla naposledy v r. 1990 a byla brzy rozebrána. Vypravěčem působivého příběhu pomsty, krutosti a utrpení je soudce, jemuž hrb, jímž je poznamenaný, umožní přežít peklo koncentračního tábora. Stane se totiž jedním z „dvorních šašků“ na dvoře velitele tábora, sloužících jako atrakce a rozptýlení při jeho četných večírcích. Filmová práva k této knize zakoupil Miloš Forman.","id":71},{"author":"J. H. Krchovský","name":"Noci, po nichž nepřichází ráno","pages":108,"type":"poezie","categories":"","theme":"život","mood":"neutrální","year":1991,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/noci-po-nichz-neprichazi-rano-36831","thumbnail":"https://www.databazeknih.cz/images_books/36_/36831/big_noci-po-nichz-neprichazi-rano-ewv-36831.jpg","description":"„Krchovský, jenž byl mimochodem právě za tento výbor ze svých básní oceněn cenou časopisu Revolver Revue, je hotovou básnickou osobností s naprosto vyhraněným a originálním viděním světa, které dokáže neméně originální formou zprostředkovat i čtenářům. Jeho básním se lze smát, lze jimi být však i okouzlen pro jejich brutální krásu a krutě cynickou citlivost. A právě tam, kde se střetává děsivé s nádherným, kde padá šklebivá maka zábavy a objevuje se duše a cit, je Krchovský nejlepší. Čehož důkazem je i báseň ze sbírky Zamilovaný dement (s.78): „JSEM HRSTKA PRACHU ZE SVÝCH KOSTÍ / jsem chladný popel bez urny/ a průvan, přízrak nestvůrný/ mne rozfoukává po místnosti/ - a kde jsi ty? Tvá ruka, kde je?!/ jen tichý vzdech se ozval tmou/ jsem popel, jenž už nezahřeje/ tvou ruku větrem rozvátou“.“ Andrej Halada","id":72},{"author":"Jan ZÁBRANA","name":"Celý život","pages":1046,"type":"próza","categories":"deníky","theme":"život, komunizmus","mood":"neutrální","year":1992,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=fw9hAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/11_/11326/big_cely-zivot-g4g-11326.jpg","url":"https://www.databazeknih.cz/knihy/cely-zivot-11326","description":"Výbor z deníků 1948 / 1984. Ucelené vydání deníkových zápisků Jana Zábrany, které se rozprostírají téměř celým obdobím komunistického režimu, zahrnují nejen reflexi dobových událostí, ale jsou i jistým oknem do duše tohoto českého básníka a překladatele. Nepatří vůbec ke strohým faktickým poznámkám, ale glosují vnitřní hnutí, představy, jež se před našima očima mění v básně.","id":73},{"author":"Milan Kundera","name":"Nesmrtelnost","pages":358,"type":"próza","categories":"román","theme":"život","mood":"neutrální","year":1993,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/nesmrtelnost-899","thumbnail":"https://www.databazeknih.cz/images_books/89_/899/nesmrtelnost-899.jpg","description":"Nesmrtelnost nejúplněji z celého dosavadního Kunderova Díla ztělesňuje román jako hravý nápad, který se rozvíjí před čtenářovýma očima, a přitom strhuje do hry autorův skvělý intelekt i silnou obraznost, takže hravá poloha je kontrapunktována osudovými tématy lásky a předstírání, pravdy a lži, složitosti života a smrti.","id":74},{"author":"Jáchym Topol","name":"Sestra","url":"https://www.databazeknih.cz/knihy/sestra-4925","pages":464,"type":"próza","categories":"román","theme":"komunizmus","mood":"neutrální","year":1994,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=_wVhAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/49_/4925/sestra-4925.jpg","description":"Prvotina Jáchyma Topola patří k nejpřekládanějším polistopadovým českým románům. Jde o osobitou výpověď o životě v bývalém Československu na konci 80. a počátku 90. let 20. století. Mnohovrstevné vyprávění začíná útěky Němců přes Československo na západ, pokračuje listopadovou revolucí, dotýká se rasismu, kriminality, narkomanie a dalších společenských jevů, které přinesla překotná doba a které zasáhly především mládež. Vyprávění nemá souvislou linii, často jde o kupení dojmů a působivých obrazů se spoustu literárních citací.","id":75},{"author":"Vlastimil TŘEŠŇÁK","name":"Klíč je pod rohožkou","pages":498,"type":"próza","categories":"román","theme":"život, komunizmus","mood":"šťastný","year":1995,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=z8UYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/36_/36442/klic-je-pod-rohozkou-36442.jpg","url":"https://www.databazeknih.cz/knihy/klic-je-pod-rohozkou-36442","description":"Rozsáhlý román známého zpěváka, výtvarníka, prozaika a fotografa prochází mnoha městy Německa, USA a Prahou při hledání hrdinova domova i paměti.","id":76},{"author":"Lubomír MARTÍNEK","name":"Palimpsest","pages":176,"type":"próza","categories":"literatura náuční","theme":"život","mood":"neutrální","year":1996,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=sbnqAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/16_/164252/palimpsest-164252.jpg","url":"https://www.databazeknih.cz/knihy/palimpsest-164252","description":"Kniha volně navazuje na Martínkovu sbírku textů Nomad's Land. Jeho pokus (v původním slova smyslu) nastínit imaginární portréty cizince, nomáda a blouda, je autorovou završující úvahou o svém věčném putování a nesamozřejmosti lidské existence na konci tohoto století. Skládá se ze tří částí: - Cizinec - Nomád - Bloud ","id":77},{"author":"Josef TOPOL","name":"Básně","url":"https://www.databazeknih.cz/knihy/basne-61592","pages":431,"type":"poezie","categories":"","theme":"život, komunizmus","mood":"neutrální","year":1997,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=2QdhAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/61_/61592/basne-tna-61592.png","description":"Josef Topol je vedle dramat též autorem rozsáhlého básnického díla, čtenářům po desítky let z velké většiny neznámého, přestože se svou hodnotou řadí k tomu nejlepšímu, co v české poezii 20. století vzniklo. Topolova poetika vyrůstá jakoby mimo kontext poválečné české poezie, její zdroje lze vytušit u anglických alžbětinců, Johna Donna či Karla Hynka Máchy a Karla Jaromíra Erbena. Svazek obsahuje celek Topolovy básnické tvorby - verše vznikající od začátku padesátých let do konce let osmdesátých.","id":78},{"author":"Irena Dousková","name":"Hrdý Budžes","pages":168,"type":"próza","categories":"humoristický román","theme":"komunizmus","mood":"šťastný","year":1998,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=jnbqAAAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/27_/2748/hrdy-budzes-2748.jpg","url":"https://www.databazeknih.cz/knihy/helenka-souckova-hrdy-budzes-2748","description":"Chcete se zasmát, zastydět a zavzpomínat? Prvními roky husákovské normalizace, tak jak se v řadě komických i méně veselých příhod a situací promítala do života dětí i dospělých z jednoho okresního města, nás v této knize provází bystrá, leč přiměřeně naivní žákyně druhé třídy ZDŠ v Ničíně Helenka Součková.  Po mimořádném ohlasu vychází kniha v novém vydání a zároveň byla úspěšně uvedena jako divadelní hra.","id":79},{"author":"Ivan LANDSMANN","name":"Pestré vrstvy","pages":499,"type":"próza","categories":"román, biografický román","theme":"život, komunizmus","mood":"neutrální","year":1999,"images":"FALSE","description":"Autobiografický román z prostředí ostravských dolů a holandského exilu. Svou nepřibarvenou autenticitou se řadí k nejvýraznějším českým literárním počinům posledních let. Kniha zvítězila v tradiční anketě Lidových novin Kniha roku 1999.","smallThumbnail":"http://books.google.com/books/content?id=0bNUDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/29_/29064/pestre-vrstvy-29064.jpg","url":"https://www.databazeknih.cz/knihy/pestre-vrstvy-29064","id":80},{"author":"Ota Filip","name":"Sedmý životopis","pages":376,"type":"próza","categories":"literatura náuční, biografický román","theme":"život, válka, komunizmus","mood":"neutrální","year":2000,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=SZMYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/14_/14539/sedmy-zivotopis-14539.jpg","url":"https://www.databazeknih.cz/knihy/sedmy-zivotopis-14539","description":"Autobiografický román vypráví o 40. a 50.letech v Čechách a je odezvou na autorovo obvinění ze spolupráce s STB. Děj románu se odvíjí od září r.1939, kdy otec, jenž se \"dal k Němcům\" násilím odvádí svého devítiletého syna do ostravské německé školy. Konec války už prožívá mladý Ota v Praze. Protlouká se životem s pomocí svého strýce, finančně podporuje svou rodinu, když je otec odsouzen za kolaboraci. Po maturitě nastupuje jako redaktor v Mladé frontě a v r. l951 je odveden na vojnu k tzv. \"černým baronům\", kde je zapleten do pokusu o útěk na Západ a vykoupen podpisem spolupráce s STB. Na pozadí barvitého líčení \"velkých dějin\" se odehrává osobní příběh dospívání a zrání mladého muže, jeho vyrovnání s rodiči, prvními láskami i nepřející dobou. Silné osobní angažmá činí z románu zajímavou četbu, která nešetří nikoho, nejméně pak hlavního \"smutného hrdinu\".","id":81},{"author":"Květa Legátová","name":"Želary","pages":240,"type":"próza","categories":"povídky","theme":"život","mood":"smutný","year":2001,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=hMkYAQAAIAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/57_/5720/zelary-5720.jpg","url":"https://www.databazeknih.cz/knihy/zelary-5720","description":"Želary jsou ucelený cyklus osmi povídek, který je navzájem propojený jednotlivými hlavními postavami. Poprvé vyšly roku roku 2001 v nakladatelství Paseka a o rok později obdržely Státní cenu za literaturu. Děj jednotlivých povídek popisuje osudy obyvatel fiktivní stejnojmenné zapadlé horské vesnice nacházející se v Beskydech na moravsko-slovenském pomezí a jejich bídu v období první republiky.  Většina postav se následně objevuje v pozdějším autorčině opusu (vydaném v Pasece o rok později), v knize Jozova Hanule, která ovšem byla zfilmována pod názvem Želary, čímž byl odstartován zmatek, trvající dodnes. Dokonce i ministerstvo kultury ČR při nedávném autorčině umrtí na svém webu uvedlo, že film Želary je filmovou verzí stejnojmenného románu.","id":82},{"author":"Václav CÍLEK","name":"Krajiny vnitřní a vnější","pages":272,"type":"próza","categories":"literatura náuční","theme":"příroda","mood":"neutrální","year":2002,"images":"TRUE","url":"https://www.databazeknih.cz/knihy/krajiny-vnitrni-a-vnejsi-1072","thumbnail":"https://www.databazeknih.cz/images_books/10_/1072/big_krajiny-vnitrni-a-vnejsi-b0b-1072.jpg","description":"Krajina se od 90. let 20. století stala jedním z klíčových pojmů přírodních, ale i některých humanitních věd. První polovina textů se týká skutečné, fyzické krajiny, jejích proměn a ochrany. Druhá část je věnována vnitřním krajinám duše – fenoménu genia loci, postavě Zeleného muže, keltským bohům v druhohorách atp. Celek uzavírají Poutníkova pravidla putování po posvátných místech a obsáhlý soupis literárních i hudebních pramenů, které jsou pro vstup do krajiny potřebné. Hlavním motivem knihy zůstává nutnost chránit krajinu kvůli jí samé, kvůli živlům, skalám, vodám a životu, ale také kvůli sobě a vlastní duši.   2., doplněné vydání","id":83},{"author":"Tomáš Halík","name":"Oslovit zachea","pages":500,"type":"próza","categories":"román, duchovní literatura","theme":"náboženství","mood":"neutrální","year":2003,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/oslovit-zachea-9200","thumbnail":"https://www.databazeknih.cz/images_books/92_/9200/oslovit-zachea-9200.jpg","description":"Obraz Zachea, jerišského celníka skrývajícího se ve větvích fíkovníku, aby mohl nepozorován sledovat Kristovo počínání a teprve se rozhodnout pro jeho následování, je pro Tomáše Halíka totožný s představou většiny současných lidí, kteří teprve hledají svou cestu v křesťanství, váhají a dychtí zároveň. Smysl své pastorační činnosti spatřuje právě v jejich oslovování. Myšlenka „oslovit Zachea“ Tomáše Halíka zaměstnávala déle. Nakonec si pro její knižní konkretizaci vybral tradiční formu kázání. Vznikla tak pozoruhodná syntéza věčného obsahu Bible s výrazným aktualizujícím dobovým vkladem autorovy osobnosti.","id":84},{"author":"Jan NOVÁK","name":"Zatím dobrý","pages":800,"type":"próza","categories":"historický román","theme":"komunizmus","mood":"neutrální","year":2004,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/zatim-dobry-23623","thumbnail":"https://www.databazeknih.cz/images_books/23_/23623/zatim-dobry-23623.jpg","description":"Zřejmě žádná událost z našich moderních dějin nevyvolává tolik otazníků a protikladných soudů jako „případ“ bratrů Mašínových. Jaké stanovisko zaujmout k tomu, co se tehdy stalo? A jsme vůbec s to pochopit, co všechno aktéři tohoto příběhu prožívali? Jan Novák, americký spisovatel českého původu, svým románem-dokumentem znovu vrací celou kauzu do prostředí, kde její zpodobení nadiktoval komunistický režim v seriálu Třicet případů majora Zemana. Autor bez patosu a syrovým jazykem — odpovídajícím drsným časům, o nichž je řeč — řetězí fakty a nechává je mluvit samy za sebe. Jeho podmanivý příběh vypráví nejen o pohnutých osudech jedné rodiny, ale rovněž o době, která si s lidmi tak krutě pohrávala. Autor za svůj román obdržel cenu Magnesia Litera 2005 pro nejlepší knihu roku.","id":85},{"author":"Jiří Hájíček","name":"Selský baroko","pages":176,"type":"próza","categories":"román","theme":"život, komunizmus","mood":"neutrální","year":2005,"images":"FALSE","description":"V beletrii posledních let se najde jen málo knih, které by se zabývaly naší nedávnou minulostí, a není snad jediné, jejímž tématem by bylo období kolektivizace vesnice v 50. letech. V novele Selský baroko se o takovou historickou reflexi pokouší Jiří Hájíček (1967), autor generace, která vyrůstala dávno po tomto temném období selských procesů.  Příběh začíná zdánlivě nenápadně jednoho horkého léta v zámeckém parku v Třeboni. Pavel Straňanský je genealog, který sestavuje v archivech rodokmeny, většinou pro zámožné emigranty, kteří ve staré vlasti hledají své kořeny. Jedna neobvyklá zakázka jej však přivádí do historie poměrně nedávné a před Pavlem náhle vyvstává příběh vesnické krásky Rozálie Zandlové a sedláků z obce Tomašice.  Osamělý hledač putuje po jihočeském venkově, aby ze zápisů starých kronik a výpovědí pamětníků postupně rekonstruoval příběh udání, které v 50. letech přivedlo několik sedláků do vězení. Vše se však stále více zamotává a Pavel zjišťuje, že jeho téměř detektivní pátrání, které jej přivádí až do žhavé současnosti, namísto jasných odpovědí vyvolává jen další otázky. A ty zůstávají vlastně stále stejné, ať se jedná o příběh starý padesát let nebo několik týdnů. Jak by měl člověk zacházet s vinou, pomstou, odpuštěním? Jakou moc má nad námi minulost?  Magnesia Litera 2006 za prózu  3. místo v anketě Lidových novin Kniha roku 2005","smallThumbnail":"http://books.google.com/books/content?id=nXhKDQAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/12_/12932/big_selsky-baroko-rUp-12932.jpg","url":"https://www.databazeknih.cz/knihy/selsky-baroko-12932","id":86},{"author":"Petra Dvořáková","name":"Proměněné sny","pages":164,"type":"próza","categories":"duchovní literatura","theme":"náboženství","mood":"neutrální","year":2006,"images":"FALSE","description":"Deset rozhovorů o iluzích a deziluzích, které přináší víra.  Knížka rozhovorů Petry Dvořákové je dobrá. Proč? Především je to v podstatě dokument o jedné křesťanské generaci. Máme před sebou materiál, jehož platnost nepomine, protože prchavá svědectví „zezdola\" o církvi v osmdesátých a devadesátých letech budou jednou skutečnou kronikou toho, jak to bylo. Nikoli tedy protokoly ze zasedání biskupské konference či nějaké další dokumenty, které nikdo rozumný nečte. Tyto rozhovory jsou určitou „anatomií\" (většinou) mladých křesťanských životů a jejich nehod. Jednotlivá vyprávění přinášejí svědectví o tom, co je to duchovní moc a jakých destruktivních podob může nabýt.","smallThumbnail":"http://books.google.com/books/content?id=6-r2AwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/14_/14557/big_promenene-sny-P6y-14557.jpg","url":"https://www.databazeknih.cz/knihy/promenene-sny-14557","id":87},{"author":"Jiří Voskovec – Jan Werich","name":"Korespondence I, II","pages":352,"type":"próza","categories":"biografický román, deníky","theme":"život, komunizmus","mood":"neutrální","year":2007,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=jPUKAQAAMAAJ&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/29_/292099/korespondence-i-ii-3XH-292099.jpg","url":"https://www.databazeknih.cz/knihy/korespondence-i-ii-292099","description":"Dvanáctý díl edice Studia etymologica Brunensia podává ve dvou svazcích soubor Machkovy přijaté i odeslané korespondence pocházející z let 1929-1965.  Zahrnuje dopisy osobní i institucionální povahy, a dává nám tak nahlédnout z nové perspektivy do života a díla tohoto vědce, ale přináší i řadu informací v širším vědeckém a společenském kontextu.","id":88},{"author":"Teraza Boučková","name":"Rok kohouta","pages":332,"type":"próza","categories":"literatura náuční, biografický román","theme":"život","mood":"smutný","year":2008,"images":"FALSE","smallThumbnail":"http://books.google.com/books/content?id=lHfyKmOogw4C&printsec=frontcover&img=1&zoom=5&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/57_/576/rok-kohouta.jpg","url":"https://www.databazeknih.cz/knihy/rok-kohouta-576","description":"Spisovatelka, která nemůže psát. Tíseň úplně strašlivá. Nikomu to neříkám. Stejně to nepomůže. Já mám tíseň a já s tím musím něco dělat. Nikomu to neříkám a přitom mám čím dál větší potřebu s někým se objímat (a být objímaná), někoho hladit (a být pohlazená), s někým se milovat (a být milovaná), k někomu se schoulit... Je devět. Patrik má mít první výslech na policii (z úterka přeloženo na středu, nevím proč). Když jsme mu nestáli ani za telefonát, z účasti jsem se omluvila. Nezajímá mě to. Jak to asi probíhá? Policie už Patrika dávno neznervózňuje ani nestresuje, po všech útěcích z výchovného ústavu, po šťárách v pražských nočních klubech, kde se převážně zdržuje, po tom, co ho několikrát sebrali a drželi na vyšetřovně, dokud si pro něj z ústavu nepřijeli... Je v pohodě. Tíseň.","id":89},{"author":"Pavel ŠRUT","name":"Lichožrouti","url":"https://www.databazeknih.cz/knihy/lichozrouti-11885","pages":232,"type":"próza","categories":"literatura pro deti, pohádky","theme":"život","mood":"šťastný","year":2009,"images":"TRUE","thumbnail":"https://www.databazeknih.cz/images_books/11_/11885/lichozrouti-11885.jpg","description":"Je to nejobratnější lupič všech dob a dosud nikdy nebyl dopaden. Možná i vám se včera nebo právě v této chvíli ztratila ponožka. Kdo za to může? Lichožrout! Záhadný tvor, který žere ponožky a z párů dělá licháče. Do jejich tajemného světa pronikla autorská a ilustrátorská dvojice Pavel Šrut – Galina Miklínová a vynořila se s napínavým a vtipným příběhem jedné lichožroutí rodinky, starého mládence pana Vavřince a malého nešiky lichožrouta Hihlíka. ","id":90},{"author":"Kateřina TUČKOVÁ","name":"Vyhnání Gerty Schnirch","pages":416,"type":"próza","categories":"historický román","theme":"válka, život","mood":"smutný","year":2010,"images":"FALSE","description":"Noc z 30. na 31. 5. 1945. Gerta Schnirch, matka několika­měsíční dcerky, je jen s osobními věcmi odsunuta společně s ostatními brněnskými Němci směrem na Vídeň. Vyčerpávající pochod skončí v Pohořelicích, kde mnoho vyhnanců podlehne epidemii tyfu a úplavice. Gerta a některé další německé ženy se zachrání při nucených pracích na jižní Moravě, kde setrvají i po ukončení transportů. Po znovuzískání československého občanství se Gerta vrací do Brna, v němž prožívá další bouřlivé události druhé poloviny dvacátého století.","smallThumbnail":"http://books.google.com/books/content?id=vNf5AwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/29_/29103/big_vyhnani-gerty-schnirch-SiS-29103.jpg","url":"https://www.databazeknih.cz/knihy/vyhnani-gerty-schnirch-29103","id":91},{"author":"Miloš DOLEŽAL","name":"Jako bychom dnes zemřít měli","pages":446,"type":"próza","categories":"literatura náuční, biografický román","theme":"komunizmus, náboženství","mood":"smutný","year":2012,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/jako-bychom-dnes-zemrit-meli-137916","thumbnail":"https://www.databazeknih.cz/images_books/13_/137916/big_jako-bychom-dnes-zemrit-meli-Z6S-137916.jpg","description":"Drama života, kněžství a mučedniké smrti číhošťského faráře P. Josefa Toufara.  Noc z 23. na 24. února 1950. Černý tudor projíždí zasněženou Vysočinou. Vpředu řidič se spolujezdcem, který popíjí čaj z termosky. Na zadním sedadle zhrouceně leží osmačtyřicetiletý kněz s oteklou tváří, který má na nohou narvané bačkory, na nártu rozstřihnuté, aby se do nich jeho opuchlé nohy vůbec vešly. Dva rozsvícené světlomety metají žluté kužely po sněhu. Je po půlnoci a pražští příslušníci StB soudruzi Bohumil Košař a Stanislav Cvíček právě přivezli z valdické věznice do Číhoště na filmovou rekonstrukci kněze Josefa Toufara. Dobitého po brutálních výsleších, těžce a sípavě dýchajícího, podivně zkrouceného a držícího se za břicho. To už není ani Getsemanská zahrada, ani bičování – teď se losuje o jeho šat. Jihlavský estébák Josef Solař, který na kraji vsi žoviálně vítal unavené soudruhy z Valdic, v roce 1968 prohlásí: „Toufar nemohl normálně jít a dva naši soudruzi jej museli vést. Při této chůzi vydával bolestné nářky. Trochu mi to připomínalo chroptění.“  Advent 1949, zasněžená mrazivá Vysočina, nedělní dopoledne 11. prosince. V malém kostele v Číhošti se při kázání sedmačtyřicetiletého P. Josefa Toufara třikrát zakýval dřevěný oltářní křížek a zůstal zkroucen a vychýlen mimo těžiště. Pohyb křížku vidělo dvacet svědků. Následně se do rozbíhajícího církevního objasňování vlomila komunistická Státní bezpečnost. P. Toufar byl zatčen, unesen a mučením jej příslušníci StB nutili lživě doznat, že vše podvodně sestrojil. Toufarova mučednická smrt zhatila připravovaný inscenovaný monstrproces, nezastavila však otevřený útok komunistického aparátu proti katolické církvi. Autor této knihy se zdaleka nespokojil s tím, že by začal vypravovat životní příběh kněze Josefa Toufara (1902 až 1950) dnem jeho příjezdu do Číhoště. Dosud stál hlavní aktér příběhu stranou, nikde nebylo možné dočíst se, z jakých pocházel poměrů, co jej vedlo k rozhodnutí stát se knězem a jak dlouhá cesta vedla k vysvěcení. Základní pohnutkou k sepsání díla nebylo vyvrácení či potvrzení toho, zda se křížek skutečně v adventním čase roku 1949 tajemně zahýbal, ale naléhavá touha pochopit, kdo Josef Toufar byl a co všechno v jeho údělu předcházelo dějství poslednímu. Léta pátrání, shromažďování dokumentů, snímků i svědeckých výpovědí tvoří opěrný systém díla. Miloš Doležal nepojímá obsáhlý životopisný portrét patera Toufara jako chladné historické pojednání, nechybí v něm bezprostřednost ani humor, a přece ani o krok neustoupí požadavku na absolutní dokumentární věrnost, každou uvedenou informaci opírá o konkrétní nálezy v archivech a osobní svědectví pamětníků. Kniha Jako bychom dnes zemřít měli se skládá ze dvou rovnocenných částí, textové a obrazové. Vzniklý celek je také důkladně vyvedenou kronikou života jedné části Vysočiny v první polovině minulého století, krajiny, jež v sobě nese stigmata hrdinů a mučedníků. Spolu s autorem, pamětníky i fotografiemi putujeme po místech dnes zbořených, zatopených, či zjizvených necitelnými zásahy do krajinného profilu z dob komunismu. Ne náhodou říká básník a historik Zbyněk Hejda, že Miloš Doležal Vysočině vrací její paměť.","id":92},{"author":"Jiří Padevět","name":"Průvodce protektorátní Prahou","pages":808,"type":"próza","categories":"literatura náuční","theme":"válka","mood":"neutrální","year":2013,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/pruvodce-protektoratni-prahou-177576","thumbnail":"https://www.databazeknih.cz/images_books/17_/177576/pruvodce-protektoratni-prahou-mista-udalosti-lide-177576.jpg","description":"Kniha zavede zájemce na místa konspiračních schůzek odbojářů, do bytů rodin podporovatelů parašutistů, připravujících atentát na Reinharda Heydricha, do kanceláří krycích firem Sicherheitsdienstu, do tajné porodnice, zřízené gestapem, na místa, kde trpěli pražští židé, do podzemí, kde nacisté připravovali výstavbu podzemních továren, do sálů, kde se scházeli čeští fašisté a na barikády a velitelská stanoviště Pražského povstání. Zároveň ukáže, že i během okupace byla Praha místem, kde i přes nacistický útlak existovaly ostrůvky svobody a kulturního života. Publikace je doplněna velkým množstvím dosud nepublikovaného obrazového materiálu a přehlednými mapkami.","id":93},{"author":"Martin REINER ","name":"Básník (Román o Ivanu Blatném)","pages":600,"type":"próza","categories":"román, biografický román","theme":"život, komunizmus","mood":"neutrální","year":2014,"images":"FALSE","description":"Martin Reiner se poezií a osudem básníka Ivana Blatného (1919–1990) zabývá usilovně již třicet let. Byl autorem scénáře prvního televizního dokumentu o Blatném a desítek novinových článků a rozhlasových pořadů, stál za převozem Blatného pozůstalosti z Londýna do Památníku národního písemnictví, organizoval slavnostní ukládání ostatků Blatného na brněnském Slavíně a významně se podílel i na umístění básníkovy pamětní desky na jeho rodném domě na Obilním trhu. V roce 2000 začal pracovat na románu o básníkově nevšedním životním příběhu. Blatný zažil v Československu nejprve velkou literární slávu, po své emigraci do Anglie v březnu 1948 pak naprostý pád a snahu o vymazání svého jména z českých literárních dějin. Reinerův román je strhující text, který se zabývá nejen básníkovým životem, ale též literárním kontextem, dobou a místy, na nichž Ivan Blatný žil. Dozvíme se zde mnoho z literárního života první republiky, stejně jako zajímavé detaily z přátelství mezi Blatným, Ortenem, Kainarem, Chalupeckým, Nezvalem a dalšími. Nahlédneme do protektorátních let a hrůz heydrichiády. Po Blatného emigraci dostaneme možnost seznámit se s intrikami, jimiž dlouhé roky žil český politický exil, stejně jako s činností komunistických agentů v zahraničí. A básníka neopustíme ani v blázincích, v nichž strávil většinu z čtyřiceti let svého života v Anglii. Kniha je nabitá dosud neznámými informacemi, zároveň je však silně emotivní. Životní úděl Ivana Blatného je jedním z velkých českých osudů 20. století. Reinerova kniha o něm vypovídá svrchovaným způsobem.  První vydání.","url":"https://www.databazeknih.cz/knihy/basnik-roman-o-ivanu-blatnem-202540","thumbnail":"https://www.databazeknih.cz/images_books/20_/202540/big_basnik-roman-o-ivanu-blatnem-tm4-202540.jpg","id":94},{"author":"Anna Bolavá","name":"Do tmy","url":"https://www.databazeknih.cz/knihy/do-tmy-240709","pages":232,"type":"próza","categories":"román","theme":"život, příroda","mood":"smutný","year":2015,"images":"FALSE","thumbnail":"https://www.databazeknih.cz/images_books/24_/240709/big_do-tmy-hVO-240709.jpg","description":"Příběh osamělé, nemocné ženy, která většinu života zasvětila sběru, sušení a odevzdávání léčivých rostlin, má od počátku nádech apokalypsy. Děj se posouvá kupředu pomocí detailně propracovaného „plánu sběru“. Konstantou je pak úterý, výkupní den, kdy hrdinka nedočkavě navštěvuje výkupnu. I přes pomalé, zdánlivě nevzrušené tempo probublává pod hladinou podivný neklid. Rafinovaný styl nás kapitolu po kapitole vtahuje hlouběji: hlouběji do staré půdy, hlouběji do prokletí sběru bylin.","id":95},{"author":"Ladislav Heryán","name":"Exotem na této zemi","pages":144,"type":"próza","categories":"duchovní literatura","theme":"náboženství","mood":"šťastný","year":2016,"images":"FALSE","url":"https://www.databazeknih.cz/knihy/exotem-na-teto-zemi-304988","thumbnail":"https://www.databazeknih.cz/images_books/30_/304988/big_exotem-na-teto-zemi-Ke5-304988.jpg","description":"Kniha známého salesiánského kněze a pedagoga, „pastýře undergroundu“, je putováním po stopách Božího milosrdenství na této zemi. V krátkých příbězích se setkávají dva světy: svět Heryánovy kněžské každodennosti vyplněný setkáními s lidmi z různých vrstev společnosti, vesměs ale z jejích okrajů, a svět biblických poselství a podobenství. Ty vnášejí do naší současnosti paprsky pochopení a smyslu, ale také nastavují zrcadlo naší pýše a sobectví. Heryán ukazuje, jak je svět naplněn Božím milosrdenstvím, které nás v každé chvíli vybízí k tomu, abychom změnily naše uvažování a nechali se jím prostoupit. Jednotlivé kapitoly-příběhy knihy zaujmou bezprostředností a upřímností, s jakou nahlížejí v Boží perspektivě aktuální dění kolem nás, a prohlubují touhu po obrácení srdcí.","id":96},{"author":"Alena Mornštajnová","name":"Hana","url":"https://www.databazeknih.cz/knihy/hana-324332","pages":310,"type":"próza","categories":"historický román","theme":"život","mood":"smutný","year":2017,"images":"FALSE","description":"Třetí román úspěšné české autorky. Existuje-li něco, co prověřuje opravdovost lidského života, pak je to utrpení. A existuje-li něco, co život znehodnocuje, pak je to utrpení, které člověk působí jiným. Jenže co když je přesto nevinen? Co když je to všechno jen shoda okolností a člověk je pouze bezmocným nástrojem osudu? Je zima roku 1954 a devítiletá Mira se přes zákaz rodičů vypraví k řece jezdit na ledových krách. Spadne do vody, čímž se její neposlušnost prozradí, a je za to potrestána tím, že na rodinné oslavě nedostane zákusek. Nevinná příhoda z dětství však pro Miru znamená zásadní životní zvrat. Následuje tragédie, která ji na dlouhá léta připoutá k nemluvné a depresivní tetě Haně a odhalí pohnutou rodinnou historii, jež nadále popluje s proudem jejího života jako ledová kra. Příběh, který vychází ze skutečných událostí, popisuje Alena Mornštajnová ve strhujícím tempu a se smyslem pro dramatičnost, až má čtenář pocit, že sleduje napínavý film. Zůstává jen otázka, zda se kra osudu nakonec přece jen rozpustí…","smallThumbnail":"http://books.google.com/books/content?id=2RsvDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api","thumbnail":"https://www.databazeknih.cz/images_books/32_/324332/big_hana-cqZ-324332.jpg","id":97}]

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.6.3
/*
  k-Nearest Neighbour library
  -------
  subject:  vantage point object - will consider each attribute present in this object as a feature
  objects:  array of objects that should all have at least the attributes of subject
  options:
      - k: (default = unlimited) specifies how many objects to return
      - standardize: (default = false) if true, will apply standardization across all attributes using stdvs - set this to true if your attributes do not have the same scale
      - weights: (default = {}) a hash describing the weights of each attribute
      - key: (default = none) a key function to map over objects, to be used if the subject attributes are nested within key
          e.g. if subject is {a:0} and objects are [{x: {a: 0}}, {x: {a: 2}}], then provide key: function(o) {return o.x}
      - filter: (default = none) a filter function that returns true for items to be considered
          e.g. to only consider objects with non-negative a: function(o) {return o.a >= 0})
*/


(function() {
  var stable, util;

  util = __webpack_require__(59);

  stable = __webpack_require__(60);

  module.exports = function(subject, objects, options) {
    var attr, distances, i, o, obj, object, objects_filtered, objects_mapped, sortMap, sortedObjects, stdv, weights, _i, _len;
    if (arguments.length < 2) {
      throw new Error('Expecting at least 2 arguments');
    }
    if (!(Array.prototype.slice.call(arguments).every(function(i) {
      return i && typeof i === 'object';
    }))) {
      throw new Error('Expecting object arguments');
    }
    if (!Array.isArray(arguments[1])) {
      throw new Error('Expecting an array as second argument');
    }
    objects_mapped = objects;
    objects_filtered = objects;
    if ((options != null ? options.filter : void 0) != null) {
      objects_filtered = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = objects.length; _i < _len; _i++) {
          obj = objects[_i];
          if (options.filter(obj)) {
            _results.push(obj);
          }
        }
        return _results;
      })();
    }
    objects_mapped = objects_filtered;
    if ((options != null ? options.key : void 0) != null) {
      objects_mapped = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = objects_filtered.length; _i < _len; _i++) {
          obj = objects_filtered[_i];
          _results.push(options.key(obj));
        }
        return _results;
      })();
    }
    if (!objects_mapped.length) {
      return [];
    }
    for (attr in subject) {
      for (_i = 0, _len = objects_mapped.length; _i < _len; _i++) {
        o = objects_mapped[_i];
        if (!(attr in o)) {
          throw new Error("Missing attribute '" + attr + "' in '" + (JSON.stringify(o)) + "'");
        }
      }
    }
    stdv = {};
    if ((options != null ? options.standardize : void 0) != null) {
      stdv = util.allStdvs(subject, objects_mapped);
    }
    weights = {};
    if (options != null ? options.weights : void 0) {
      weights = options.weights;
    }
    distances = (function() {
      var _j, _len1, _results;
      _results = [];
      for (i = _j = 0, _len1 = objects_mapped.length; _j < _len1; i = ++_j) {
        object = objects_mapped[i];
        _results.push({
          index: i,
          dist: util.distance(subject, object, {
            stdv: stdv,
            weights: weights
          })
        });
      }
      return _results;
    })();
    sortMap = stable(distances, function(a, b) {
      return a.dist - b.dist;
    });
    sortedObjects = (function() {
      var _j, _len1, _results;
      _results = [];
      for (_j = 0, _len1 = sortMap.length; _j < _len1; _j++) {
        i = sortMap[_j];
        _results.push(objects_filtered[i.index]);
      }
      return _results;
    })();
    if (options != null ? options.k : void 0) {
      return sortedObjects.slice(0, options.k);
    } else {
      return sortedObjects;
    }
  };

}).call(this);


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.6.3
/* 
  Euclidean distance function
  ----------
  Takes 2 objects, and returns squared Euclidean distance based on the first object's attributes
  e.g. p1 = {a: 1} and p2 = {a: 2, b: 3, c: 5} will ignore extra attributes on p2 and return 1
  All attributes on p1 MUST be present in p2 (otherwise will be inaccurate if ignored)
  Accepts optional third argument, which is an options hash: 
   - [stdv] defines the stdv for each attr
   - [weights] defines the weights for each attr (todo)
*/


(function() {
  var mean;

  exports.distance = function(p1, p2, opts) {
    var attr, dist, val, x, y;
    dist = 0;
    for (attr in p1) {
      val = p1[attr];
      x = val;
      y = p2[attr];
      if ((opts != null ? opts.stdv : void 0) && Object.getOwnPropertyNames(opts.stdv).length > 0 && opts.stdv[attr] !== 0) {
        x /= opts.stdv[attr];
        y /= opts.stdv[attr];
      }
      if ((opts != null ? opts.weights : void 0) && Object.getOwnPropertyNames(opts.weights).length > 0) {
        x *= opts.weights[attr];
        y *= opts.weights[attr];
      }
      dist += Math.pow(x - y, 2);
    }
    return dist;
  };

  /*
    Standard Deviation
    ----------
    Given an array of numbers, returns the stdv
    Given an array of objects, require key parameter identifying the attribute to calculate stdv for
  */


  exports.stdv = function(array, key) {
    var a, arr, m, ssqdiff, x, _i, _len;
    if (typeof array[0] !== 'number' && !key) {
      throw new Error('No key parameter provided');
    }
    arr = [];
    if (key) {
      arr = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = array.length; _i < _len; _i++) {
          a = array[_i];
          _results.push(a[key]);
        }
        return _results;
      })();
    } else {
      arr = array;
    }
    m = mean(arr);
    ssqdiff = 0;
    for (_i = 0, _len = arr.length; _i < _len; _i++) {
      x = arr[_i];
      ssqdiff += Math.pow(x - m, 2);
    }
    return Math.sqrt(ssqdiff / array.length);
  };

  /*
    Get all Standard Deviations
    ----------
    Given a subject and an array of objects, return an object describing each of subject's key's stdv on objects
  */


  exports.allStdvs = function(subject, objects) {
    var attr, objectsClone, stdvs;
    stdvs = {};
    objectsClone = objects.slice(0);
    objectsClone.push(subject);
    for (attr in subject) {
      stdvs[attr] = exports.stdv(objectsClone, attr);
    }
    return stdvs;
  };

  /*
    Standardize objects
    ---
    Takes an array of objects with numerical attributes, and returns object with standardized values,
    with units in measures of standard deviation from mean. (See www.econ.upf.edu/~michael/stanford/maeb4.pdf)
  */


  exports.standardize = function(array) {
    var m, s, x, _i, _len, _results;
    m = mean(array);
    s = exports.stdv(array);
    _results = [];
    for (_i = 0, _len = array.length; _i < _len; _i++) {
      x = array[_i];
      _results.push((x - m) / s);
    }
    return _results;
  };

  mean = function(array) {
    var sum;
    sum = array.reduce(function(a, b) {
      return a + b;
    });
    return sum / array.length;
  };

}).call(this);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

//! stable.js 0.1.8, https://github.com/Two-Screen/stable
//! © 2018 Angry Bytes and contributors. MIT licensed.

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.stable = factory());
}(this, (function () { 'use strict';

  // A stable array sort, because `Array#sort()` is not guaranteed stable.
  // This is an implementation of merge sort, without recursion.

  var stable = function (arr, comp) {
    return exec(arr.slice(), comp)
  };

  stable.inplace = function (arr, comp) {
    var result = exec(arr, comp);

    // This simply copies back if the result isn't in the original array,
    // which happens on an odd number of passes.
    if (result !== arr) {
      pass(result, null, arr.length, arr);
    }

    return arr
  };

  // Execute the sort using the input array and a second buffer as work space.
  // Returns one of those two, containing the final result.
  function exec(arr, comp) {
    if (typeof(comp) !== 'function') {
      comp = function (a, b) {
        return String(a).localeCompare(b)
      };
    }

    // Short-circuit when there's nothing to sort.
    var len = arr.length;
    if (len <= 1) {
      return arr
    }

    // Rather than dividing input, simply iterate chunks of 1, 2, 4, 8, etc.
    // Chunks are the size of the left or right hand in merge sort.
    // Stop when the left-hand covers all of the array.
    var buffer = new Array(len);
    for (var chk = 1; chk < len; chk *= 2) {
      pass(arr, comp, chk, buffer);

      var tmp = arr;
      arr = buffer;
      buffer = tmp;
    }

    return arr
  }

  // Run a single pass with the given chunk size.
  var pass = function (arr, comp, chk, result) {
    var len = arr.length;
    var i = 0;
    // Step size / double chunk size.
    var dbl = chk * 2;
    // Bounds of the left and right chunks.
    var l, r, e;
    // Iterators over the left and right chunk.
    var li, ri;

    // Iterate over pairs of chunks.
    for (l = 0; l < len; l += dbl) {
      r = l + chk;
      e = r + chk;
      if (r > len) r = len;
      if (e > len) e = len;

      // Iterate both chunks in parallel.
      li = l;
      ri = r;
      while (true) {
        // Compare the chunks.
        if (li < r && ri < e) {
          // This works for a regular `sort()` compatible comparator,
          // but also for a simple comparator like: `a > b`
          if (comp(arr[li], arr[ri]) <= 0) {
            result[i++] = arr[li++];
          }
          else {
            result[i++] = arr[ri++];
          }
        }
        // Nothing to compare, just flush what's left.
        else if (li < r) {
          result[i++] = arr[li++];
        }
        else if (ri < e) {
          result[i++] = arr[ri++];
        }
        // Both iterators are at the chunk ends.
        else {
          break
        }
      }
    }
  };

  return stable;

})));


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_simple_chatbot__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_simple_chatbot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_simple_chatbot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Message=function(_Component){_inherits(Message,_Component);function Message(props){_classCallCheck(this,Message);var _this=_possibleConstructorReturn(this,(Message.__proto__||Object.getPrototypeOf(Message)).call(this));var text=props.messages;_this.state={value:text[text.length-1],loading:!__WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__["b" /* isLocalhost */]};return _this;}_createClass(Message,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.setState({loading:false});_this2.props.triggerNextStep();},!__WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__["b" /* isLocalhost */]?this.state.value.length*70:0);}},{key:'render',value:function render(){var loading=this.state.loading;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_simple_chatbot__["Loading"],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.value);}}]);return Message;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Book=function(_Component){_inherits(Book,_Component);function Book(props){_classCallCheck(this,Book);var _this=_possibleConstructorReturn(this,(Book.__proto__||Object.getPrototypeOf(Book)).call(this));var books=props.books;_this.state={book:books[books.length-1]};return _this;}_createClass(Book,[{key:"render",value:function render(){var _state$book=this.state.book,thumbnail=_state$book.thumbnail,name=_state$book.name,author=_state$book.author,year=_state$book.year,description=_state$book.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"recommendation"},thumbnail&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img-wrapper"},year&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"year"},year),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{"class":"img",src:thumbnail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"headline"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"author"},author));}}]);return Book;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Book);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BookDescription=function(_Component){_inherits(BookDescription,_Component);function BookDescription(props){_classCallCheck(this,BookDescription);var _this=_possibleConstructorReturn(this,(BookDescription.__proto__||Object.getPrototypeOf(BookDescription)).call(this));var books=props.books;_this.state={book:books[books.length-1]};return _this;}_createClass(BookDescription,[{key:"render",value:function render(){var _state$book=this.state.book,description=_state$book.description,name=_state$book.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{"class":"name"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,description));}}]);return BookDescription;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BookDescription);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.effc7bcf.js